import { ColorLens } from "@mui/icons-material";

export const IconStore = ({
  className,
  width = "24",
  height = "24",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 7L6.41 2.59C6.59606 2.40283 6.81732 2.25434 7.06103 2.15308C7.30474 2.05182 7.56609 1.99979 7.83 2H16.17C16.4339 1.99979 16.6953 2.05182 16.939 2.15308C17.1827 2.25434 17.4039 2.40283 17.59 2.59L22 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 22V18C15 17.4696 14.7893 16.9609 14.4142 16.5858C14.0391 16.2107 13.5304 16 13 16H11C10.4696 16 9.96086 16.2107 9.58579 16.5858C9.21071 16.9609 9 17.4696 9 18V22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 7H22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 7V10C22 10.5304 21.7893 11.0391 21.4142 11.4142C21.0391 11.7893 20.5304 12 20 12C19.4157 11.9678 18.8577 11.7467 18.41 11.37C18.2907 11.2838 18.1472 11.2374 18 11.2374C17.8528 11.2374 17.7093 11.2838 17.59 11.37C17.1423 11.7467 16.5843 11.9678 16 12C15.4157 11.9678 14.8577 11.7467 14.41 11.37C14.2907 11.2838 14.1472 11.2374 14 11.2374C13.8528 11.2374 13.7093 11.2838 13.59 11.37C13.1423 11.7467 12.5843 11.9678 12 12C11.4157 11.9678 10.8577 11.7467 10.41 11.37C10.2907 11.2838 10.1472 11.2374 10 11.2374C9.85279 11.2374 9.70932 11.2838 9.59 11.37C9.14227 11.7467 8.58426 11.9678 8 12C7.41574 11.9678 6.85773 11.7467 6.41 11.37C6.29068 11.2838 6.14721 11.2374 6 11.2374C5.85279 11.2374 5.70932 11.2838 5.59 11.37C5.14227 11.7467 4.58426 11.9678 4 12C3.46957 12 2.96086 11.7893 2.58579 11.4142C2.21071 11.0391 2 10.5304 2 10V7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconChevronDown = ({
  className,
  width = "24",
  height = "24",
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9L12 15L18 9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconArrowDownToLine = ({
  className,
  width = "24",
  height = "24",
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 17V3"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 11L12 17L18 11"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 21H5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconBannerPattern = ({
  className,
  width = "570",
  height = "91",
  color = "#8B1516",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 570 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 88C49.5 50.5 160 -3.10003 306 56.5C452 116.1 540.833 45.3333 567 2.5"
        stroke={color}
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const IconUKFlag = ({ className, width = "28", height = "21" }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 28 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_331_3211"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="21"
      >
        <path d="M0 0H28V21H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_331_3211)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V21H28V0H0Z"
          fill="#41479B"
        />
        <mask
          id="mask1_331_3211"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="28"
          height="21"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V21H28V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_331_3211)">
          <mask
            id="mask2_331_3211"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="28"
            height="21"
          >
            <path d="M0 0H28V21H0V0Z" fill="white" />
          </mask>
          <g mask="url(#mask2_331_3211)">
            <path
              d="M-3.11774 19.4997L3.04374 22.1055L28.1398 2.83308L31.3898 -1.03922L24.8011 -1.91016L14.565 6.39488L6.32595 11.9906L-3.11774 19.4997Z"
              fill="white"
            />
            <path
              d="M-1.99982 20.565L1.09116 22L30.0002 -1H25.6601L-1.99982 20.565Z"
              fill="#FF4B55"
            />
            <path
              d="M31.1171 19.4997L24.9557 22.1055L-0.1404 2.83308L-3.39044 -1.03922L3.19838 -1.91016L13.4345 6.39488L21.6735 11.9906L31.1171 19.4997Z"
              fill="white"
            />
            <path
              d="M30.0002 20.5104L27.0072 22L15.0878 11.7778L11.5539 10.6357L-2.99982 -1H1.20264L15.7483 10.3595L19.6119 11.729L30.0002 20.5104Z"
              fill="#FF4B55"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.3047 -1.75H10.6936V7H-1.72675V14H10.6936V22.75H17.3047V14H29.7733V7H17.3047V-1.75Z"
              fill="#FF4B55"
            />
            <mask
              id="mask3_331_3211"
              maskUnits="userSpaceOnUse"
              x="-2"
              y="-2"
              width="32"
              height="25"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.306 -1.75H10.6949V7H-1.72546V14H10.6949V22.75H17.306V14H29.7746V7H17.306V-1.75Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_331_3211)">
              <path
                d="M10.6946 -1.75V-3.5H8.94462V-1.75H10.6946ZM17.3057 -1.75H19.0557V-3.5H17.3057V-1.75ZM10.6946 7V8.75H12.4446V7H10.6946ZM-1.72577 7V5.25H-3.47577V7H-1.72577ZM-1.72577 14H-3.47577V15.75H-1.72577V14ZM10.6946 14H12.4446V12.25H10.6946V14ZM10.6946 22.75H8.94462V24.5H10.6946V22.75ZM17.3057 22.75V24.5H19.0557V22.75H17.3057ZM17.3057 14V12.25H15.5557V14H17.3057ZM29.7743 14V15.75H31.5243V14H29.7743ZM29.7743 7H31.5243V5.25H29.7743V7ZM17.3057 7H15.5557V8.75H17.3057V7ZM10.6946 0H17.3057V-3.5H10.6946V0ZM12.4446 7V-1.75H8.94462V7H12.4446ZM-1.72577 8.75H10.6946V5.25H-1.72577V8.75ZM0.0242271 14V7H-3.47577V14H0.0242271ZM10.6946 12.25H-1.72577V15.75H10.6946V12.25ZM12.4446 22.75V14H8.94462V22.75H12.4446ZM17.3057 21H10.6946V24.5H17.3057V21ZM15.5557 14V22.75H19.0557V14H15.5557ZM29.7743 12.25H17.3057V15.75H29.7743V12.25ZM28.0243 7V14H31.5243V7H28.0243ZM17.3057 8.75H29.7743V5.25H17.3057V8.75ZM15.5557 -1.75V7H19.0557V-1.75H15.5557Z"
                fill="white"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const IconUSFlag = ({ className, width = "28", height = "21" }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 28 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_331_3250"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="21"
      >
        <path d="M0 0H28V21H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_331_3250)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H28V21H0V0Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 12.832V14.582H28V12.832H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 16.043V17.793H28V16.043H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6.41797V8.16797H28V6.41797H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 19.25V21H28V19.25H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 9.625V11.375H28V9.625H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V1.75H28V0H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3.20703V4.95703H28V3.20703H0Z"
          fill="#E31D1C"
        />
        <path d="M0 0H17.5V11.375H0V0Z" fill="#2E42A5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.50669 2.57022L0.871545 3.01549L1.08598 2.22308L0.521851 1.72091H1.25867L1.5058 1.07422L1.79557 1.72091H2.4237L1.93017 2.22308L2.12123 3.01549L1.50669 2.57022ZM5.00669 2.57022L4.37155 3.01549L4.58598 2.22308L4.02185 1.72091H4.75867L5.0058 1.07422L5.29557 1.72091H5.9237L5.43017 2.22308L5.62123 3.01549L5.00669 2.57022ZM7.87155 3.01549L8.50669 2.57022L9.12123 3.01549L8.93013 2.22308L9.42372 1.72091H8.79556L8.5058 1.07422L8.25867 1.72091H7.52185L8.08598 2.22308L7.87155 3.01549ZM12.0067 2.57022L11.3716 3.01549L11.586 2.22308L11.0218 1.72091H11.7587L12.0058 1.07422L12.2956 1.72091H12.9237L12.4301 2.22308L12.6212 3.01549L12.0067 2.57022ZM0.871545 6.51549L1.50669 6.07022L2.12123 6.51549L1.93017 5.72308L2.4237 5.22091H1.79557L1.5058 4.57422L1.25867 5.22091H0.521851L1.08598 5.72308L0.871545 6.51549ZM5.00669 6.07022L4.37155 6.51549L4.58598 5.72308L4.02185 5.22091H4.75867L5.0058 4.57422L5.29557 5.22091H5.9237L5.43017 5.72308L5.62123 6.51549L5.00669 6.07022ZM7.87155 6.51549L8.50669 6.07022L9.12123 6.51549L8.93013 5.72308L9.42372 5.22091H8.79556L8.5058 4.57422L8.25867 5.22091H7.52185L8.08598 5.72308L7.87155 6.51549ZM12.0067 6.07022L11.3716 6.51549L11.586 5.72308L11.0218 5.22091H11.7587L12.0058 4.57422L12.2956 5.22091H12.9237L12.4301 5.72308L12.6212 6.51549L12.0067 6.07022ZM0.871545 10.0155L1.50669 9.57021L2.12123 10.0155L1.93017 9.22309L2.4237 8.72091H1.79557L1.5058 8.07422L1.25867 8.72091H0.521851L1.08598 9.22309L0.871545 10.0155ZM5.00669 9.57021L4.37155 10.0155L4.58598 9.22309L4.02185 8.72091H4.75867L5.0058 8.07422L5.29557 8.72091H5.9237L5.43017 9.22309L5.62123 10.0155L5.00669 9.57021ZM7.87155 10.0155L8.50669 9.57021L9.12123 10.0155L8.93013 9.22309L9.42372 8.72091H8.79556L8.5058 8.07422L8.25867 8.72091H7.52185L8.08598 9.22309L7.87155 10.0155ZM12.0067 9.57021L11.3716 10.0155L11.586 9.22309L11.0218 8.72091H11.7587L12.0058 8.07422L12.2956 8.72091H12.9237L12.4301 9.22309L12.6212 10.0155L12.0067 9.57021ZM14.8716 3.01549L15.5067 2.57022L16.1212 3.01549L15.9301 2.22308L16.4237 1.72091H15.7956L15.5058 1.07422L15.2587 1.72091H14.5218L15.086 2.22308L14.8716 3.01549ZM15.5067 6.07022L14.8716 6.51549L15.086 5.72308L14.5218 5.22091H15.2587L15.5058 4.57422L15.7956 5.22091H16.4237L15.9301 5.72308L16.1212 6.51549L15.5067 6.07022ZM14.8716 10.0155L15.5067 9.57021L16.1212 10.0155L15.9301 9.22309L16.4237 8.72091H15.7956L15.5058 8.07422L15.2587 8.72091H14.5218L15.086 9.22309L14.8716 10.0155ZM3.25669 4.32022L2.62155 4.76549L2.83598 3.97308L2.27185 3.47091H3.00867L3.2558 2.82422L3.54557 3.47091H4.1737L3.68017 3.97308L3.87123 4.76549L3.25669 4.32022ZM6.12155 4.76549L6.75669 4.32022L7.37123 4.76549L7.18017 3.97308L7.6737 3.47091H7.04557L6.7558 2.82422L6.50867 3.47091H5.77185L6.33598 3.97308L6.12155 4.76549ZM10.2567 4.32022L9.62156 4.76549L9.83602 3.97308L9.27182 3.47091H10.0087L10.2558 2.82422L10.5456 3.47091H11.1737L10.6801 3.97308L10.8712 4.76549L10.2567 4.32022ZM2.62155 8.26549L3.25669 7.82022L3.87123 8.26549L3.68017 7.47308L4.1737 6.97091H3.54557L3.2558 6.32422L3.00867 6.97091H2.27185L2.83598 7.47308L2.62155 8.26549ZM6.75669 7.82022L6.12155 8.26549L6.33598 7.47308L5.77185 6.97091H6.50867L6.7558 6.32422L7.04557 6.97091H7.6737L7.18017 7.47308L7.37123 8.26549L6.75669 7.82022ZM9.62156 8.26549L10.2567 7.82022L10.8712 8.26549L10.6801 7.47308L11.1737 6.97091H10.5456L10.2558 6.32422L10.0087 6.97091H9.27182L9.83602 7.47308L9.62156 8.26549ZM13.7567 4.32022L13.1216 4.76549L13.336 3.97308L12.7718 3.47091H13.5087L13.7558 2.82422L14.0456 3.47091H14.6737L14.1801 3.97308L14.3712 4.76549L13.7567 4.32022ZM13.1216 8.26549L13.7567 7.82022L14.3712 8.26549L14.1801 7.47308L14.6737 6.97091H14.0456L13.7558 6.32422L13.5087 6.97091H12.7718L13.336 7.47308L13.1216 8.26549Z"
          fill="#F7FCFF"
        />
      </g>
    </svg>
  );
};

export const IconChinaFlag = ({ className, width = "28", height = "21" }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 28 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_331_3282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="21"
      >
        <path d="M0 0H28V21H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_331_3282)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H28V21H0V0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1383 3.98109L12.2545 4.51469L12.4561 3.47341L11.72 2.69412L12.7166 2.65198L13.1383 1.67969L13.56 2.65198H14.555L13.8206 3.47341L14.0417 4.51469L13.1383 3.98109Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.13995 8.40762L3.61921 9.7647L4.19417 7.11651L2.09503 5.1346L4.9374 5.02744L6.13995 2.55469L7.34249 5.02744H10.18L8.08571 7.11651L8.71623 9.7647L6.13995 8.40762Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8882 7.48109L14.0044 8.01469L14.206 6.97341L13.4699 6.19412L14.4665 6.15198L14.8882 5.17969L15.31 6.15198H16.3049L15.5705 6.97341L15.7917 8.01469L14.8882 7.48109Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0132 10.9811L13.1294 11.5147L13.331 10.4734L12.595 9.69408L13.5916 9.652L14.0132 8.67969L14.435 9.652H15.43L14.6956 10.4734L14.9167 11.5147L14.0132 10.9811Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3884 13.6061L10.5045 14.1397L10.7061 13.0984L9.97009 12.3191L10.9667 12.277L11.3884 11.3047L11.8101 12.277H12.8051L12.0707 13.0984L12.2918 14.1397L11.3884 13.6061Z"
          fill="#FECA00"
        />
      </g>
    </svg>
  );
};

export const IconMexicoFlag = ({ className, width = "28", height = "21" }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 28 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_331_3310"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="21"
      >
        <path d="M0 0H28V21H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_331_3310)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.25 0H28V21H19.25V0Z"
          fill="#D9071E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H10.5V21H0V0Z"
          fill="#006923"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75 0H19.25V21H8.75V0Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4228 7.30003C11.3298 7.69829 11.3903 7.7923 11.84 7.7923C11.8634 7.7923 11.9005 7.8583 11.9407 7.9301C11.9849 8.00887 12.0331 8.09461 12.0714 8.10786C12.055 8.12959 11.884 8.43858 11.8831 8.98289C11.8831 9.09497 11.9351 9.2796 11.9853 9.45705C12.0397 9.64999 12.0917 9.83426 12.0714 9.90715C12.0382 10.0257 11.8895 9.89647 11.7744 9.79637C11.7085 9.73915 11.6536 9.69137 11.6374 9.70494C11.5552 9.77415 11.5128 9.22622 11.4871 8.89521C11.4757 8.74782 11.4676 8.64341 11.4608 8.6556C11.4321 8.59229 11.4204 8.51452 11.4088 8.43767C11.3836 8.27057 11.3591 8.10786 11.1619 8.10786H10.6543V8.48157C10.6543 8.48157 10.948 8.48157 10.948 9.17679C10.9528 9.28074 11.09 10.1949 11.4228 10.1997C11.2278 10.204 11.2292 10.243 11.23 10.2658L11.2301 10.2698C11.2301 10.8291 11.6976 10.8896 12.1344 10.7317C12.3969 10.6368 12.6757 10.4516 12.8844 10.2233C13.1789 9.90102 13.2153 9.48382 12.8286 9.2551C12.6909 9.17364 12.5415 9.14222 12.3325 9.13059C12.3738 9.00791 12.3347 8.89845 12.3042 8.81296C12.2787 8.74152 12.2592 8.68692 12.2978 8.6556C12.7358 8.30033 12.7749 7.97289 12.4562 7.67917C12.4148 7.64107 12.3748 7.58941 12.3336 7.53624C12.256 7.436 12.1742 7.33038 12.0714 7.30003C12.1189 7.2042 12.1828 7.08808 12.2632 6.95433L11.513 6.50391C11.377 6.73042 11.3997 6.90758 11.4196 7.06197C11.4304 7.14672 11.4404 7.2246 11.4228 7.30003ZM12.2386 9.63292L12.225 9.64745L12.2342 9.63914C12.2357 9.6366 12.2371 9.6345 12.2386 9.63292ZM11.8417 9.90715C11.8414 9.90724 11.8419 9.90706 11.8429 9.90689L11.8515 9.90522C11.8481 9.90575 11.8447 9.90645 11.8429 9.90689L11.8417 9.90715ZM11.4608 10.1992C11.4505 10.1992 11.4407 10.1993 11.4314 10.1995L11.4475 10.1991L11.4608 10.1992Z"
          fill="#A8AC71"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5855 6.92578C12.5855 6.92578 11.9846 7.39186 12.097 7.88875C12.2094 8.38565 13.3937 7.88875 13.2505 7.40727C13.1074 6.92578 12.5855 6.92578 12.5855 6.92578Z"
          fill="#FCCA3D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8585 10.8509C16.8585 10.8509 17.6679 8.45217 16.3814 7.21051C15.0948 5.96885 13.6081 6.05194 13.6081 6.05194C13.6081 6.05194 13.18 6.37004 13.6081 6.61264C14.0362 6.85524 13.8569 7.08785 13.8569 7.08785C13.8569 7.08785 13.1398 6.35982 12.6639 6.78516C12.1879 7.21051 13.1082 7.14578 13.0107 7.46604C12.9133 7.78631 12.5006 9.20821 13.1037 9.92615C13.7068 10.644 12.5335 10.4883 12.7721 10.4883C13.0107 10.4883 13.8569 10.6553 13.8569 10.4883C13.8569 10.3211 14.1509 11.1379 14.4027 11.1379C14.6544 11.1379 14.8488 10.8509 14.8488 10.8509C14.8488 10.8509 15.2016 11.1379 15.4166 11.1379C15.6316 11.1379 16.3814 10.9501 16.3814 10.9501L14.9643 9.75605C14.9643 9.75605 15.0497 9.22947 14.8488 9.11546C14.6477 9.00145 16.4602 10.1256 16.6023 10.4883C16.7442 10.8509 16.8585 10.8509 16.8585 10.8509Z"
          fill="#8F4620"
        />
        <path
          d="M9.68262 10.2623C9.68262 10.2623 9.81404 9.84351 9.95466 9.81446C10.0765 9.78926 10.3327 10.0151 10.3327 10.0151C10.788 12.5438 11.8887 13.5314 13.7151 13.5314C15.5629 13.5314 16.6828 12.7809 17.3363 10.4488C17.3363 10.4488 17.6838 10.094 17.8064 10.1335C17.9398 10.1764 18.107 10.6458 18.107 10.6458C17.3573 13.3212 15.9407 14.5124 13.7151 14.5124C11.4679 14.5124 10.2053 13.1657 9.68262 10.2623Z"
          fill="#9FAB2F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6666 11.9492C11.6666 11.9492 14.2954 12.5069 15.333 12.5069C16.3706 12.5069 14.4226 13.3537 13.6625 13.3537C13.33 13.3537 12.9293 13.1522 12.4603 12.7491C12.3762 12.6768 12.4576 12.5151 12.2015 12.5129C11.8444 12.5098 11.4008 12.4261 11.4433 12.375C11.4836 12.3264 12.0032 12.3118 11.9531 12.2587C11.8705 12.1712 11.6666 11.9492 11.6666 11.9492Z"
          fill="#2FC2DC"
        />
        <path
          d="M14.4382 12.3359H12.9798C12.8993 12.3359 12.834 12.4012 12.834 12.4818V13.1276C12.834 13.2081 12.8993 13.2734 12.9798 13.2734H14.4382C14.5187 13.2734 14.584 13.2081 14.584 13.1276V12.4818C14.584 12.4012 14.5187 12.3359 14.4382 12.3359Z"
          fill="#F9AA51"
        />
        <path
          d="M10.6533 10.6187C10.6533 10.6187 10.6533 10.2906 10.8756 10.1162C11.1303 9.91632 11.3696 10.1162 11.3696 10.1162C12.3019 11.4449 13.696 11.8821 15.6459 11.4259C15.6459 11.4259 16.2289 11.6164 16.2582 11.7416C16.2953 11.9004 15.8452 12.2779 15.8452 12.2779C13.5658 12.8112 11.8039 12.2587 10.6533 10.6187Z"
          fill="#259485"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5175 10.8047C14.5175 10.8047 13.4555 11.3637 13.8096 11.3637C14.1635 11.3637 15.5489 11.6432 15.2793 11.3637C15.0097 11.0843 14.5175 10.8047 14.5175 10.8047Z"
          fill="#FCCA3D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2617 10.1375C13.2617 10.1375 13.0599 9.55469 12.64 9.55469C12.2201 9.55469 12.3386 10.0328 12.1367 10.0328C11.9347 10.0328 12.3248 10.3692 12.4987 10.3692C12.6725 10.3692 13.2617 10.1375 13.2617 10.1375Z"
          fill="#FCCA3D"
        />
      </g>
    </svg>
  );
};

export const IconPhone = ({
  className,
  width = "24",
  height = "24",
  color = "#7D7D7D",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 4.5C1.5 3.70435 1.81607 2.94129 2.37868 2.37868C2.94129 1.81607 3.70435 1.5 4.5 1.5H5.872C6.732 1.5 7.482 2.086 7.691 2.92L8.796 7.343C8.88554 7.701 8.86746 8.07746 8.74401 8.42522C8.62055 8.77299 8.39723 9.07659 8.102 9.298L6.809 10.268C6.674 10.369 6.645 10.517 6.683 10.62C7.24738 12.1549 8.1386 13.5487 9.29495 14.7051C10.4513 15.8614 11.8451 16.7526 13.38 17.317C13.483 17.355 13.63 17.326 13.732 17.191L14.702 15.898C14.9234 15.6028 15.227 15.3794 15.5748 15.256C15.9225 15.1325 16.299 15.1145 16.657 15.204L21.08 16.309C21.914 16.518 22.5 17.268 22.5 18.129V19.5C22.5 20.2956 22.1839 21.0587 21.6213 21.6213C21.0587 22.1839 20.2956 22.5 19.5 22.5H17.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
        fill={color}
      />
    </svg>
  );
};

export const IconEmail = ({
  className,
  width = "24",
  height = "24",
  color = "#7D7D7D",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L13.06 12.34C12.41 12.75 11.59 12.75 10.94 12.34L4.4 8.25C4.29973 8.19371 4.21192 8.11766 4.14189 8.02645C4.07186 7.93525 4.02106 7.83078 3.99258 7.71937C3.96409 7.60796 3.9585 7.49194 3.97616 7.37831C3.99381 7.26468 4.03434 7.15581 4.09528 7.0583C4.15623 6.96079 4.23632 6.87666 4.33073 6.811C4.42513 6.74533 4.53187 6.69951 4.6445 6.6763C4.75712 6.65309 4.87328 6.65297 4.98595 6.67595C5.09863 6.69893 5.20546 6.74453 5.3 6.81L12 11L18.7 6.81C18.7945 6.74453 18.9014 6.69893 19.014 6.67595C19.1267 6.65297 19.2429 6.65309 19.3555 6.6763C19.4681 6.69951 19.5749 6.74533 19.6693 6.811C19.7637 6.87666 19.8438 6.96079 19.9047 7.0583C19.9657 7.15581 20.0062 7.26468 20.0238 7.37831C20.0415 7.49194 20.0359 7.60796 20.0074 7.71937C19.9789 7.83078 19.9281 7.93525 19.8581 8.02645C19.7881 8.11766 19.7003 8.19371 19.6 8.25Z"
        fill={color}
      />
    </svg>
  );
};

export const IconLocation = ({
  className,
  width = "24",
  height = "24",
  color = "#7D7D7D",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2901 16.1463L12.2835 22L6.27679 16.1463C5.18123 15.091 4.44457 13.8392 4.06679 12.3912C3.68901 10.9922 3.68901 9.59319 4.06679 8.1942C4.44457 6.74613 5.17808 5.49133 6.26734 4.42982C7.3566 3.36831 8.6442 2.64734 10.1301 2.26691C11.5657 1.91103 13.0012 1.91103 14.4368 2.26691C15.9227 2.64734 17.2103 3.36831 18.2996 4.42982C19.3888 5.49133 20.1223 6.74613 20.5001 8.1942C20.8779 9.59319 20.8779 10.9922 20.5001 12.3912C20.1223 13.8392 19.3857 15.091 18.2901 16.1463ZM12.2835 12.1335C12.6235 12.1335 12.9383 12.0506 13.2279 11.885C13.5175 11.7193 13.7473 11.4953 13.9173 11.2131C14.0873 10.9308 14.1723 10.624 14.1723 10.2927C14.1723 9.96134 14.0873 9.65455 13.9173 9.3723C13.7473 9.09004 13.5175 8.86608 13.2279 8.70041C12.9383 8.53475 12.6235 8.45191 12.2835 8.45191C11.9435 8.45191 11.6286 8.53475 11.339 8.70041C11.0494 8.86608 10.8196 9.09004 10.6496 9.3723C10.4796 9.65455 10.3946 9.96134 10.3946 10.2927C10.3946 10.624 10.4796 10.9308 10.6496 11.2131C10.8196 11.4953 11.0494 11.7193 11.339 11.885C11.6286 12.0506 11.9435 12.1335 12.2835 12.1335Z"
        fill={color}
      />
    </svg>
  );
};

export const IconArrowDownSquare = ({
  className,
  width = "18",
  height = "19",
  color = "#0A142F",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.488281" width="18" height="18.0247" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.20586 7.49609C5.76058 7.49609 5.53742 8.03432 5.85206 8.3494L8.29228 10.793C8.68292 11.1842 9.31684 11.1842 9.70747 10.793L12.1477 8.3494C12.4623 8.03432 12.2392 7.49609 11.7939 7.49609H6.20586Z"
        fill={color}
      />
    </svg>
  );
};

export const IconThreeWavesToRight = ({
  className,
  width = "39",
  height = "42",
  color = "#8B1516",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 39 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5.5091"
        y="22.3711"
        width="20"
        height="4"
        rx="2"
        transform="rotate(-62.3477 5.5091 22.3711)"
        fill={color}
      />
      <rect
        x="13.8748"
        y="27.9492"
        width="20"
        height="4"
        rx="2"
        transform="rotate(-50.9604 13.8748 27.9492)"
        fill={color}
      />
      <rect
        x="18.3976"
        y="35.4062"
        width="20"
        height="4"
        rx="2"
        transform="rotate(-32.0499 18.3976 35.4062)"
        fill={color}
      />
    </svg>
  );
};

export const IconThreeWavesToLeft = ({
  className,
  width = "29",
  height = "38",
  color = "#8B1516",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 29 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="17.054"
        height="3.58991"
        rx="1.79495"
        transform="matrix(-0.421504 -0.906826 -0.737841 0.674974 24.9559 17.8867)"
        fill={color}
      />
      <rect
        width="16.012"
        height="3.77699"
        rx="1.88849"
        transform="matrix(-0.603404 -0.797435 -0.612337 0.790597 18.7151 24.7617)"
        fill={color}
      />
      <rect
        width="14.7826"
        height="3.9724"
        rx="1.9862"
        transform="matrix(-0.871834 -0.489801 -0.393138 0.919479 15.39 32.7695)"
        fill={color}
      />
    </svg>
  );
};

export const IconCurrentLocation = ({
  className,
  width = "32",
  height = "32",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_331_3071)">
        <circle cx="16" cy="16" r="16" fill="#8B1516" fillOpacity="0.23" />
      </g>
      <g filter="url(#filter1_b_331_3071)">
        <circle cx="16" cy="16.0002" r="15.84" fill="#AB7879" />
      </g>
      <circle
        cx="16.33"
        cy="16.3291"
        r="7.04"
        fill="#8B1516"
        stroke="#F6F6F6"
        strokeWidth="1.5"
      />
      <defs>
        <filter
          id="filter0_b_331_3071"
          x="-10"
          y="-10"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_331_3071"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_331_3071"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_b_331_3071"
          x="-3.84"
          y="-3.83984"
          width="51.68"
          height="51.6797"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_331_3071"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_331_3071"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const IconCurrentLocationGray = ({
  className,
  width = "32",
  height = "32",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_331_3112)">
        <circle cx="16" cy="16" r="16" fill="#2C2C2C" fillOpacity="0.23" />
      </g>
      <g filter="url(#filter1_b_331_3112)">
        <circle cx="16" cy="16.0002" r="15.84" fill="#848484" />
      </g>
      <circle
        cx="16.33"
        cy="16.3291"
        r="7.04"
        fill="black"
        stroke="#F6F6F6"
        strokeWidth="1.5"
      />
      <defs>
        <filter
          id="filter0_b_331_3112"
          x="-10"
          y="-10"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_331_3112"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_331_3112"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_b_331_3112"
          x="-3.84003"
          y="-3.83984"
          width="51.68"
          height="51.6797"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_331_3112"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_331_3112"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const IconScrollToTop = ({
  className,
  width = "40",
  height = "41",
  color = "#0081FE",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="20" cy="20.0275" rx="20" ry="20.0275" fill={color} />
      <path
        d="M14 23.0312L20 17.023L26 23.0312"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconRectangleLine = ({
  className,
  width = "40",
  height = "5",
  color = "#8B1516",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="5" rx="2.5" fill={color} />
    </svg>
  );
};

export const IconSystemOptions = ({
  className,
  width = "48",
  height = "48",
  bgColor = "#56D9B9",
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={width} height={height} rx="10" fill={bgColor} />
      <path
        d="M18.0944 23.2288C18.0322 22.8282 18 22.4179 18 22C18 17.5817 21.6052 14 26.0526 14C30.4999 14 34.1052 17.5817 34.1052 22C34.1052 22.9981 33.9213 23.9535 33.5852 24.8345C33.5154 25.0175 33.4804 25.109 33.4646 25.1804C33.4489 25.2512 33.4428 25.301 33.4411 25.3735C33.4394 25.4466 33.4493 25.5272 33.4692 25.6883L33.8717 28.9585C33.9153 29.3125 33.9371 29.4895 33.8782 29.6182C33.8266 29.731 33.735 29.8205 33.6211 29.8695C33.4911 29.9254 33.3146 29.8995 32.9617 29.8478L29.7765 29.3809C29.6101 29.3565 29.527 29.3443 29.4512 29.3448C29.3763 29.3452 29.3245 29.3507 29.2511 29.3661C29.177 29.3817 29.0823 29.4172 28.893 29.4881C28.0097 29.819 27.0524 30 26.0526 30C25.6344 30 25.2237 29.9683 24.8227 29.9073M19.6316 34C22.5965 34 25 31.5376 25 28.5C25 25.4624 22.5965 23 19.6316 23C16.6667 23 14.2632 25.4624 14.2632 28.5C14.2632 29.1106 14.3603 29.6979 14.5395 30.2467C14.6153 30.4787 14.6532 30.5947 14.6657 30.6739C14.6786 30.7567 14.6809 30.8031 14.6761 30.8867C14.6714 30.9668 14.6514 31.0573 14.6113 31.2383L14 34L16.9948 33.591C17.1583 33.5687 17.24 33.5575 17.3114 33.558C17.3865 33.5585 17.4264 33.5626 17.5001 33.5773C17.5701 33.5912 17.6742 33.6279 17.8823 33.7014C18.4306 33.8949 19.0191 34 19.6316 34Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconMonitoringOptions = ({
  className,
  width = "49",
  height = "48",
  color = "white",
  bgColor = "#56D9B9",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="48" height="48" rx="10" fill={bgColor} />
      <path
        d="M25.5 14L16.5935 24.6879C16.2446 25.1064 16.0702 25.3157 16.0676 25.4925C16.0653 25.6461 16.1337 25.7923 16.2533 25.8889C16.3907 26 16.6632 26 17.208 26H24.5L23.5 34L32.4065 23.3121C32.7554 22.8936 32.9298 22.6843 32.9324 22.5075C32.9347 22.3539 32.8663 22.2077 32.7467 22.1111C32.6093 22 32.3368 22 31.792 22H24.5L25.5 14Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconRateStar = ({
  className,
  width = "17",
  height = "16",
  color = "#FFAC33",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0371 16C12.847 16 12.6578 15.939 12.495 15.8175L8.66675 12.9478L4.83853 15.8175C4.67992 15.9368 4.48931 16.0006 4.29392 15.9999C4.09853 15.9992 3.90835 15.934 3.75054 15.8136C3.59257 15.6938 3.47475 15.5251 3.41384 15.3313C3.35292 15.1376 3.35201 14.9287 3.41124 14.7343L4.839 9.91764L1.04513 7.12315C0.887902 7.00185 0.771132 6.83195 0.711342 6.63749C0.651552 6.44302 0.651767 6.23382 0.711958 6.03949C0.772624 5.84562 0.89004 5.67659 1.04761 5.55628C1.20519 5.43597 1.39495 5.37047 1.59007 5.36903L6.28888 5.36165L7.78487 0.66448C7.84661 0.470978 7.96502 0.302683 8.12334 0.183427C8.28165 0.0641718 8.47185 0 8.66699 0C8.86213 0 9.05233 0.0641718 9.21064 0.183427C9.36896 0.302683 9.48737 0.470978 9.5491 0.66448L11.0197 5.36165L15.7425 5.36903C15.9379 5.37018 16.1279 5.43565 16.2856 5.55614C16.4434 5.67663 16.5608 5.84601 16.6211 6.04022C16.6815 6.23444 16.6818 6.4436 16.622 6.638C16.5622 6.8324 16.4453 7.00215 16.2879 7.12315L12.494 9.91764L13.9218 14.7343C13.9811 14.9286 13.9803 15.1375 13.9195 15.3313C13.8587 15.5251 13.7409 15.6938 13.583 15.8136C13.4247 15.9349 13.2334 16.0003 13.0371 16Z"
        fill={color}
      />
    </svg>
  );
};

export const IconStarFilled = ({
  className,
  width = "48",
  height = "48",
  color = "white",
  bgColor = "#56D9B9",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="10" fill={bgColor} />
      <path
        d="M21.153 17.408C22.42 15.136 23.053 14 24 14C24.947 14 25.58 15.136 26.847 17.408L27.175 17.996C27.535 18.642 27.715 18.965 27.995 19.178C28.275 19.391 28.625 19.47 29.325 19.628L29.961 19.772C32.421 20.329 33.65 20.607 33.943 21.548C34.235 22.488 33.397 23.469 31.72 25.43L31.286 25.937C30.81 26.494 30.571 26.773 30.464 27.117C30.357 27.462 30.393 27.834 30.465 28.577L30.531 29.254C30.784 31.871 30.911 33.179 30.145 33.76C29.379 34.342 28.227 33.811 25.925 32.751L25.328 32.477C24.674 32.175 24.347 32.025 24 32.025C23.653 32.025 23.326 32.175 22.672 32.477L22.076 32.751C19.773 33.811 18.621 34.341 17.856 33.761C17.089 33.179 17.216 31.871 17.469 29.254L17.535 28.578C17.607 27.834 17.643 27.462 17.535 27.118C17.429 26.773 17.19 26.494 16.714 25.938L16.28 25.43C14.603 23.47 13.765 22.489 14.057 21.548C14.35 20.607 15.58 20.328 18.04 19.772L18.676 19.628C19.375 19.47 19.724 19.391 20.005 19.178C20.285 18.965 20.465 18.642 20.825 17.996L21.153 17.408Z"
        fill={color}
      />
    </svg>
  );
};

export const IconPrecisionFilled = ({
  className,
  width = "48",
  height = "48",
  color = "white",
  bgColor = "#56D9B9",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="10" fill={bgColor} />
      <path
        d="M24 18V20M24 28V30M20 24H18M30 24H28M24 34C29.523 34 34 29.523 34 24C34 18.477 29.523 14 24 14C18.477 14 14 18.477 14 24C14 29.523 18.477 34 24 34Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconDoubleTickFilled = ({
  className,
  width = "48",
  height = "48",
  color = "white",
  bgColor = "#56D9B9",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="10" fill={bgColor} />
      <path
        d="M17.9999 30.1825L13.0416 25.2241C12.8083 24.9908 12.6963 24.7186 12.7056 24.4075C12.7149 24.0964 12.8367 23.8241 13.0708 23.5908C13.3041 23.3769 13.5763 23.2649 13.8874 23.2548C14.1986 23.2447 14.4708 23.3567 14.7041 23.5908L18.8458 27.7325L20.4791 29.3658L19.6333 30.1825C19.4 30.3964 19.1277 30.5084 18.8166 30.5185C18.5055 30.5286 18.2333 30.4166 17.9999 30.1825ZM24.5916 30.1825L19.6333 25.2241C19.4194 25.0102 19.3124 24.7431 19.3124 24.4226C19.3124 24.1022 19.4194 23.8249 19.6333 23.5908C19.8666 23.3575 20.1439 23.2408 20.4651 23.2408C20.7863 23.2408 21.0632 23.3575 21.2958 23.5908L25.4083 27.7033L35.3249 17.7866C35.5583 17.5533 35.8305 17.4417 36.1416 17.4518C36.4527 17.4619 36.7249 17.5832 36.9583 17.8158C37.1722 18.0491 37.2842 18.3214 37.2943 18.6325C37.3044 18.9436 37.1924 19.2158 36.9583 19.4491L26.2249 30.1825C25.9916 30.4158 25.7194 30.5325 25.4083 30.5325C25.0972 30.5325 24.8249 30.4158 24.5916 30.1825ZM25.4083 24.4075L23.7458 22.7741L28.7041 17.8158C28.918 17.6019 29.1856 17.495 29.5068 17.495C29.828 17.495 30.1049 17.6019 30.3375 17.8158C30.5708 18.0491 30.6875 18.3264 30.6875 18.6476C30.6875 18.9689 30.5708 19.2457 30.3375 19.4783L25.4083 24.4075Z"
        fill={color}
      />
    </svg>
  );
};

export const IconWavedLampFilled = ({
  className,
  width = "48",
  height = "48",
  color = "white",
  bgColor = "#56D9B9",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="10" fill={bgColor} />
      <path
        d="M16.0001 23C16.255 23.0003 16.5001 23.0979 16.6855 23.2728C16.8708 23.4478 16.9823 23.687 16.9973 23.9414C17.0122 24.1958 16.9294 24.4464 16.7658 24.6418C16.6023 24.8373 16.3702 24.9629 16.1171 24.993L16.0001 25H15.0001C14.7452 24.9997 14.5001 24.9021 14.3147 24.7272C14.1294 24.5522 14.0179 24.313 14.0029 24.0586C13.988 23.8042 14.0708 23.5536 14.2344 23.3582C14.398 23.1627 14.63 23.0371 14.8831 23.007L15.0001 23H16.0001ZM24.0001 14C24.245 14 24.4815 14.09 24.6645 14.2527C24.8475 14.4155 24.9645 14.6397 24.9931 14.883L25.0001 15V16C24.9998 16.2549 24.9022 16.5 24.7273 16.6854C24.5523 16.8707 24.3132 16.9822 24.0587 16.9972C23.8043 17.0121 23.5537 16.9293 23.3583 16.7657C23.1628 16.6021 23.0372 16.3701 23.0071 16.117L23.0001 16V15C23.0001 14.7348 23.1055 14.4804 23.293 14.2929C23.4805 14.1054 23.7349 14 24.0001 14ZM33.0001 23C33.255 23.0003 33.5001 23.0979 33.6855 23.2728C33.8708 23.4478 33.9823 23.687 33.9973 23.9414C34.0122 24.1958 33.9294 24.4464 33.7658 24.6418C33.6023 24.8373 33.3702 24.9629 33.1171 24.993L33.0001 25H32.0001C31.7452 24.9997 31.5001 24.9021 31.3147 24.7272C31.1294 24.5522 31.0179 24.313 31.0029 24.0586C30.988 23.8042 31.0708 23.5536 31.2344 23.3582C31.398 23.1627 31.63 23.0371 31.8831 23.007L32.0001 23H33.0001ZM16.8931 16.893C17.0653 16.7208 17.2944 16.6174 17.5374 16.6021C17.7805 16.5868 18.0207 16.6607 18.2131 16.81L18.3071 16.893L19.0071 17.593C19.1865 17.773 19.2906 18.0144 19.2983 18.2684C19.3061 18.5223 19.2169 18.7697 19.0489 18.9603C18.8808 19.1508 18.6466 19.2703 18.3936 19.2944C18.1407 19.3185 17.8881 19.2454 17.6871 19.09L17.5931 19.007L16.8931 18.307C16.7056 18.1195 16.6003 17.8652 16.6003 17.6C16.6003 17.3348 16.7056 17.0805 16.8931 16.893ZM29.6931 16.893C29.8731 16.7137 30.1145 16.6095 30.3685 16.6018C30.6224 16.594 30.8698 16.6832 31.0604 16.8512C31.251 17.0193 31.3704 17.2536 31.3945 17.5065C31.4186 17.7594 31.3455 18.012 31.1901 18.213L31.1071 18.307L30.4071 19.007C30.2272 19.1863 29.9857 19.2905 29.7317 19.2982C29.4778 19.306 29.2304 19.2168 29.0398 19.0488C28.8493 18.8807 28.7298 18.6464 28.7057 18.3935C28.6816 18.1406 28.7547 17.888 28.9101 17.687L28.9931 17.593L29.6931 16.893ZM26.0001 30C26.2653 30 26.5197 30.1054 26.7072 30.2929C26.8948 30.4804 27.0001 30.7348 27.0001 31C27.0001 31.7956 26.684 32.5587 26.1214 33.1213C25.5588 33.6839 24.7958 34 24.0001 34C23.2045 34 22.4414 33.6839 21.8788 33.1213C21.3162 32.5587 21.0001 31.7956 21.0001 31C21.0001 30.7551 21.0901 30.5187 21.2528 30.3356C21.4156 30.1526 21.6399 30.0357 21.8831 30.007L22.0001 30H26.0001ZM24.0001 18C25.2594 18 26.4868 18.3962 27.5084 19.1325C28.53 19.8689 29.294 20.908 29.6922 22.1026C30.0904 23.2973 30.1027 24.587 29.7272 25.789C29.3517 26.991 28.6075 28.0444 27.6001 28.8C27.4623 28.9035 27.3 28.9697 27.1291 28.992L27.0001 29H21.0001C20.7837 29 20.5732 28.9298 20.4001 28.8C19.3927 28.0444 18.6485 26.991 18.273 25.789C17.8976 24.587 17.9098 23.2973 18.308 22.1026C18.7062 20.908 19.4703 19.8689 20.4919 19.1325C21.5134 18.3962 22.7408 18 24.0001 18Z"
        fill={color}
      />
    </svg>
  );
};

export const IconDiamondFilled = ({
  className,
  width = "48",
  height = "48",
  color = "white",
  bgColor = "#56D9B9",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="10" fill={bgColor} />
      <path
        d="M21.375 32.3992C21.4069 32.4276 21.4472 32.4448 21.4897 32.4482C21.5323 32.4516 21.5748 32.441 21.6108 32.4181C21.6468 32.3951 21.6743 32.361 21.6891 32.3209C21.704 32.2809 21.7053 32.2371 21.693 32.1962L19.173 23.5582C19.1501 23.4796 19.1038 23.4099 19.0401 23.3584C18.9765 23.3069 18.8986 23.2762 18.817 23.2702C18.409 23.2402 18.002 23.2072 17.595 23.1702L14.225 22.8632C14.1893 22.8598 14.1534 22.866 14.1211 22.8813C14.0887 22.8966 14.0611 22.9204 14.0412 22.9502C14.0213 22.9799 14.0099 23.0145 14.0081 23.0503C14.0063 23.086 14.0142 23.1216 14.031 23.1532C15.854 26.5632 18.479 29.8132 21.375 32.3992ZM23.847 34.2252C23.867 34.2952 23.927 34.3472 24 34.3472C24.0352 34.3462 24.0692 34.3337 24.0968 34.3117C24.1244 34.2897 24.1441 34.2594 24.153 34.2252L27.237 23.6522C27.2462 23.6215 27.2478 23.5891 27.2418 23.5576C27.2358 23.5261 27.2224 23.4965 27.2026 23.4714C27.1828 23.4462 27.1572 23.4261 27.1281 23.4129C27.0989 23.3996 27.067 23.3936 27.035 23.3952C25.0126 23.482 22.9874 23.482 20.965 23.3952C20.9331 23.3936 20.9013 23.3997 20.8722 23.4129C20.8432 23.4261 20.8177 23.446 20.7979 23.4711C20.7781 23.4961 20.7646 23.5256 20.7586 23.5569C20.7525 23.5882 20.754 23.6206 20.763 23.6512L23.847 34.2252ZM26.307 32.1962C26.251 32.3862 26.477 32.5312 26.625 32.3992C29.521 29.8122 32.146 26.5632 33.969 23.1532C33.9857 23.1217 33.9936 23.0862 33.9918 23.0506C33.9901 23.0149 33.9787 22.9804 33.9589 22.9507C33.9391 22.921 33.9117 22.8972 33.8795 22.8818C33.8473 22.8664 33.8115 22.86 33.776 22.8632L30.406 23.1702C29.998 23.2072 29.591 23.2402 29.183 23.2702C29.1013 23.2762 29.0235 23.3069 28.9598 23.3584C28.8962 23.4099 28.8498 23.4796 28.827 23.5582L26.307 32.1962ZM33.801 21.3552C33.8358 21.3522 33.8693 21.34 33.898 21.32C33.9267 21.2999 33.9496 21.2727 33.9645 21.241C33.9794 21.2093 33.9857 21.1743 33.9828 21.1394C33.9799 21.1045 33.9679 21.071 33.948 21.0422L30.71 16.3472C30.572 16.1473 30.3875 15.9838 30.1724 15.871C29.9572 15.7581 29.7179 15.6991 29.475 15.6992H26.985C26.9521 15.6992 26.9198 15.7073 26.8908 15.7228C26.8618 15.7382 26.8371 15.7606 26.8188 15.7879C26.8006 15.8151 26.7893 15.8465 26.786 15.8792C26.7827 15.9119 26.7875 15.9448 26.8 15.9752L29.057 21.4982C29.089 21.5763 29.145 21.6423 29.2169 21.6867C29.2887 21.7311 29.3728 21.7515 29.457 21.7452C29.727 21.7242 29.999 21.7012 30.27 21.6752L33.801 21.3552ZM25.165 15.9452C25.1345 15.8722 25.0831 15.8099 25.0173 15.7661C24.9514 15.7223 24.8741 15.6991 24.795 15.6992H23.205C23.1259 15.6991 23.0485 15.7223 22.9827 15.7661C22.9168 15.8099 22.8654 15.8722 22.835 15.9452L20.477 21.6032C20.4648 21.6328 20.4598 21.6649 20.4626 21.6968C20.4654 21.7287 20.4758 21.7595 20.493 21.7866C20.5101 21.8136 20.5335 21.8361 20.5612 21.8523C20.5888 21.8684 20.62 21.8776 20.652 21.8792C22.882 21.9872 25.118 21.9872 27.349 21.8792C27.3809 21.8775 27.4119 21.8681 27.4394 21.8519C27.467 21.8358 27.4902 21.8132 27.5073 21.7862C27.5243 21.7591 27.5346 21.7284 27.5374 21.6966C27.5401 21.6648 27.5352 21.6328 27.523 21.6032L25.165 15.9452ZM21.2 15.9752C21.2125 15.9448 21.2173 15.9119 21.214 15.8792C21.2107 15.8465 21.1994 15.8151 21.1811 15.7879C21.1628 15.7606 21.1381 15.7382 21.1091 15.7228C21.0802 15.7073 21.0478 15.6992 21.015 15.6992H18.525C18.282 15.6991 18.0427 15.7581 17.8276 15.871C17.6125 15.9838 17.428 16.1473 17.29 16.3472L14.052 21.0422C14.0321 21.071 14.0201 21.1045 14.0172 21.1394C14.0143 21.1743 14.0206 21.2093 14.0354 21.241C14.0503 21.2727 14.0733 21.2999 14.102 21.32C14.1306 21.34 14.1641 21.3522 14.199 21.3552L17.73 21.6752C18.001 21.7012 18.272 21.7242 18.543 21.7452C18.6272 21.7517 18.7113 21.7313 18.7832 21.6869C18.8551 21.6425 18.911 21.5764 18.943 21.4982L21.2 15.9752Z"
        fill={color}
      />
    </svg>
  );
};

export const IconSettingFilled = ({
  className,
  width = "48",
  height = "48",
  color = "white",
  bgColor = "#56D9B9",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="10" fill={bgColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.2789 14.152C25.9089 14 25.4389 14 24.4999 14C23.5609 14 23.0919 14 22.7209 14.152C22.2284 14.3542 21.8363 14.7438 21.6309 15.235C21.5369 15.458 21.5009 15.719 21.4859 16.098C21.4793 16.3726 21.4027 16.641 21.2634 16.8777C21.1241 17.1145 20.9267 17.3118 20.6899 17.451C20.4487 17.5851 20.1775 17.6561 19.9015 17.6575C19.6255 17.6589 19.3536 17.5907 19.1109 17.459C18.7729 17.281 18.5279 17.183 18.2859 17.151C17.7565 17.0815 17.221 17.2238 16.7959 17.547C16.4779 17.789 16.2429 18.193 15.7739 19C15.3039 19.807 15.0699 20.21 15.0169 20.605C14.9469 21.131 15.0909 21.663 15.4169 22.084C15.5649 22.276 15.7739 22.437 16.0969 22.639C16.5739 22.936 16.8799 23.442 16.8799 24C16.8799 24.558 16.5739 25.064 16.0979 25.36C15.7739 25.563 15.5649 25.724 15.4159 25.916C15.255 26.1239 15.1369 26.3617 15.0684 26.6156C14.9999 26.8694 14.9825 27.1343 15.0169 27.395C15.0699 27.789 15.3039 28.193 15.7739 29C16.2439 29.807 16.4779 30.21 16.7959 30.453C17.2199 30.776 17.7559 30.918 18.2859 30.849C18.5279 30.817 18.7729 30.719 19.1109 30.541C19.3537 30.4092 19.6258 30.3408 19.902 30.3422C20.1782 30.3436 20.4496 30.4147 20.6909 30.549C21.1769 30.829 21.4649 31.344 21.4859 31.902C21.5009 32.282 21.5369 32.542 21.6309 32.765C21.8349 33.255 22.2269 33.645 22.7209 33.848C23.0909 34 23.5609 34 24.4999 34C25.4389 34 25.9089 34 26.2789 33.848C26.7715 33.6458 27.1636 33.2562 27.3689 32.765C27.4629 32.542 27.4989 32.282 27.5139 31.902C27.5339 31.344 27.8229 30.828 28.3099 30.549C28.5512 30.4149 28.8224 30.3439 29.0984 30.3425C29.3744 30.3411 29.6463 30.4093 29.8889 30.541C30.2269 30.719 30.472 30.817 30.714 30.849C31.2439 30.919 31.7799 30.776 32.2039 30.453C32.5219 30.211 32.7569 29.807 33.2259 29C33.6959 28.193 33.9299 27.79 33.9829 27.395C34.0173 27.1343 33.9996 26.8693 33.931 26.6155C33.8623 26.3616 33.744 26.1239 33.5829 25.916C33.4349 25.724 33.2259 25.563 32.9029 25.361C32.4259 25.064 32.1199 24.558 32.1199 24C32.1199 23.442 32.4259 22.936 32.9019 22.64C33.2259 22.437 33.4349 22.276 33.5839 22.084C33.7449 21.8761 33.863 21.6383 33.9315 21.3844C34 21.1306 34.0174 20.8657 33.9829 20.605C33.9299 20.211 33.6959 19.807 33.2259 19C32.7559 18.193 32.5219 17.79 32.2039 17.547C31.7789 17.2238 31.2434 17.0815 30.714 17.151C30.472 17.183 30.2269 17.281 29.8889 17.459C29.6462 17.5908 29.3741 17.6592 29.0979 17.6578C28.8217 17.6564 28.5503 17.5853 28.3089 17.451C28.0723 17.3117 27.8752 17.1143 27.7361 16.8776C27.597 16.6408 27.5205 16.3725 27.5139 16.098C27.4989 15.718 27.4629 15.458 27.3689 15.235C27.2673 14.9917 27.1187 14.7709 26.9317 14.5851C26.7447 14.3992 26.5229 14.2521 26.2789 14.152ZM24.4999 27C26.1699 27 27.5229 25.657 27.5229 24C27.5229 22.343 26.1689 21 24.4999 21C22.8299 21 21.4769 22.343 21.4769 24C21.4769 25.657 22.8309 27 24.4999 27Z"
        fill={color}
      />
    </svg>
  );
};

export const IconConfigBolt = ({
  className,
  width = "24",
  height = "24",
  color = "#040637",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3V5H14C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7H16V9C16 9.55228 16.4477 10 17 10C17.5523 10 18 9.55228 18 9V7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H18V3Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0993 1.00164C12.0663 1.00055 12.0332 1 12 1C11.4742 1 10.9577 1.13818 10.5021 1.40069L3.50386 5.3997L3.5 5.40192C3.04439 5.66497 2.66597 6.0432 2.40269 6.49867C2.13941 6.95414 2.00054 7.47084 2 7.99692V15.999C2.00054 16.5251 2.13941 17.0418 2.40269 17.4972C2.66597 17.9527 3.04439 18.3309 3.5 18.594L3.50386 18.5962L10.5 22.594L10.5019 22.595C10.9575 22.8577 11.4741 22.9959 12 22.9959C12.5259 22.9959 13.0426 22.8576 13.4982 22.595L13.5 22.594L20.4961 18.5962L20.5 18.594C20.9556 18.3309 21.334 17.9527 21.5973 17.4972C21.8606 17.0418 21.9995 16.5251 22 15.999V10.899C21.4259 11.4849 20.7496 11.9703 20 12.3264V15.9969C19.9998 16.1723 19.9535 16.3445 19.8658 16.4963C19.7783 16.6476 19.6527 16.7734 19.5016 16.861L19.5 16.8619L12.5039 20.8597L12.5 20.8619C12.348 20.9497 12.1755 20.9959 12 20.9959C11.8245 20.9959 11.652 20.9497 11.5 20.8619L4.5 16.8619L4.49842 16.861C4.34726 16.7734 4.22169 16.6476 4.13423 16.4963C4.04654 16.3446 4.00025 16.1726 4 15.9974V7.99854C4.00025 7.82333 4.04654 7.65126 4.13423 7.49956C4.22169 7.34826 4.34726 7.22253 4.49842 7.13489L4.5 7.13398L10.357 3.78716C10.7117 2.7218 11.3155 1.77026 12.0993 1.00164ZM10.1321 7.36057C8.29596 8.10052 7 9.89892 7 12C7 14.7614 9.23858 17 12 17C14.4192 17 16.4371 15.2819 16.9001 12.9993C16.2119 12.9897 15.5477 12.8807 14.9212 12.6862C14.6109 14.0123 13.4208 15 12 15C10.3431 15 9 13.6569 9 12C9 10.7703 9.73985 9.71343 10.7987 9.2502C10.491 8.66436 10.2639 8.02957 10.1321 7.36057Z"
        fill={color}
      />
    </svg>
  );
};

export const IconConfigSimpleBolt = ({
  className,
  width = "24",
  height = "24",
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15.9979V7.99795C20.9996 7.64722 20.9071 7.30276 20.7315 6.99911C20.556 6.69546 20.3037 6.44331 20 6.26795L13 2.26795C12.696 2.09241 12.3511 2 12 2C11.6489 2 11.304 2.09241 11 2.26795L4 6.26795C3.69626 6.44331 3.44398 6.69546 3.26846 6.99911C3.09294 7.30276 3.00036 7.64722 3 7.99795V15.9979C3.00036 16.3487 3.09294 16.6931 3.26846 16.9968C3.44398 17.3004 3.69626 17.5526 4 17.7279L11 21.7279C11.304 21.9035 11.6489 21.9959 12 21.9959C12.3511 21.9959 12.696 21.9035 13 21.7279L20 17.7279C20.3037 17.5526 20.556 17.3004 20.7315 16.9968C20.9071 16.6931 20.9996 16.3487 21 15.9979Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconConfiguratorOnLine = () => {
  return (
    <svg
      width="251"
      height="45"
      viewBox="0 0 251 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.4376 5.3436C28.6632 2.00522 32.41 0 36.4222 0H214.578C218.59 0 222.337 2.00521 224.562 5.3436L251 45H0L26.4376 5.3436Z"
        fill="#8B1516"
      />
      <path
        d="M80 25.9979V17.9979C79.9996 17.6472 79.9071 17.3028 79.7315 16.9991C79.556 16.6955 79.3037 16.4433 79 16.2679L72 12.2679C71.696 12.0924 71.3511 12 71 12C70.6489 12 70.304 12.0924 70 12.2679L63 16.2679C62.6963 16.4433 62.444 16.6955 62.2685 16.9991C62.0929 17.3028 62.0004 17.6472 62 17.9979V25.9979C62.0004 26.3487 62.0929 26.6931 62.2685 26.9968C62.444 27.3004 62.6963 27.5526 63 27.7279L70 31.7279C70.304 31.9035 70.6489 31.9959 71 31.9959C71.3511 31.9959 71.696 31.9035 72 31.7279L79 27.7279C79.3037 27.5526 79.556 27.3004 79.7315 26.9968C79.9071 26.6931 79.9996 26.3487 80 25.9979Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71 26C73.2091 26 75 24.2091 75 22C75 19.7909 73.2091 18 71 18C68.7909 18 67 19.7909 67 22C67 24.2091 68.7909 26 71 26Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.278 19.9375H99.7898C99.7443 19.6155 99.6515 19.3295 99.5114 19.0795C99.3712 18.8258 99.1913 18.6098 98.9716 18.4318C98.7519 18.2538 98.4981 18.1174 98.2102 18.0227C97.9261 17.928 97.6174 17.8807 97.2841 17.8807C96.6818 17.8807 96.1572 18.0303 95.7102 18.3295C95.2633 18.625 94.9167 19.0568 94.6705 19.625C94.4242 20.1894 94.3011 20.875 94.3011 21.6818C94.3011 22.5114 94.4242 23.2083 94.6705 23.7727C94.9205 24.3371 95.2689 24.7633 95.7159 25.0511C96.1629 25.339 96.6799 25.483 97.267 25.483C97.5966 25.483 97.9015 25.4394 98.1818 25.3523C98.4659 25.2652 98.7178 25.1383 98.9375 24.9716C99.1572 24.8011 99.339 24.5947 99.483 24.3523C99.6307 24.1098 99.733 23.8333 99.7898 23.5227L102.278 23.5341C102.214 24.0682 102.053 24.5833 101.795 25.0795C101.542 25.572 101.199 26.0133 100.767 26.4034C100.339 26.7898 99.8277 27.0966 99.233 27.3239C98.642 27.5473 97.9735 27.6591 97.2273 27.6591C96.1894 27.6591 95.2614 27.4242 94.4432 26.9545C93.6288 26.4848 92.9848 25.8049 92.5114 24.9148C92.0417 24.0246 91.8068 22.947 91.8068 21.6818C91.8068 20.4129 92.0455 19.3333 92.5227 18.4432C93 17.553 93.6477 16.875 94.4659 16.4091C95.2841 15.9394 96.2045 15.7045 97.2273 15.7045C97.9015 15.7045 98.5265 15.7992 99.1023 15.9886C99.6818 16.178 100.195 16.4545 100.642 16.8182C101.089 17.178 101.453 17.6193 101.733 18.142C102.017 18.6648 102.199 19.2633 102.278 19.9375ZM107.94 27.6705C107.058 27.6705 106.295 27.483 105.651 27.108C105.01 26.7292 104.516 26.2027 104.168 25.5284C103.819 24.8504 103.645 24.0644 103.645 23.1705C103.645 22.2689 103.819 21.4811 104.168 20.8068C104.516 20.1288 105.01 19.6023 105.651 19.2273C106.295 18.8485 107.058 18.6591 107.94 18.6591C108.823 18.6591 109.584 18.8485 110.224 19.2273C110.868 19.6023 111.365 20.1288 111.713 20.8068C112.062 21.4811 112.236 22.2689 112.236 23.1705C112.236 24.0644 112.062 24.8504 111.713 25.5284C111.365 26.2027 110.868 26.7292 110.224 27.108C109.584 27.483 108.823 27.6705 107.94 27.6705ZM107.952 25.7955C108.353 25.7955 108.688 25.6818 108.957 25.4545C109.226 25.2235 109.429 24.9091 109.565 24.5114C109.705 24.1136 109.776 23.661 109.776 23.1534C109.776 22.6458 109.705 22.1932 109.565 21.7955C109.429 21.3977 109.226 21.0833 108.957 20.8523C108.688 20.6212 108.353 20.5057 107.952 20.5057C107.546 20.5057 107.205 20.6212 106.929 20.8523C106.656 21.0833 106.45 21.3977 106.31 21.7955C106.173 22.1932 106.105 22.6458 106.105 23.1534C106.105 23.661 106.173 24.1136 106.31 24.5114C106.45 24.9091 106.656 25.2235 106.929 25.4545C107.205 25.6818 107.546 25.7955 107.952 25.7955ZM116.23 22.4545V27.5H113.81V18.7727H116.116V20.3125H116.219C116.412 19.8049 116.736 19.4034 117.19 19.108C117.645 18.8087 118.196 18.6591 118.844 18.6591C119.45 18.6591 119.978 18.7917 120.429 19.0568C120.88 19.322 121.23 19.7008 121.48 20.1932C121.73 20.6818 121.855 21.2652 121.855 21.9432V27.5H119.435V22.375C119.438 21.8409 119.302 21.4242 119.026 21.125C118.749 20.822 118.368 20.6705 117.884 20.6705C117.558 20.6705 117.27 20.7405 117.02 20.8807C116.774 21.0208 116.58 21.2254 116.44 21.4943C116.304 21.7595 116.234 22.0795 116.23 22.4545ZM128.456 18.7727V20.5909H123.07V18.7727H128.456ZM124.303 27.5V18.142C124.303 17.5095 124.426 16.9848 124.672 16.5682C124.922 16.1515 125.263 15.839 125.695 15.6307C126.126 15.4223 126.617 15.3182 127.166 15.3182C127.537 15.3182 127.876 15.3466 128.183 15.4034C128.494 15.4602 128.725 15.5114 128.876 15.5568L128.445 17.375C128.35 17.3447 128.232 17.3163 128.092 17.2898C127.956 17.2633 127.816 17.25 127.672 17.25C127.316 17.25 127.068 17.3333 126.928 17.5C126.787 17.6629 126.717 17.892 126.717 18.1875V27.5H124.303ZM129.935 27.5V18.7727H132.355V27.5H129.935ZM131.151 17.6477C130.791 17.6477 130.482 17.5284 130.224 17.2898C129.971 17.0473 129.844 16.7576 129.844 16.4205C129.844 16.0871 129.971 15.8011 130.224 15.5625C130.482 15.3201 130.791 15.1989 131.151 15.1989C131.51 15.1989 131.817 15.3201 132.071 15.5625C132.329 15.8011 132.457 16.0871 132.457 16.4205C132.457 16.7576 132.329 17.0473 132.071 17.2898C131.817 17.5284 131.51 17.6477 131.151 17.6477ZM138.226 30.9545C137.442 30.9545 136.769 30.8466 136.209 30.6307C135.652 30.4186 135.209 30.1288 134.879 29.7614C134.55 29.3939 134.336 28.9811 134.237 28.5227L136.476 28.2216C136.544 28.3958 136.652 28.5587 136.8 28.7102C136.947 28.8617 137.143 28.983 137.385 29.0739C137.631 29.1686 137.93 29.2159 138.283 29.2159C138.809 29.2159 139.243 29.0871 139.584 28.8295C139.929 28.5758 140.101 28.1496 140.101 27.5511V25.9545H139.999C139.893 26.197 139.733 26.4261 139.521 26.642C139.309 26.858 139.036 27.0341 138.703 27.1705C138.37 27.3068 137.972 27.375 137.51 27.375C136.855 27.375 136.258 27.2235 135.72 26.9205C135.186 26.6136 134.76 26.1458 134.442 25.517C134.127 24.8845 133.97 24.0852 133.97 23.1193C133.97 22.1307 134.131 21.3049 134.453 20.642C134.775 19.9792 135.203 19.483 135.737 19.1534C136.275 18.8239 136.864 18.6591 137.504 18.6591C137.993 18.6591 138.402 18.7424 138.732 18.9091C139.061 19.072 139.326 19.2765 139.527 19.5227C139.732 19.7652 139.889 20.0038 139.999 20.2386H140.089V18.7727H142.493V27.5852C142.493 28.3277 142.311 28.9489 141.947 29.4489C141.584 29.9489 141.08 30.3239 140.436 30.5739C139.796 30.8277 139.059 30.9545 138.226 30.9545ZM138.277 25.5568C138.667 25.5568 138.997 25.4602 139.266 25.267C139.538 25.0701 139.747 24.7898 139.891 24.4261C140.038 24.0587 140.112 23.6193 140.112 23.108C140.112 22.5966 140.04 22.1534 139.896 21.7784C139.752 21.3996 139.544 21.1061 139.271 20.8977C138.999 20.6894 138.667 20.5852 138.277 20.5852C137.879 20.5852 137.544 20.6932 137.271 20.9091C136.999 21.1212 136.792 21.4167 136.652 21.7955C136.512 22.1742 136.442 22.6117 136.442 23.108C136.442 23.6117 136.512 24.0473 136.652 24.4148C136.796 24.7784 137.002 25.0606 137.271 25.2614C137.544 25.4583 137.879 25.5568 138.277 25.5568ZM150.016 23.7841V18.7727H152.436V27.5H150.112V25.9148H150.021C149.824 26.4261 149.497 26.8371 149.038 27.1477C148.584 27.4583 148.029 27.6136 147.374 27.6136C146.79 27.6136 146.277 27.4811 145.834 27.2159C145.391 26.9508 145.044 26.5739 144.794 26.0852C144.548 25.5966 144.423 25.0114 144.419 24.3295V18.7727H146.839V23.8977C146.843 24.4129 146.982 24.8201 147.254 25.1193C147.527 25.4186 147.893 25.5682 148.351 25.5682C148.643 25.5682 148.915 25.5019 149.169 25.3693C149.423 25.233 149.627 25.0322 149.783 24.767C149.942 24.5019 150.019 24.1742 150.016 23.7841ZM154.372 27.5V18.7727H156.719V20.2955H156.81C156.969 19.7538 157.236 19.3447 157.611 19.0682C157.986 18.7879 158.418 18.6477 158.906 18.6477C159.027 18.6477 159.158 18.6553 159.298 18.6705C159.438 18.6856 159.562 18.7064 159.668 18.733V20.8807C159.554 20.8466 159.397 20.8163 159.196 20.7898C158.995 20.7633 158.812 20.75 158.645 20.75C158.289 20.75 157.971 20.8277 157.69 20.983C157.414 21.1345 157.194 21.3466 157.031 21.6193C156.872 21.892 156.793 22.2064 156.793 22.5625V27.5H154.372ZM163.158 27.6648C162.601 27.6648 162.105 27.5682 161.669 27.375C161.233 27.178 160.889 26.8883 160.635 26.5057C160.385 26.1193 160.26 25.6383 160.26 25.0625C160.26 24.5777 160.349 24.1705 160.527 23.8409C160.705 23.5114 160.947 23.2462 161.254 23.0455C161.561 22.8447 161.91 22.6932 162.3 22.5909C162.694 22.4886 163.107 22.4167 163.538 22.375C164.046 22.322 164.455 22.2727 164.766 22.2273C165.076 22.178 165.302 22.1061 165.442 22.0114C165.582 21.9167 165.652 21.7765 165.652 21.5909V21.5568C165.652 21.197 165.538 20.9186 165.311 20.7216C165.088 20.5246 164.769 20.4261 164.357 20.4261C163.921 20.4261 163.574 20.5227 163.317 20.7159C163.059 20.9053 162.889 21.1439 162.805 21.4318L160.567 21.25C160.68 20.7197 160.904 20.2614 161.237 19.875C161.571 19.4848 162 19.1856 162.527 18.9773C163.057 18.7652 163.671 18.6591 164.368 18.6591C164.853 18.6591 165.317 18.7159 165.76 18.8295C166.207 18.9432 166.603 19.1193 166.947 19.358C167.296 19.5966 167.571 19.9034 167.771 20.2784C167.972 20.6496 168.072 21.0947 168.072 21.6136V27.5H165.777V26.2898H165.709C165.569 26.5625 165.381 26.803 165.146 27.0114C164.911 27.2159 164.629 27.3769 164.3 27.4943C163.97 27.608 163.589 27.6648 163.158 27.6648ZM163.851 25.9943C164.207 25.9943 164.521 25.9242 164.794 25.7841C165.067 25.6402 165.281 25.447 165.436 25.2045C165.591 24.9621 165.669 24.6875 165.669 24.3807V23.4545C165.593 23.5038 165.489 23.5492 165.357 23.5909C165.228 23.6288 165.082 23.6648 164.919 23.6989C164.756 23.7292 164.593 23.7576 164.43 23.7841C164.268 23.8068 164.12 23.8277 163.987 23.8466C163.703 23.8883 163.455 23.9545 163.243 24.0455C163.031 24.1364 162.866 24.2595 162.749 24.4148C162.631 24.5663 162.572 24.7557 162.572 24.983C162.572 25.3125 162.692 25.5644 162.93 25.7386C163.173 25.9091 163.48 25.9943 163.851 25.9943ZM174.592 18.7727V20.5909H169.337V18.7727H174.592ZM170.53 16.6818H172.95V24.8182C172.95 25.0417 172.984 25.2159 173.053 25.3409C173.121 25.4621 173.215 25.5473 173.337 25.5966C173.462 25.6458 173.606 25.6705 173.768 25.6705C173.882 25.6705 173.996 25.661 174.109 25.642C174.223 25.6193 174.31 25.6023 174.371 25.5909L174.751 27.392C174.63 27.4299 174.46 27.4735 174.24 27.5227C174.02 27.5758 173.753 27.608 173.439 27.6193C172.856 27.642 172.344 27.5644 171.905 27.3864C171.469 27.2083 171.13 26.9318 170.888 26.5568C170.645 26.1818 170.526 25.7083 170.53 25.1364V16.6818ZM180.018 27.6705C179.136 27.6705 178.373 27.483 177.729 27.108C177.089 26.7292 176.594 26.2027 176.246 25.5284C175.897 24.8504 175.723 24.0644 175.723 23.1705C175.723 22.2689 175.897 21.4811 176.246 20.8068C176.594 20.1288 177.089 19.6023 177.729 19.2273C178.373 18.8485 179.136 18.6591 180.018 18.6591C180.901 18.6591 181.662 18.8485 182.303 19.2273C182.946 19.6023 183.443 20.1288 183.791 20.8068C184.14 21.4811 184.314 22.2689 184.314 23.1705C184.314 24.0644 184.14 24.8504 183.791 25.5284C183.443 26.2027 182.946 26.7292 182.303 27.108C181.662 27.483 180.901 27.6705 180.018 27.6705ZM180.03 25.7955C180.431 25.7955 180.767 25.6818 181.036 25.4545C181.304 25.2235 181.507 24.9091 181.643 24.5114C181.784 24.1136 181.854 23.661 181.854 23.1534C181.854 22.6458 181.784 22.1932 181.643 21.7955C181.507 21.3977 181.304 21.0833 181.036 20.8523C180.767 20.6212 180.431 20.5057 180.03 20.5057C179.625 20.5057 179.284 20.6212 179.007 20.8523C178.734 21.0833 178.528 21.3977 178.388 21.7955C178.251 22.1932 178.183 22.6458 178.183 23.1534C178.183 23.661 178.251 24.1136 178.388 24.5114C178.528 24.9091 178.734 25.2235 179.007 25.4545C179.284 25.6818 179.625 25.7955 180.03 25.7955ZM185.888 27.5V18.7727H188.234V20.2955H188.325C188.484 19.7538 188.751 19.3447 189.126 19.0682C189.501 18.7879 189.933 18.6477 190.422 18.6477C190.543 18.6477 190.674 18.6553 190.814 18.6705C190.954 18.6856 191.077 18.7064 191.183 18.733V20.8807C191.07 20.8466 190.912 20.8163 190.712 20.7898C190.511 20.7633 190.327 20.75 190.161 20.75C189.804 20.75 189.486 20.8277 189.206 20.983C188.929 21.1345 188.71 21.3466 188.547 21.6193C188.388 21.892 188.308 22.2064 188.308 22.5625V27.5H185.888Z"
        fill="white"
      />
    </svg>
  );
};

export const IconPlus = ({
  className,
  width = "48",
  height = "48",
  color = "#008ECC",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 24H38"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 10V38"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconSlideLocation = ({
  className,
  width = "26",
  height = "25",
  color = "#3F3F3F",
  bgColor = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="13"
        cy="12.5"
        r="12.2"
        fill="#E6E6E6"
        stroke={bgColor}
        strokeWidth="0.4"
      />
      <path
        d="M17.1934 15.7636L13.189 19.666L9.18453 15.7636C8.45416 15.06 7.96304 14.2255 7.71119 13.2601C7.45934 12.3275 7.45934 11.3948 7.71119 10.4622C7.96304 9.49677 8.45206 8.66024 9.17823 7.95256C9.9044 7.24489 10.7628 6.76424 11.7534 6.51062C12.7105 6.27337 13.6675 6.27337 14.6245 6.51062C15.6151 6.76424 16.4735 7.24489 17.1997 7.95256C17.9259 8.66024 18.4149 9.49677 18.6667 10.4622C18.9186 11.3948 18.9186 12.3275 18.6667 13.2601C18.4149 14.2255 17.9238 15.06 17.1934 15.7636ZM13.189 13.0883C13.4156 13.0883 13.6255 13.0331 13.8186 12.9227C14.0117 12.8122 14.1649 12.6629 14.2782 12.4747C14.3916 12.2866 14.4482 12.082 14.4482 11.8611C14.4482 11.6402 14.3916 11.4357 14.2782 11.2475C14.1649 11.0594 14.0117 10.9101 13.8186 10.7996C13.6255 10.6892 13.4156 10.634 13.189 10.634C12.9623 10.634 12.7524 10.6892 12.5593 10.7996C12.3663 10.9101 12.213 11.0594 12.0997 11.2475C11.9864 11.4357 11.9297 11.6402 11.9297 11.8611C11.9297 12.082 11.9864 12.2866 12.0997 12.4747C12.213 12.6629 12.3663 12.8122 12.5593 12.9227C12.7524 13.0331 12.9623 13.0883 13.189 13.0883Z"
        fill={color}
      />
    </svg>
  );
};

export const IconSlideInfo = ({
  className,
  width = "24",
  height = "25",
  color = "#3F3F3F",
  bgColor = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12.5"
        r="11.8"
        fill="#E6E6E6"
        stroke={bgColor}
        strokeWidth="0.4"
      />
      <path
        d="M13.5861 5C14.46 5 14.897 5.6384 14.897 6.3699C14.897 7.2834 14.1378 8.1283 13.1498 8.1283C12.3222 8.1283 11.8396 7.6033 11.8624 6.7353C11.8624 6.0052 12.437 5 13.5861 5ZM10.8972 19C10.2072 19 9.70174 18.5436 10.1843 16.5332L10.9761 12.9688C11.1137 12.399 11.1365 12.1701 10.9761 12.1701C10.7693 12.1701 9.87457 12.5635 9.34435 12.952L9 12.336C10.6774 10.8058 12.6072 9.9091 13.4354 9.9091C14.1248 9.9091 14.2396 10.8002 13.8952 12.1701L12.988 15.9165C12.8276 16.578 12.8961 16.8062 13.0572 16.8062C13.2639 16.8062 13.9422 16.5318 14.6087 15.9613L15 16.5311C13.3683 18.314 11.5859 19 10.8972 19Z"
        fill={color}
      />
    </svg>
  );
};

export const IconCopy = ({
  className,
  width = "24",
  height = "24",
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 8H10C8.89543 8 8 8.89543 8 10V20C8 21.1046 8.89543 22 10 22H20C21.1046 22 22 21.1046 22 20V10C22 8.89543 21.1046 8 20 8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconDeleteRecycle = ({
  className,
  width = "24",
  height = "24",
  color = "#2e2e2e",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 5.25V5.5H14V5.25C14 4.71957 13.7893 4.21086 13.4142 3.83579C13.0391 3.46071 12.5304 3.25 12 3.25C11.4696 3.25 10.9609 3.46071 10.5858 3.83579C10.2107 4.21086 10 4.71957 10 5.25ZM8.75 5.5V5.25C8.75 4.38805 9.09241 3.5614 9.7019 2.9519C10.3114 2.34241 11.138 2 12 2C12.862 2 13.6886 2.34241 14.2981 2.9519C14.9076 3.5614 15.25 4.38805 15.25 5.25V5.5H20.875C21.0408 5.5 21.1997 5.56585 21.3169 5.68306C21.4342 5.80027 21.5 5.95924 21.5 6.125C21.5 6.29076 21.4342 6.44973 21.3169 6.56694C21.1997 6.68415 21.0408 6.75 20.875 6.75H19.4165L18.4165 18.678C18.3405 19.5838 17.927 20.428 17.2579 21.0433C16.5888 21.6586 15.713 22 14.804 22H9.196C8.2871 21.9999 7.41139 21.6584 6.7424 21.0431C6.07341 20.4279 5.65997 19.5837 5.584 18.678L4.584 6.75H3.125C2.95924 6.75 2.80027 6.68415 2.68306 6.56694C2.56585 6.44973 2.5 6.29076 2.5 6.125C2.5 5.95924 2.56585 5.80027 2.68306 5.68306C2.80027 5.56585 2.95924 5.5 3.125 5.5H8.75ZM10.75 10.125C10.75 10.0429 10.7338 9.96165 10.7024 9.88582C10.671 9.80999 10.625 9.74109 10.5669 9.68306C10.5089 9.62502 10.44 9.57898 10.3642 9.54757C10.2883 9.51617 10.2071 9.5 10.125 9.5C10.0429 9.5 9.96165 9.51617 9.88582 9.54757C9.80999 9.57898 9.74109 9.62502 9.68306 9.68306C9.62502 9.74109 9.57898 9.80999 9.54757 9.88582C9.51617 9.96165 9.5 10.0429 9.5 10.125V17.375C9.5 17.4571 9.51617 17.5383 9.54757 17.6142C9.57898 17.69 9.62502 17.7589 9.68306 17.8169C9.74109 17.875 9.80999 17.921 9.88582 17.9524C9.96165 17.9838 10.0429 18 10.125 18C10.2071 18 10.2883 17.9838 10.3642 17.9524C10.44 17.921 10.5089 17.875 10.5669 17.8169C10.625 17.7589 10.671 17.69 10.7024 17.6142C10.7338 17.5383 10.75 17.4571 10.75 17.375V10.125ZM13.875 9.5C13.53 9.5 13.25 9.78 13.25 10.125V17.375C13.25 17.5408 13.3158 17.6997 13.4331 17.8169C13.5503 17.9342 13.7092 18 13.875 18C14.0408 18 14.1997 17.9342 14.3169 17.8169C14.4342 17.6997 14.5 17.5408 14.5 17.375V10.125C14.5 9.78 14.22 9.5 13.875 9.5Z"
        fill={color}
      />
    </svg>
  );
};

export const IconSettings = ({
  className,
  width = "24",
  height = "24",
  color = "#2E2E2E",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2509 12.5696V11.4221L21.6909 10.1621C21.9564 9.92811 22.1306 9.60784 22.1827 9.25787C22.2349 8.9079 22.1616 8.55076 21.9759 8.24957L20.2059 5.24957C20.0744 5.02177 19.8853 4.83256 19.6575 4.70092C19.4298 4.56928 19.1715 4.49984 18.9084 4.49957C18.7454 4.49832 18.5833 4.52366 18.4284 4.57457L16.6059 5.18957C16.2913 4.98048 15.963 4.79256 15.6234 4.62707L15.2409 2.73707C15.1723 2.39178 14.9845 2.0816 14.7103 1.86085C14.436 1.6401 14.0929 1.52283 13.7409 1.52957H10.2309C9.87895 1.52283 9.53581 1.6401 9.26158 1.86085C8.98735 2.0816 8.79951 2.39178 8.73092 2.73707L8.34842 4.62707C8.00637 4.79252 7.67565 4.98043 7.35842 5.18957L5.57342 4.54457C5.41689 4.50379 5.2548 4.48859 5.09342 4.49957C4.83038 4.49984 4.57203 4.56928 4.34429 4.70092C4.11656 4.83256 3.92744 5.02177 3.79592 5.24957L2.02592 8.24957C1.85086 8.55031 1.78581 8.90257 1.84191 9.246C1.89801 9.58943 2.07176 9.90267 2.33342 10.1321L3.75092 11.4296V12.5771L2.33342 13.8371C2.06437 14.0681 1.88586 14.3869 1.82957 14.737C1.77328 15.0871 1.84284 15.4459 2.02592 15.7496L3.79592 18.7496C3.92744 18.9774 4.11656 19.1666 4.34429 19.2982C4.57203 19.4299 4.83038 19.4993 5.09342 19.4996C5.25643 19.5008 5.41856 19.4755 5.57342 19.4246L7.39592 18.8096C7.71058 19.0187 8.0388 19.2066 8.37842 19.3721L8.76092 21.2621C8.82951 21.6074 9.01735 21.9175 9.29158 22.1383C9.56581 22.3591 9.90895 22.4763 10.2609 22.4696H13.8009C14.1529 22.4763 14.496 22.3591 14.7703 22.1383C15.0445 21.9175 15.2323 21.6074 15.3009 21.2621L15.6834 19.3721C16.0255 19.2066 16.3562 19.0187 16.6734 18.8096L18.4884 19.4246C18.6433 19.4755 18.8054 19.5008 18.9684 19.4996C19.2315 19.4993 19.4898 19.4299 19.7175 19.2982C19.9453 19.1666 20.1344 18.9774 20.2659 18.7496L21.9759 15.7496C22.151 15.4488 22.216 15.0966 22.1599 14.7532C22.1038 14.4097 21.9301 14.0965 21.6684 13.8671L20.2509 12.5696ZM18.9084 17.9996L16.3359 17.1296C15.7337 17.6397 15.0455 18.0384 14.3034 18.3071L13.7709 20.9996H10.2309L9.69842 18.3371C8.96224 18.0608 8.27771 17.6627 7.67342 17.1596L5.09342 17.9996L3.32342 14.9996L5.36342 13.1996C5.22474 12.4232 5.22474 11.6284 5.36342 10.8521L3.32342 8.99957L5.09342 5.99957L7.66592 6.86957C8.26812 6.35949 8.95637 5.96076 9.69842 5.69207L10.2309 2.99957H13.7709L14.3034 5.66207C15.0396 5.93839 15.7241 6.33643 16.3284 6.83957L18.9084 5.99957L20.6784 8.99957L18.6384 10.7996C18.7771 11.5759 18.7771 12.3707 18.6384 13.1471L20.6784 14.9996L18.9084 17.9996Z"
        fill={color}
      />
      <path
        d="M12 16.5C11.11 16.5 10.24 16.2361 9.49994 15.7416C8.75991 15.2471 8.18314 14.5443 7.84254 13.7221C7.50195 12.8998 7.41283 11.995 7.58647 11.1221C7.7601 10.2492 8.18868 9.44736 8.81802 8.81802C9.44736 8.18868 10.2492 7.7601 11.1221 7.58647C11.995 7.41283 12.8998 7.50195 13.7221 7.84254C14.5443 8.18314 15.2471 8.75991 15.7416 9.49994C16.2361 10.24 16.5 11.11 16.5 12C16.506 12.5926 16.3937 13.1805 16.1697 13.7292C15.9457 14.2779 15.6145 14.7763 15.1954 15.1954C14.7763 15.6145 14.2779 15.9457 13.7292 16.1697C13.1805 16.3937 12.5926 16.506 12 16.5ZM12 9C11.6035 8.99077 11.2093 9.06205 10.8411 9.20954C10.473 9.35704 10.1386 9.57768 9.85812 9.85812C9.57768 10.1386 9.35704 10.473 9.20954 10.8411C9.06205 11.2093 8.99077 11.6035 9 12C8.99077 12.3965 9.06205 12.7907 9.20954 13.1589C9.35704 13.527 9.57768 13.8615 9.85812 14.1419C10.1386 14.4223 10.473 14.643 10.8411 14.7905C11.2093 14.938 11.6035 15.0092 12 15C12.3965 15.0092 12.7907 14.938 13.1589 14.7905C13.527 14.643 13.8615 14.4223 14.1419 14.1419C14.4223 13.8615 14.643 13.527 14.7905 13.1589C14.938 12.7907 15.0092 12.3965 15 12C15.0092 11.6035 14.938 11.2093 14.7905 10.8411C14.643 10.473 14.4223 10.1386 14.1419 9.85812C13.8615 9.57768 13.527 9.35704 13.1589 9.20954C12.7907 9.06205 12.3965 8.99077 12 9Z"
        fill={color}
      />
    </svg>
  );
};

export const IconSettingsLight = ({
  className,
  width = "93",
  height = "93",
  color = "#2E2E2E",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 93 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.05">
        <path
          d="M78.4721 48.7069V44.2603L84.0521 39.3778C85.0807 38.4712 85.7557 37.2301 85.9577 35.874C86.1598 34.5179 85.876 33.134 85.1564 31.9669L78.2977 20.3419C77.7881 19.4591 77.0552 18.7259 76.1728 18.2158C75.2903 17.7057 74.2892 17.4366 73.2699 17.4356C72.6382 17.4308 72.01 17.5289 71.4099 17.7262L64.3477 20.1094C63.1284 19.2991 61.8565 18.5709 60.5405 17.9297L59.0583 10.6059C58.7926 9.26789 58.0647 8.06597 57.002 7.21055C55.9394 6.35513 54.6097 5.90071 53.2458 5.92685H39.6446C38.2807 5.90071 36.951 6.35513 35.8884 7.21055C34.8257 8.06597 34.0978 9.26789 33.8321 10.6059L32.3499 17.9297C31.0244 18.5708 29.7429 19.2989 28.5136 20.1094L21.5968 17.61C20.9902 17.4519 20.3621 17.3931 19.7368 17.4356C18.7175 17.4366 17.7164 17.7057 16.8339 18.2158C15.9514 18.7259 15.2186 19.4591 14.709 20.3419L7.8502 31.9669C7.17185 33.1322 6.91977 34.4972 7.13715 35.828C7.35453 37.1588 8.02784 38.3726 9.04177 39.2615L14.5346 44.2894V48.7359L9.04177 53.6184C7.9992 54.5135 7.30748 55.7491 7.08934 57.1058C6.87121 58.4624 7.14078 59.8525 7.8502 61.0294L14.709 72.6544C15.2186 73.5371 15.9514 74.2703 16.8339 74.7804C17.7164 75.2905 18.7175 75.5596 19.7368 75.5606C20.3684 75.5654 20.9967 75.4673 21.5968 75.27L28.659 72.8869C29.8782 73.6971 31.1501 74.4253 32.4661 75.0665L33.9483 82.3903C34.2141 83.7283 34.942 84.9302 36.0046 85.7857C37.0673 86.6411 38.3969 87.0955 39.7608 87.0694H53.4783C54.8422 87.0955 56.1719 86.6411 57.2345 85.7857C58.2972 84.9302 59.0251 83.7283 59.2908 82.3903L60.773 75.0665C62.0985 74.4254 63.38 73.6973 64.6093 72.8869L71.6424 75.27C72.2425 75.4673 72.8707 75.5654 73.5024 75.5606C74.5217 75.5596 75.5228 75.2905 76.4053 74.7804C77.2877 74.2703 78.0206 73.5371 78.5302 72.6544L85.1564 61.0294C85.8348 59.864 86.0869 58.499 85.8695 57.1682C85.6521 55.8374 84.9788 54.6236 83.9649 53.7347L78.4721 48.7069ZM73.2699 69.7481L63.3015 66.3769C60.9679 68.3534 58.3009 69.8985 55.4255 70.9397L53.3621 81.3731H39.6446L37.5811 71.0559C34.7284 69.9852 32.0759 68.4428 29.7343 66.4931L19.7368 69.7481L12.878 58.1231L20.783 51.1481C20.2456 48.1397 20.2456 45.0599 20.783 42.0515L12.878 34.8731L19.7368 23.2481L29.7052 26.6194C32.0387 24.6428 34.7057 23.0977 37.5811 22.0565L39.6446 11.6231H53.3621L55.4255 21.9403C58.2782 23.011 60.9308 24.5534 63.2724 26.5031L73.2699 23.2481L80.1286 34.8731L72.2236 41.8481C72.761 44.8565 72.761 47.9363 72.2236 50.9447L80.1286 58.1231L73.2699 69.7481Z"
          fill={color}
        />
        <path
          d="M46.5 63.9375C43.0512 63.9375 39.6798 62.9148 36.8122 60.9988C33.9447 59.0827 31.7097 56.3593 30.3899 53.173C29.0701 49.9868 28.7247 46.4807 29.3976 43.0981C30.0704 39.7156 31.7312 36.6085 34.1698 34.1698C36.6085 31.7312 39.7156 30.0704 43.0981 29.3976C46.4807 28.7247 49.9868 29.0701 53.173 30.3899C56.3593 31.7097 59.0827 33.9447 60.9988 36.8122C62.9148 39.6798 63.9375 43.0512 63.9375 46.5C63.9608 48.7964 63.5257 51.0744 62.6576 53.2005C61.7896 55.3267 60.506 57.2583 58.8821 58.8821C57.2583 60.506 55.3267 61.7896 53.2005 62.6576C51.0744 63.5257 48.7964 63.9608 46.5 63.9375ZM46.5 34.875C44.9636 34.8392 43.4359 35.1154 42.0093 35.687C40.5827 36.2585 39.2869 37.1135 38.2002 38.2002C37.1135 39.2869 36.2585 40.5827 35.687 42.0093C35.1154 43.4359 34.8392 44.9636 34.875 46.5C34.8392 48.0364 35.1154 49.5641 35.687 50.9907C36.2585 52.4173 37.1135 53.7131 38.2002 54.7998C39.2869 55.8865 40.5827 56.7415 42.0093 57.313C43.4359 57.8846 44.9636 58.1608 46.5 58.125C48.0364 58.1608 49.5641 57.8846 50.9907 57.313C52.4173 56.7415 53.7131 55.8865 54.7998 54.7998C55.8865 53.7131 56.7415 52.4173 57.313 50.9907C57.8846 49.5641 58.1608 48.0364 58.125 46.5C58.1608 44.9636 57.8846 43.4359 57.313 42.0093C56.7415 40.5827 55.8865 39.2869 54.7998 38.2002C53.7131 37.1135 52.4173 36.2585 50.9907 35.687C49.5641 35.1154 48.0364 34.8392 46.5 34.875Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const IconEmptyCell = ({
  className,
  width = "42",
  height = "42",
  color = "#D2D2D2",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.6477 4.05859C26.9543 4.05861 27.2506 4.16965 27.4817 4.37119C27.7128 4.57274 27.8631 4.85114 27.9048 5.15492L27.9166 5.32749V9.26108C29.1358 9.51027 30.255 10.1121 31.1351 10.9919C32.0151 11.8717 32.6174 12.9907 32.867 14.2098H36.8006C37.1221 14.2099 37.4315 14.332 37.6665 14.5515C37.9014 14.771 38.0442 15.0715 38.0661 15.3922C38.0881 15.7129 37.9874 16.0301 37.7845 16.2794C37.5816 16.5288 37.2916 16.6919 36.9732 16.7357L36.8006 16.7476H32.9922V19.7084H36.7989C37.1055 19.7084 37.4018 19.8194 37.6329 20.021C37.864 20.2225 38.0142 20.5009 38.056 20.8047L38.0678 20.9773C38.0678 21.2839 37.9567 21.5801 37.7552 21.8112C37.5536 22.0423 37.2752 22.1926 36.9715 22.2343L36.7989 22.2462H32.9922V25.2069H36.7989C37.1055 25.2069 37.4018 25.318 37.6329 25.5195C37.864 25.7211 38.0142 25.9995 38.056 26.3032L38.0678 26.4758C38.0678 26.7824 37.9567 27.0787 37.7552 27.3098C37.5536 27.5409 37.2752 27.6912 36.9715 27.7329L36.7989 27.7447H32.8653C32.6161 28.9639 32.0143 30.0831 31.1345 30.9632C30.2547 31.8433 29.1357 32.4455 27.9166 32.6951V36.6287C27.9165 36.9502 27.7944 37.2597 27.5749 37.4946C27.3554 37.7295 27.0549 37.8724 26.7342 37.8943C26.4134 37.9162 26.0963 37.8155 25.8469 37.6126C25.5975 37.4098 25.4345 37.1198 25.3906 36.8013L25.3788 36.6287V32.8203H22.4163L22.418 36.6287C22.418 36.9353 22.307 37.2316 22.1054 37.4627C21.9039 37.6938 21.6255 37.8441 21.3217 37.8858L21.1491 37.8959C20.8425 37.8959 20.5462 37.7849 20.3152 37.5833C20.0841 37.3818 19.9338 37.1034 19.8921 36.7996L19.8802 36.627L19.8785 32.8186H16.9195V36.627C16.9195 36.9336 16.8084 37.2299 16.6069 37.461C16.4053 37.6921 16.1269 37.8424 15.8231 37.8841L15.6506 37.8959C15.3439 37.8959 15.0477 37.7849 14.8166 37.5833C14.5855 37.3818 14.4352 37.1034 14.3935 36.7996L14.3817 36.627V32.6934C13.1628 32.4439 12.044 31.8419 11.1642 30.9622C10.2844 30.0824 9.68244 28.9636 9.43296 27.7447H5.49937C5.17787 27.7446 4.8684 27.6225 4.63349 27.403C4.39857 27.1835 4.25572 26.8831 4.23381 26.5623C4.2119 26.2416 4.31255 25.9245 4.51543 25.6751C4.71832 25.4257 5.0083 25.2626 5.3268 25.2188L5.49937 25.2069L9.30607 25.2052V22.2445L5.49937 22.2462C5.19274 22.2461 4.89649 22.1351 4.6654 21.9336C4.43431 21.732 4.28401 21.4536 4.24231 21.1498L4.23047 20.9773C4.23048 20.6706 4.34153 20.3744 4.54307 20.1433C4.74461 19.9122 5.02302 19.7619 5.3268 19.7202L5.49937 19.7084L9.30607 19.7067V16.7459L5.49937 16.7476C5.19274 16.7476 4.89649 16.6365 4.6654 16.435C4.43431 16.2334 4.28401 15.955 4.24231 15.6513L4.23047 15.4787C4.23048 15.1721 4.34153 14.8758 4.54307 14.6447C4.74461 14.4136 5.02302 14.2633 5.3268 14.2216L5.49937 14.2098L9.43296 14.2081C9.68274 12.9895 10.2849 11.8711 11.1646 10.9916C12.0444 10.1122 13.163 9.51045 14.3817 9.26108V5.32749C14.3818 5.006 14.5039 4.69653 14.7234 4.46161C14.9429 4.22669 15.2433 4.08385 15.5641 4.06193C15.8848 4.04002 16.2019 4.14068 16.4513 4.34356C16.7007 4.54644 16.8638 4.83643 16.9076 5.15492L16.9195 5.32749V9.1325H19.8785L19.8802 5.32749C19.8802 5.02086 19.9913 4.72461 20.1928 4.49352C20.3944 4.26243 20.6728 4.11214 20.9766 4.07044L21.1491 4.05859C21.4558 4.05861 21.752 4.16965 21.9831 4.37119C22.2142 4.57274 22.3645 4.85114 22.4062 5.15492L22.418 5.32749L22.4163 9.1325H25.3788V5.32749C25.3787 5.04989 25.4697 4.77992 25.6378 4.55898C25.8059 4.33803 26.0418 4.1783 26.3093 4.10427L26.4751 4.07044L26.6477 4.05859ZM26.6477 11.672H15.6506C14.641 11.672 13.6727 12.0731 12.9588 12.7869C12.2449 13.5008 11.8439 14.4691 11.8439 15.4787V26.4758C11.8439 27.4854 12.2449 28.4537 12.9588 29.1676C13.6727 29.8815 14.641 30.2825 15.6506 30.2825H26.6477C27.6573 30.2825 28.6255 29.8815 29.3394 29.1676C30.0533 28.4537 30.4544 27.4854 30.4544 26.4758V15.4787C30.4544 14.4691 30.0533 13.5008 29.3394 12.7869C28.6255 12.0731 27.6573 11.672 26.6477 11.672ZM21.1576 15.9101C22.5037 15.9101 23.7947 16.4449 24.7466 17.3967C25.6984 18.3486 26.2332 19.6396 26.2332 20.9857C26.2332 22.3318 25.6984 23.6228 24.7466 24.5747C23.7947 25.5266 22.5037 26.0613 21.1576 26.0613C19.8115 26.0613 18.5205 25.5266 17.5686 24.5747C16.6167 23.6228 16.082 22.3318 16.082 20.9857C16.082 19.6396 16.6167 18.3486 17.5686 17.3967C18.5205 16.4449 19.8115 15.9101 21.1576 15.9101ZM21.1576 18.4479C20.4845 18.4479 19.839 18.7153 19.3631 19.1912C18.8872 19.6671 18.6198 20.3126 18.6198 20.9857C18.6198 21.6588 18.8872 22.3043 19.3631 22.7802C19.839 23.2561 20.4845 23.5235 21.1576 23.5235C21.8307 23.5235 22.4762 23.2561 22.9521 22.7802C23.428 22.3043 23.6954 21.6588 23.6954 20.9857C23.6954 20.3126 23.428 19.6671 22.9521 19.1912C22.4762 18.7153 21.8307 18.4479 21.1576 18.4479Z"
        fill={color}
      />
    </svg>
  );
};

export const IconRotate = ({
  className,
  width = "24",
  height = "25",
  color = "#2e2e2e",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 13.5C3 15.28 3.52784 17.0201 4.51677 18.5001C5.50571 19.9802 6.91131 21.1337 8.55585 21.8149C10.2004 22.4961 12.01 22.6743 13.7558 22.3271C15.5016 21.9798 17.1053 21.1226 18.364 19.864C19.6226 18.6053 20.4798 17.0016 20.8271 15.2558C21.1743 13.51 20.9961 11.7004 20.3149 10.0558C19.6337 8.41131 18.4802 7.00571 17.0001 6.01677C15.5201 5.02784 13.78 4.5 12 4.5C9.48395 4.50947 7.06897 5.49122 5.26 7.24L3 9.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 3.5V8.5H8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconDownload = ({
  className,
  width = "24",
  height = "25",
  color = "#A30A2A",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15.5V19.5C21 20.0304 20.7893 20.5391 20.4142 20.9142C20.0391 21.2893 19.5304 21.5 19 21.5H5C4.46957 21.5 3.96086 21.2893 3.58579 20.9142C3.21071 20.5391 3 20.0304 3 19.5V15.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10.5L12 15.5L17 10.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.5V3.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconInfo = ({
  className,
  width = "24",
  height = "24",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16V12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8H12.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconMonitor = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 6H8C5.79086 6 4 7.79086 4 10V30C4 32.2091 5.79086 34 8 34H40C42.2091 34 44 32.2091 44 30V10C44 7.79086 42.2091 6 40 6Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 42H32"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 34V42"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconFan = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6542 32.7582C19.5585 33.8172 17.2011 34.2471 14.8665 33.9958C12.5319 33.7446 10.3199 32.8231 8.49746 31.3424C6.67507 29.8617 5.32017 27.8852 4.59632 25.6515C3.87247 23.4178 3.8106 21.0223 4.41818 18.7542L15.2422 21.6542C14.1831 19.5585 13.7533 17.2011 14.0045 14.8665C14.2557 12.5319 15.1773 10.3199 16.658 8.49746C18.1386 6.67507 20.1151 5.32017 22.3488 4.59632C24.5826 3.87247 26.9781 3.8106 29.2462 4.41818L26.3462 15.2422C28.4419 14.1831 30.7993 13.7533 33.1339 14.0045C35.4685 14.2557 37.6805 15.1773 39.5029 16.658C41.3253 18.1386 42.6802 20.1151 43.404 22.3488C44.1279 24.5826 44.1898 26.9781 43.5822 29.2462L32.7582 26.3462C33.8172 28.4419 34.2471 30.7993 33.9958 33.1339C33.7446 35.4685 32.8231 37.6805 31.3424 39.5029C29.8617 41.3253 27.8852 42.6802 25.6515 43.404C23.4178 44.1279 21.0223 44.1898 18.7542 43.5822L21.6542 32.7582Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 24V24.0192"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconHeater = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9985 16C25.9985 10 17.9985 10 21.9985 4"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.9985 16C34.9985 10 26.9985 10 30.9985 4"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20H12.0208"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 28H12.0208"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 32V24"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 32V24"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 32V24"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 12C41.0609 12 42.0783 12.4214 42.8284 13.1716C43.5786 13.9217 44 14.9391 44 16V36C44 37.0609 43.5786 38.0783 42.8284 38.8284C42.0783 39.5786 41.0609 40 40 40H8C6.93913 40 5.92172 39.5786 5.17157 38.8284C4.42143 38.0783 4 37.0609 4 36V16C4 14.9391 4.42143 13.9217 5.17157 13.1716C5.92172 12.4214 6.93913 12 8 12H14"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 40V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 40V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconTopSidePreHeat = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4H38C39.1046 4 40 4.89543 40 6V10C40 11.1046 39.1046 12 38 12H10C8.89543 12 8 11.1046 8 10V6C8 4.89543 8.89543 4 10 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 16C19 20 13 22 16 26"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 16C27 20 21 22 24 26"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 16C35 20 29 22 32 26"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 34V30H20V34"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 34V30H34V34"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 34H42C43.1046 34 44 34.8954 44 36V38C44 39.1046 43.1046 40 42 40H6C4.89543 40 4 39.1046 4 38V36C4 34.8954 4.89543 34 6 34Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 40V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 40V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconBottomSidePreHeat = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8V4H20V8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 8V4H34V8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8H42C43.1046 8 44 8.89543 44 10V12C44 13.1046 43.1046 14 42 14H6C4.89543 14 4 13.1046 4 12V10C4 8.89543 4.89543 8 6 8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 28C13 24 19 22 16 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 28C21 24 27 22 24 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 28C29 24 35 22 32 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 32H38C39.1046 32 40 32.8954 40 34V38C40 39.1046 39.1046 40 38 40H10C8.89543 40 8 39.1046 8 38V34C8 32.8954 8.89543 32 10 32Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 40V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 40V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconBottomSidePyroControl = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8V4H20V8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 8V4H34V8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8H42C43.1046 8 44 8.89543 44 10V12C44 13.1046 43.1046 14 42 14H6C4.89543 14 4 13.1046 4 12V10C4 8.89543 4.89543 8 6 8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 18V18.0208"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22V22.0208"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 30V26H11V30"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 30H12C13.1046 30 14 30.8954 14 32V38C14 39.1046 13.1046 40 12 40H6C4.89543 40 4 39.1046 4 38V32C4 30.8954 4.89543 30 6 30Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 35H20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 33L20 35L18 37"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29 26C26 22.5 32 20.5 29 17"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 26C34 22.5 40 20.5 37 17"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 30H42C43.1046 30 44 30.8954 44 32V38C44 39.1046 43.1046 40 42 40H24C22.8954 40 22 39.1046 22 38V32C22 30.8954 22.8954 30 24 30Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 40V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 40V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconTopSidePyroControl = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8H12C13.1046 8 14 8.89543 14 10V16C14 17.1046 13.1046 18 12 18H6C4.89543 18 4 17.1046 4 16V10C4 8.89543 4.89543 8 6 8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 18V22H11V18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 26V26.0208"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 30V30.0208"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 13H20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 11L20 13L18 15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 8H42C43.1046 8 44 8.89543 44 10V16C44 17.1046 43.1046 18 42 18H24C22.8954 18 22 17.1046 22 16V10C22 8.89543 22.8954 8 24 8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 8V4"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 8V4"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29 22C32 25.5 26 27.5 29 31"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 22C40 25.5 34 27.5 37 31"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 34H42C43.1046 34 44 34.8954 44 36V38C44 39.1046 43.1046 40 42 40H6C4.89543 40 4 39.1046 4 38V36C4 34.8954 4.89543 34 6 34Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 40V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 40V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconTopAndBottomSidePreHeat = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4H38C39.1046 4 40 4.89543 40 6V8C40 9.10457 39.1046 10 38 10H10C8.89543 10 8 9.10457 8 8V6C8 4.89543 8.89543 4 10 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13C18.5 15 13.5 16 16 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 13C26.5 15 21.5 16 24 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 13C34.5 15 29.5 16 32 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 21H42C43.1046 21 44 21.8954 44 23V25C44 26.1046 43.1046 27 42 27H6C4.89543 27 4 26.1046 4 25V23C4 21.8954 4.89543 21 6 21Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 35C13.5 33 18.5 32 16 30"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 35C21.5 33 26.5 32 24 30"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 35C29.5 33 34.5 32 32 30"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 38H38C39.1046 38 40 38.8954 40 40V42C40 43.1046 39.1046 44 38 44H10C8.89543 44 8 43.1046 8 42V40C8 38.8954 8.89543 38 10 38Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconRingHeater = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 4H42C43.1046 4 44 4.89543 44 6V8C44 9.10457 43.1046 10 42 10H6C4.89543 10 4 9.10457 4 8V6C4 4.89543 4.89543 4 6 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 18C20 12 28 12 28 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 44V18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 44V18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 31C10 29.4 13.2 28 18.5 27.3"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5 27.3C34.8 28 38 29.4 38 31"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 31C38 33.2091 31.732 35 24 35C16.268 35 10 33.2091 10 31"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 24C15.5 21.5 10.5 19.5 13 15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 24C37.5 21.5 32.5 19.5 35 15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconConvectionPreHeat = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 20H40C41.1046 20 42 20.8954 42 22V40C42 41.1046 41.1046 42 40 42H8C6.89543 42 6 41.1046 6 40V22C6 20.8954 6.89543 20 8 20Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 25H42"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 25V42"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 30V36"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 30V36"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 42V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 42V44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 20V16C10 13.7909 11.7909 12 14 12H26C28.2091 12 30 13.7909 30 16V20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 20V18C14.5 16.8954 15.3954 16 16.5 16H23.5C24.6046 16 25.5 16.8954 25.5 18V20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 12V9H22V12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 13H41C41.5523 13 42 13.4477 42 14V19C42 19.5523 41.5523 20 41 20H34C33.4477 20 33 19.5523 33 19V14C33 13.4477 33.4477 13 34 13Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 13V9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 4H39C39.5523 4 40 4.44772 40 5V8C40 8.55228 39.5523 9 39 9H37C36.4477 9 36 8.55228 36 8V5C36 4.44772 36.4477 4 37 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconSiren = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 36V24C14 21.3478 15.0536 18.8043 16.9289 16.9289C18.8043 15.0536 21.3478 14 24 14C26.6522 14 29.1957 15.0536 31.0711 16.9289C32.9464 18.8043 34 21.3478 34 24V36"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 42C10 42.5304 10.2107 43.0391 10.5858 43.4142C10.9609 43.7893 11.4696 44 12 44H36C36.5304 44 37.0391 43.7893 37.4142 43.4142C37.7893 43.0391 38 42.5304 38 42V40C38 38.9391 37.5786 37.9217 36.8284 37.1716C36.0783 36.4214 35.0609 36 34 36H14C12.9391 36 11.9217 36.4214 11.1716 37.1716C10.4214 37.9217 10 38.9391 10 40V42Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 24H44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 9L36 10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 24H6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 4V6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.85938 9.85938L11.2734 11.2734"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 24V36"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconClose = ({
  className,
  width = "24",
  height = "24",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconLikeCompass = ({
  className,
  width = "32",
  height = "32",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8381 18.329H16.7037L14.8063 15.4565V18.329H13.6719V13.6719H14.8063L16.7037 16.5577V13.6719H17.8381V18.329Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5371 19.9959C22.3206 18.8664 22.7798 17.4949 22.7798 16.0161C22.7798 12.1554 19.6501 9.02579 15.7895 9.02579C14.7523 9.02579 13.7679 9.25169 12.8827 9.65697C12.7769 9.3534 12.5994 9.08347 12.3704 8.86751C13.4055 8.37153 14.5651 8.09375 15.7895 8.09375C20.1649 8.09375 23.7118 11.6407 23.7118 16.0161C23.7118 17.7412 23.1604 19.3376 22.2242 20.6385C22.0503 20.3732 21.8144 20.1521 21.5371 19.9959ZM18.696 22.3754C17.8109 22.7805 16.8266 23.0064 15.7895 23.0064C11.9289 23.0064 8.79923 19.8767 8.79923 16.0161C8.79923 14.5372 9.25847 13.1656 10.0421 12.0361C9.76473 11.88 9.52871 11.6591 9.35467 11.3938C8.41855 12.6947 7.86719 14.291 7.86719 16.0161C7.86719 20.3915 11.4141 23.9384 15.7895 23.9384C17.014 23.9384 18.1736 23.6606 19.2087 23.1646C18.9795 22.9488 18.8019 22.6789 18.696 22.3754Z"
        fill={color}
      />
      <circle
        cx="15.8402"
        cy="1.94175"
        r="1.47573"
        stroke={color}
        strokeWidth="0.932039"
      />
      <circle
        cx="15.8402"
        cy="30.0589"
        r="1.47573"
        stroke={color}
        strokeWidth="0.932039"
      />
      <circle
        cx="29.5902"
        cy="15.9964"
        r="1.47573"
        stroke={color}
        strokeWidth="0.932039"
      />
      <circle
        cx="1.94175"
        cy="15.9964"
        r="1.47573"
        stroke={color}
        strokeWidth="0.932039"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3607 2.18601C19.3607 2.50351 19.3193 2.81133 19.2416 3.10438C23.8453 4.33158 27.4708 7.9559 28.6996 12.5589C28.9909 12.4822 29.2967 12.4413 29.6121 12.4413L29.6326 12.4414C28.3398 7.41802 24.3845 3.4635 19.3607 2.17188L19.3607 2.18601ZM12.2151 29.8539C12.2151 29.8488 12.2151 29.8436 12.2151 29.8384C12.2151 29.5213 12.2564 29.2139 12.3339 28.9213C7.68574 27.6793 4.03602 23.9934 2.84564 19.3244C2.56135 19.4402 2.25881 19.5204 1.94351 19.5595C3.2285 24.5932 7.18579 28.5581 12.2151 29.8539ZM29.6324 19.5869C28.3395 24.61 24.3843 28.5642 19.3606 29.8558C19.3607 29.85 19.3607 29.8442 19.3607 29.8384C19.3607 29.522 19.3196 29.2152 19.2424 28.9231C23.8455 27.6957 27.4705 24.0718 28.6995 19.4693C28.9908 19.5461 29.2967 19.587 29.6121 19.587L29.6324 19.5869ZM12.2151 2.17373C7.18559 3.46963 3.2282 7.43477 1.94336 12.4687C2.25866 12.5078 2.56121 12.5881 2.8455 12.7038C4.0358 8.03432 7.68598 4.34798 12.3347 3.10617C12.2566 2.81259 12.2151 2.50416 12.2151 2.18601L12.2151 2.17373Z"
        fill={color}
      />
    </svg>
  );
};

export const IconConfiguratorSec = ({
  className,
  width = "24",
  height = "24",
  color = "#040637",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 12H22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M2 11C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13L2 11ZM6 13L7 13L7 11L6 11L6 13ZM2 13L6 13L6 11L2 11L2 13Z"
        fill={color}
      />
      <mask id="path-3-inside-1_616_28602" fill="white">
        <path d="M9.75 19.2834C9.75 19.6792 10.0716 20.0036 10.4655 19.9658C12.1921 19.8004 13.8164 19.0402 15.0533 17.8033C16.4598 16.3968 17.25 14.4891 17.25 12.5C17.25 10.5109 16.4598 8.60322 15.0533 7.1967C13.8164 5.95984 12.1921 5.1996 10.4655 5.03419C10.0716 4.99644 9.75 5.32082 9.75 5.71657C9.75 6.11232 10.072 6.42877 10.465 6.4754C11.8106 6.63506 13.072 7.24215 14.0399 8.21009C15.1777 9.34784 15.8169 10.891 15.8169 12.5C15.8169 14.109 15.1777 15.6522 14.0399 16.7899C13.072 17.7579 11.8106 18.3649 10.4649 18.5246C10.072 18.5712 9.75 18.8877 9.75 19.2834Z" />
      </mask>
      <path
        d="M9.75 19.2834C9.75 19.6792 10.0716 20.0036 10.4655 19.9658C12.1921 19.8004 13.8164 19.0402 15.0533 17.8033C16.4598 16.3968 17.25 14.4891 17.25 12.5C17.25 10.5109 16.4598 8.60322 15.0533 7.1967C13.8164 5.95984 12.1921 5.1996 10.4655 5.03419C10.0716 4.99644 9.75 5.32082 9.75 5.71657C9.75 6.11232 10.072 6.42877 10.465 6.4754C11.8106 6.63506 13.072 7.24215 14.0399 8.21009C15.1777 9.34784 15.8169 10.891 15.8169 12.5C15.8169 14.109 15.1777 15.6522 14.0399 16.7899C13.072 17.7579 11.8106 18.3649 10.4649 18.5246C10.072 18.5712 9.75 18.8877 9.75 19.2834Z"
        stroke={color}
        strokeWidth="1.875"
        mask="url(#path-3-inside-1_616_28602)"
      />
      <circle cx="9.75" cy="12.5" r="3.75" fill={color} />
    </svg>
  );
};

export const IconInfoBold = ({
  className,
  width = "24",
  height = "24",
  color = "#040637",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8394 17.525C13.8334 17.527 13.2804 17.711 12.8004 17.711C12.5354 17.711 12.4284 17.656 12.3944 17.632C12.2264 17.515 11.9144 17.296 12.4484 16.232L13.4484 14.238C14.0414 13.054 14.1294 11.909 13.6934 11.013C13.3374 10.28 12.6544 9.777 11.7734 9.597C11.4582 9.53248 11.1372 9.49998 10.8154 9.5C8.96641 9.5 7.72141 10.58 7.66941 10.626C7.58259 10.7025 7.525 10.8068 7.50646 10.921C7.48792 11.0352 7.50958 11.1524 7.56774 11.2524C7.62591 11.3525 7.71697 11.4292 7.82541 11.4696C7.93386 11.51 8.05296 11.5116 8.16241 11.474C8.16741 11.472 8.72141 11.287 9.20141 11.287C9.46441 11.287 9.57041 11.342 9.60341 11.365C9.77241 11.483 10.0854 11.705 9.55241 12.767L8.55241 14.762C7.95841 15.947 7.87141 17.092 8.30741 17.987C8.66341 18.72 9.34541 19.223 10.2284 19.403C10.5424 19.466 10.8644 19.5 11.1824 19.5C13.0324 19.5 14.2784 18.42 14.3304 18.374C14.4173 18.2977 14.475 18.1936 14.4938 18.0794C14.5125 17.9653 14.4911 17.8482 14.4332 17.7481C14.3753 17.6479 14.2845 17.571 14.1762 17.5303C14.0679 17.4896 13.9489 17.4878 13.8394 17.525Z"
        fill={color}
      />
      <path
        d="M13 8.5C14.3807 8.5 15.5 7.38071 15.5 6C15.5 4.61929 14.3807 3.5 13 3.5C11.6193 3.5 10.5 4.61929 10.5 6C10.5 7.38071 11.6193 8.5 13 8.5Z"
        fill={color}
      />
    </svg>
  );
};

export const IconMaterialSymbolsStar = ({
  className,
  width = "24",
  height = "24",
  color = "#040637",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.725 18.5L15 17.125L17.275 18.5L16.675 15.9L18.675 14.175L16.05 13.95L15 11.5L13.95 13.95L11.325 14.175L13.325 15.9L12.725 18.5ZM6 14V16H4C3.45 16 2.97933 15.8043 2.588 15.413C2.19667 15.0217 2.00067 14.5507 2 14V4C2 3.45 2.196 2.97933 2.588 2.588C2.98 2.19667 3.45067 2.00067 4 2H14C14.55 2 15.021 2.196 15.413 2.588C15.805 2.98 16.0007 3.45067 16 4V6H14V4H4V14H6ZM10 22C9.45 22 8.97933 21.8043 8.588 21.413C8.19667 21.0217 8.00067 20.5507 8 20V10C8 9.45 8.196 8.97933 8.588 8.588C8.98 8.19667 9.45067 8.00067 10 8H20C20.55 8 21.021 8.196 21.413 8.588C21.805 8.98 22.0007 9.45067 22 10V20C22 20.55 21.8043 21.021 21.413 21.413C21.0217 21.805 20.5507 22.0007 20 22H10ZM10 20H20V10H10V20Z"
        fill={color}
      />
    </svg>
  );
};

export const IconFluentOptions = ({
  className,
  width = "24",
  height = "24",
  color = "#040637",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.74977 13.5C9.48139 13.5 10.1916 13.7468 10.7656 14.2005C11.3396 14.6542 11.7438 15.2882 11.9128 16H21.2498C21.4398 16.0001 21.6227 16.0722 21.7616 16.202C21.9004 16.3317 21.9848 16.5093 21.9978 16.6989C22.0107 16.8885 21.9513 17.0759 21.8313 17.2233C21.7114 17.3707 21.54 17.4671 21.3518 17.493L21.2498 17.5H11.9128C11.7437 18.2118 11.3395 18.8457 10.7655 19.2993C10.1916 19.753 9.48135 19.9997 8.74977 19.9997C8.01819 19.9997 7.30799 19.753 6.73401 19.2993C6.16004 18.8457 5.75584 18.2118 5.58677 17.5H2.74977C2.55975 17.4999 2.37683 17.4278 2.23798 17.298C2.09913 17.1683 2.0147 16.9907 2.00175 16.8011C1.98879 16.6115 2.04829 16.4241 2.1682 16.2767C2.28812 16.1293 2.45952 16.0329 2.64777 16.007L2.74977 16H5.58677C5.75578 15.2882 6.15996 14.6542 6.73394 14.2005C7.30792 13.7468 8.01815 13.5 8.74977 13.5ZM15.2498 4C15.9814 4.00002 16.6916 4.24681 17.2656 4.70048C17.8396 5.15415 18.2438 5.78817 18.4128 6.5H21.2498C21.4398 6.50006 21.6227 6.57224 21.7616 6.70197C21.9004 6.8317 21.9848 7.0093 21.9978 7.19888C22.0107 7.38846 21.9513 7.57589 21.8313 7.7233C21.7114 7.87071 21.54 7.9671 21.3518 7.993L21.2498 8H18.4128C18.2437 8.71178 17.8395 9.34573 17.2655 9.79934C16.6916 10.253 15.9814 10.4997 15.2498 10.4997C14.5182 10.4997 13.808 10.253 13.234 9.79934C12.66 9.34573 12.2558 8.71178 12.0868 8H2.74977C2.55975 7.99994 2.37683 7.92776 2.23798 7.79803C2.09913 7.6683 2.0147 7.4907 2.00175 7.30112C1.98879 7.11154 2.04829 6.92411 2.1682 6.7767C2.28812 6.62929 2.45952 6.5329 2.64777 6.507L2.74977 6.5H12.0868C12.2558 5.78817 12.66 5.15415 13.2339 4.70048C13.8079 4.24681 14.5181 4.00002 15.2498 4Z"
        fill={color}
      />
    </svg>
  );
};

export const IconMapLocation = ({
  className,
  width = "42",
  height = "50",
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 42 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.84 35.3659L21 50L6.16 35.3659C3.45333 32.7274 1.63333 29.5981 0.7 25.9779C-0.233333 22.4804 -0.233333 18.983 0.7 15.4855C1.63333 11.8653 3.44556 8.72834 6.13667 6.07455C8.82778 3.42077 12.0089 1.61835 15.68 0.667282C19.2267 -0.222424 22.7733 -0.222424 26.32 0.667282C29.9911 1.61835 33.1722 3.42077 35.8633 6.07455C38.5544 8.72834 40.3667 11.8653 41.3 15.4855C42.2333 18.983 42.2333 22.4804 41.3 25.9779C40.3667 29.5981 38.5467 32.7274 35.84 35.3659Z"
        fill={color}
      />
    </svg>
  );
};

export const IconInfoTransparent = ({
  className,
  width = "24",
  height = "24",
  color = "#8B1516",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9826 2C15.075 2 15.6212 2.798 15.6212 3.71238C15.6212 4.85425 14.6723 5.91037 13.4372 5.91037C12.4027 5.91037 11.7995 5.25413 11.828 4.16913C11.828 3.2565 12.5462 2 13.9826 2ZM10.6215 19.5C9.75897 19.5 9.12717 18.9295 9.73043 16.4165L10.7201 11.961C10.8921 11.2487 10.9207 10.9626 10.7201 10.9626C10.4617 10.9626 9.34321 11.4544 8.68043 11.94L8.25 11.17C10.3467 9.25725 12.759 8.13637 13.7943 8.13637C14.656 8.13637 14.7995 9.25025 14.369 10.9626L13.2351 15.6456C13.0345 16.4725 13.1201 16.7577 13.3215 16.7577C13.5799 16.7577 14.4277 16.4148 15.2609 15.7016L15.75 16.4139C13.7103 18.6425 11.4823 19.5 10.6215 19.5Z"
        fill={color}
      />
    </svg>
  );
};

export const IconLocationTransparent = ({
  className,
  width = "24",
  height = "24",
  color = "#8B1516",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9802 15.7819L12.2249 20.416L7.4696 15.7819C6.60228 14.9464 6.01909 13.9554 5.72001 12.809C5.42094 11.7015 5.42094 10.594 5.72001 9.48643C6.01909 8.34003 6.59979 7.34665 7.46212 6.50629C8.32445 5.66593 9.34379 5.09516 10.5202 4.79399C11.6566 4.51225 12.7931 4.51225 13.9296 4.79399C15.106 5.09516 16.1253 5.66593 16.9876 6.50629C17.85 7.34665 18.4307 8.34003 18.7297 9.48643C19.0288 10.594 19.0288 11.7015 18.7297 12.809C18.4307 13.9554 17.8475 14.9464 16.9802 15.7819ZM12.2249 12.605C12.494 12.605 12.7433 12.5394 12.9726 12.4083C13.2018 12.2771 13.3838 12.0998 13.5184 11.8764C13.653 11.6529 13.7202 11.41 13.7202 11.1477C13.7202 10.8854 13.653 10.6425 13.5184 10.4191C13.3838 10.1956 13.2018 10.0183 12.9726 9.88718C12.7433 9.75602 12.494 9.69044 12.2249 9.69044C11.9557 9.69044 11.7065 9.75602 11.4772 9.88718C11.2479 10.0183 11.066 10.1956 10.9314 10.4191C10.7968 10.6425 10.7295 10.8854 10.7295 11.1477C10.7295 11.41 10.7968 11.6529 10.9314 11.8764C11.066 12.0998 11.2479 12.2771 11.4772 12.4083C11.7065 12.5394 11.9557 12.605 12.2249 12.605Z"
        fill={color}
      />
    </svg>
  );
};

export const IconDarkClose = ({
  className,
  width = "44",
  height = "44",
  color = "#C5C5C5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 16L16 28"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 16L28 28"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconLocationOutline = ({
  className,
  width = "24",
  height = "24",
  color = "#7D7D7D",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 10C20 16 12 22 12 22C12 22 4 16 4 10C4 7.87827 4.84285 5.84344 6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconUserRoundOutline = ({
  className,
  width = "24",
  height = "24",
  color = "#7d7d7d",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 21C20 18.8783 19.1571 16.8434 17.6569 15.3431C16.1566 13.8429 14.1217 13 12 13C9.87827 13 7.84344 13.8429 6.34315 15.3431C4.84285 16.8434 4 18.8783 4 21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconPauseTransparent = ({
  className,
  width = "20",
  height = "20",
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 4.66667C11.3333 4.29848 11.6318 4 12 4H14C14.3682 4 14.6666 4.29848 14.6666 4.66667V15.3333C14.6666 15.7015 14.3682 16 14 16H12C11.6318 16 11.3333 15.7015 11.3333 15.3333V4.66667Z"
        fill={color}
      />
      <path
        d="M5.33331 4.66667C5.33331 4.29848 5.63179 4 5.99998 4H7.99998C8.36817 4 8.66665 4.29848 8.66665 4.66667V15.3333C8.66665 15.7015 8.36817 16 7.99998 16H5.99998C5.63179 16 5.33331 15.7015 5.33331 15.3333V4.66667Z"
        fill={color}
      />
    </svg>
  );
};

export const IconPlayTransparent = ({
  className,
  width = "20",
  height = "20",
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8319 10.8661C16.499 10.4813 16.499 9.51843 15.8319 9.13362L7.16614 4.13526C6.49948 3.75073 5.6665 4.23187 5.6665 5.00149L5.6665 14.9982C5.6665 15.7678 6.49948 16.249 7.16614 15.8644L15.8319 10.8661Z"
        fill={color}
      />
    </svg>
  );
};

export const IconPhoneOutline = ({
  className,
  width = "24",
  height = "24",
  color = "#7D7D7D",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9999 16.9201V19.9201C22.0011 20.1986 21.944 20.4743 21.8324 20.7294C21.7209 20.9846 21.5572 21.2137 21.352 21.402C21.1468 21.5902 20.9045 21.7336 20.6407 21.8228C20.3769 21.912 20.0973 21.9452 19.8199 21.9201C16.7428 21.5857 13.7869 20.5342 11.1899 18.8501C8.77376 17.3148 6.72527 15.2663 5.18993 12.8501C3.49991 10.2413 2.44818 7.27109 2.11993 4.1801C2.09494 3.90356 2.12781 3.62486 2.21643 3.36172C2.30506 3.09859 2.4475 2.85679 2.6347 2.65172C2.82189 2.44665 3.04974 2.28281 3.30372 2.17062C3.55771 2.05843 3.83227 2.00036 4.10993 2.0001H7.10993C7.59524 1.99532 8.06572 2.16718 8.43369 2.48363C8.80166 2.80008 9.04201 3.23954 9.10993 3.7201C9.23656 4.68016 9.47138 5.62282 9.80993 6.5301C9.94448 6.88802 9.9736 7.27701 9.89384 7.65098C9.81408 8.02494 9.6288 8.36821 9.35993 8.6401L8.08993 9.9101C9.51349 12.4136 11.5864 14.4865 14.0899 15.9101L15.3599 14.6401C15.6318 14.3712 15.9751 14.1859 16.3491 14.1062C16.723 14.0264 17.112 14.0556 17.4699 14.1901C18.3772 14.5286 19.3199 14.7635 20.2799 14.8901C20.7657 14.9586 21.2093 15.2033 21.5265 15.5776C21.8436 15.9519 22.0121 16.4297 21.9999 16.9201Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconPrinterOutline = ({
  className,
  width = "24",
  height = "24",
  color = "#7d7d7d",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9V2H18V9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H18"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 14H6V22H18V14Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconGlobeOutline = ({
  className,
  width = "24",
  height = "24",
  color = "#7d7d7d",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2C9.43223 4.69615 8 8.27674 8 12C8 15.7233 9.43223 19.3038 12 22C14.5678 19.3038 16 15.7233 16 12C16 8.27674 14.5678 4.69615 12 2Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12H22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconEmailOutline = ({
  className,
  width = "24",
  height = "24",
  color = "#7d7d7d",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 7L13.03 12.7C12.7213 12.8934 12.3643 12.996 12 12.996C11.6357 12.996 11.2787 12.8934 10.97 12.7L2 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconWarning = ({
  className,
  width = "24",
  height = "24",
  color = "#EB4D4D",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9.00006V13.0001M4.37891 15.1999C3.46947 16.775 3.01489 17.5629 3.08281 18.2092C3.14206 18.7729 3.43792 19.2851 3.89648 19.6182C4.42204 20.0001 5.3309 20.0001 7.14853 20.0001H16.8515C18.6691 20.0001 19.5778 20.0001 20.1034 19.6182C20.5619 19.2851 20.8579 18.7729 20.9172 18.2092C20.9851 17.5629 20.5307 16.775 19.6212 15.1999L14.7715 6.79986C13.8621 5.22468 13.4071 4.43722 12.8135 4.17291C12.2957 3.94236 11.704 3.94236 11.1862 4.17291C10.5928 4.43711 10.1381 5.22458 9.22946 6.79845L4.37891 15.1999ZM12.0508 16.0001V16.1001L11.9502 16.1003V16.0001H12.0508Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// OPTIONS ICONS

export const IconTopPreHeat = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2186 41.209C13.1536 41.2371 13.0621 41.2551 12.9619 41.2486C12.9059 41.245 12.8578 41.2344 12.8191 41.2213C14.2267 38.7872 14.5218 36.785 13.9974 34.8044C13.4911 32.8923 12.2285 31.0689 10.784 28.983L10.7237 28.8959C7.81698 24.6984 9.61176 19.0325 14.7848 16.7908C14.8498 16.7628 14.9412 16.7448 15.0413 16.7513C15.0973 16.7549 15.1454 16.7655 15.1841 16.7786C13.7765 19.212 13.4814 21.2138 14.0057 23.1941C14.5118 25.1058 15.774 26.9289 17.2178 29.0142L17.2784 29.1017C20.1846 33.3018 18.3899 38.9676 13.2186 41.209ZM34.8191 41.2221C36.2267 38.7879 36.5218 36.7857 35.9974 34.8052C35.4911 32.8931 34.2285 31.0696 32.7841 28.9837L32.7238 28.8967C29.8179 24.699 31.6129 19.0324 36.785 16.7908C36.85 16.7628 36.9413 16.7449 37.0413 16.7513C37.0973 16.7549 37.1454 16.7655 37.1841 16.7786C35.7765 19.212 35.4814 21.2138 36.0057 23.1942C36.5118 25.1057 37.7738 26.9288 39.2173 29.0143L39.2784 29.1025C42.1845 33.3018 40.3892 38.9684 35.2181 41.2099C35.1532 41.2379 35.0619 41.2558 34.9619 41.2493C34.9059 41.2457 34.8578 41.2352 34.8191 41.2221ZM26.0413 16.7513C26.0973 16.7549 26.1454 16.7655 26.1841 16.7786C24.7765 19.212 24.4814 21.2138 25.0057 23.1942C25.5118 25.1058 26.7738 26.9289 28.2174 29.0143L28.2784 29.1024C31.1844 33.3023 29.3892 38.9681 24.2186 41.2097C24.1536 41.2378 24.0621 41.2558 23.9619 41.2493C23.9059 41.2457 23.8578 41.2352 23.8191 41.2221C25.2267 38.7879 25.5218 36.7857 24.9974 34.8052C24.4911 32.8931 23.2285 31.0696 21.784 28.9837L21.7238 28.8967C18.818 24.6991 20.6129 19.0323 25.785 16.7908C25.85 16.7628 25.9413 16.7449 26.0413 16.7513Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M43 8H5C4.44772 8 4 8.44772 4 9C4 9.55228 4.44772 10 5 10H43C43.5523 10 44 9.55228 44 9C44 8.44772 43.5523 8 43 8Z"
        fill={color}
      />
    </svg>
  );
};

export const IconTypeCnArrowLoop = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.128 14.4819L29.0004 15.5228L30.535 15.5228L35.75 15.5228C41.6069 15.5228 46.4 20.416 46.4 26.4614C46.4 32.4481 41.1072 37.4 34.5 37.4L14.5 37.4C7.89275 37.4 2.6 32.4481 2.6 26.4614C2.6 20.4747 7.89275 15.5228 14.5 15.5228C15.0187 15.5228 15.5075 15.7135 15.8608 16.0396C16.2125 16.3643 16.4 16.7938 16.4 17.2305C16.4 17.6672 16.2125 18.0968 15.8608 18.4215C15.5075 18.7476 15.0187 18.9382 14.5 18.9382C10.0797 18.9382 6.4 22.2688 6.4 26.4614C6.4 30.654 10.0797 33.9846 14.5 33.9846L34.5 33.9846C38.9202 33.9846 42.6 30.6541 42.6 26.4614C42.6 22.3724 39.5852 18.9383 35.75 18.9383L30.535 18.9383L29.0004 18.9383L30.128 19.9791L33.3605 22.963L33.3609 22.9634C33.5354 23.1242 33.6711 23.3126 33.7627 23.5164C33.8542 23.7201 33.9005 23.9365 33.9005 24.1537C33.9005 24.3709 33.8542 24.5873 33.7627 24.791C33.6711 24.9948 33.5354 25.1832 33.3609 25.344L33.3593 25.3455C33.1853 25.507 32.976 25.6375 32.7421 25.7273C32.5082 25.8171 32.2558 25.8638 32 25.8638C31.7442 25.8638 31.4918 25.8171 31.2579 25.7273C31.024 25.6375 30.8147 25.507 30.6407 25.3455L30.6395 25.3444L21.8496 17.2305L30.6395 9.1167C30.814 8.95562 31.0237 8.82556 31.2577 8.73607C31.4918 8.64657 31.7442 8.60001 32 8.60001C32.2558 8.60001 32.5082 8.64657 32.7423 8.73607C32.9763 8.82556 33.186 8.95563 33.3605 9.1167C33.5349 9.27768 33.6705 9.46617 33.7619 9.67002L34.3093 9.42438L33.7619 9.67002C33.8533 9.87372 33.8996 10.0901 33.8996 10.3074C33.8996 10.5246 33.8533 10.741 33.7619 10.9447L34.3093 11.1904L33.7619 10.9447C33.6705 11.1486 33.5349 11.3371 33.3605 11.4981L30.128 14.4819Z"
        fill={color}
        stroke="#F6F6F6"
        strokeWidth="1.2"
      />
    </svg>
  );
};

export const IconBottomPreHeat = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.72313 20.8959L9.7231 20.8958C6.81639 16.6983 8.61119 11.0325 13.7843 8.79081C13.8493 8.76279 13.9406 8.74485 14.0407 8.75131C14.0967 8.75494 14.1448 8.76549 14.1835 8.77858C12.7759 11.212 12.4808 13.2138 13.0051 15.1941C13.5112 17.1058 14.7734 18.9288 16.2172 21.0142L16.2778 21.1017C19.1838 25.3016 17.3887 30.9674 12.218 33.209C12.153 33.2371 12.0615 33.2551 11.9613 33.2486C11.9053 33.245 11.8572 33.2344 11.8185 33.2213C13.2261 30.7872 13.5212 28.785 12.9968 26.8044C12.4905 24.8923 11.2279 23.0689 9.78344 20.983L9.72313 20.8959ZM25.1835 8.77858C23.7759 11.212 23.4808 13.2138 24.0051 15.1942C24.5112 17.1058 25.7732 18.9289 27.2168 21.0143L27.2778 21.1024C27.2778 21.1025 27.2778 21.1025 27.2778 21.1025C30.1838 25.3024 28.3886 30.9681 23.218 33.2097C23.153 33.2378 23.0615 33.2558 22.9613 33.2493C22.9053 33.2457 22.8572 33.2352 22.8185 33.2221C24.2261 30.7879 24.5212 28.7857 23.9968 26.8052C23.4905 24.8931 22.2279 23.0696 20.7834 20.9837L20.7232 20.8967C17.8173 16.699 19.6123 11.0323 24.7845 8.7907C24.8495 8.76274 24.9408 8.74486 25.0407 8.75131C25.0967 8.75494 25.1448 8.76549 25.1835 8.77858ZM36.1835 8.77858C34.7759 11.212 34.4808 13.2138 35.0051 15.1942C35.5112 17.1057 36.7732 18.9288 38.2167 21.0143L38.2778 21.1025C41.1838 25.3016 39.3887 30.9681 34.218 33.2097C34.153 33.2378 34.0615 33.2558 33.9613 33.2493C33.9053 33.2457 33.8572 33.2352 33.8185 33.2221C35.2261 30.7879 35.5212 28.7857 34.9968 26.8052C34.4905 24.8931 33.2279 23.0696 31.7835 20.9837L31.7232 20.8967C28.8173 16.699 30.6123 11.0323 35.7845 8.7907C35.8495 8.76274 35.9408 8.74486 36.0407 8.75131C36.0967 8.75494 36.1448 8.76549 36.1835 8.77858Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <rect x="4" y="40" width="40" height="2" rx="1" fill="black" />
    </svg>
  );
};

export const IconTypeCnArrowLoopReverse = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.872 33.5181L18.9996 32.4772L17.465 32.4772L12.25 32.4772C6.39308 32.4772 1.6 27.584 1.6 21.5386C1.6 15.5519 6.89276 10.6 13.5 10.6L33.5 10.6C40.1072 10.6 45.4 15.5519 45.4 21.5386C45.4 27.5253 40.1072 32.4772 33.5 32.4772C32.9813 32.4772 32.4925 32.2865 32.1392 31.9604C31.7875 31.6357 31.6 31.2062 31.6 30.7695C31.6 30.3328 31.7875 29.9032 32.1392 29.5785C32.4925 29.2524 32.9813 29.0618 33.5 29.0618C37.9203 29.0618 41.6 25.7312 41.6 21.5386C41.6 17.346 37.9203 14.0154 33.5 14.0154L13.5 14.0154C9.07975 14.0154 5.4 17.3459 5.4 21.5386C5.4 25.6276 8.41477 29.0618 12.25 29.0618L17.465 29.0618L18.9996 29.0618L17.872 28.0209L14.6395 25.037L14.6391 25.0366C14.4645 24.8758 14.3289 24.6874 14.2373 24.4836C14.1458 24.2799 14.0995 24.0635 14.0995 23.8463C14.0995 23.6291 14.1458 23.4127 14.2373 23.2091C14.3289 23.0052 14.4645 22.8168 14.6391 22.656L14.6407 22.6545C14.8147 22.493 15.024 22.3625 15.2579 22.2727C15.4918 22.1829 15.7442 22.1362 16 22.1362C16.2558 22.1362 16.5082 22.1829 16.7421 22.2727C16.976 22.3625 17.1853 22.493 17.3593 22.6545L17.3605 22.6556L26.1504 30.7695L17.3605 38.8833C17.186 39.0444 16.9763 39.1744 16.7423 39.2639C16.5082 39.3534 16.2558 39.4 16 39.4C15.7442 39.4 15.4918 39.3534 15.2577 39.2639C15.0237 39.1744 14.814 39.0444 14.6395 38.8833C14.4651 38.7223 14.3295 38.5338 14.2381 38.33L13.6907 38.5756L14.2381 38.33C14.1467 38.1263 14.1004 37.9099 14.1004 37.6926C14.1004 37.4754 14.1467 37.259 14.2381 37.0553L13.6907 36.8096L14.2381 37.0553C14.3295 36.8514 14.4651 36.6629 14.6395 36.502L17.872 33.5181Z"
        fill={color}
        stroke="#F6F6F6"
        strokeWidth="1.2"
      />
    </svg>
  );
};

export const IconFluxHead = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1494_7448)">
        <path
          d="M5.73717 26.4993H6.73717V25.4993V24.2812H8.10576H9.10576V23.2812V21.1746L11.6586 15.1105L14.2115 21.1746V23.2812V24.2812H15.2115H16.5801V25.0706C16.4452 25.13 16.2911 25.1985 16.1155 25.2794C15.6921 25.4744 15.1414 25.7444 14.7525 26.0606C14.5727 26.2069 14.2852 26.4734 14.1579 26.8686C14.0861 27.0917 14.0666 27.3538 14.1466 27.6241C14.2147 27.8544 14.3388 28.0363 14.4716 28.1743C14.4775 28.2095 14.4845 28.2813 14.4769 28.4066C14.4589 28.7058 14.3692 29.1056 14.2283 29.5929C14.1598 29.8297 14.084 30.0716 14.0058 30.3191C13.9979 30.344 13.99 30.3691 13.9821 30.3942C13.9126 30.6141 13.8413 30.8396 13.7774 31.055C13.6454 31.4999 13.5 32.0402 13.5 32.5V51C13.5 51.0396 13.5018 51.0782 13.5052 51.1159H5.73717H4.73717V52.1159V53.3899V54.3899H5.73717H17.5801H18.106C18.6288 54.6393 19.0983 54.8699 19.4731 55.078C18.9072 55.3839 18.2556 55.552 17.5801 55.552H5.73717C4.7256 55.552 3.7676 55.1751 3.07102 54.5228C2.37666 53.8726 2 53.0052 2 52.1159V29.9354C2 29.0461 2.37666 28.1787 3.07102 27.5285C3.7676 26.8762 4.7256 26.4993 5.73717 26.4993Z"
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M19.6449 23.2209H21.0158V21.8499V19.7447H23.3569H24.7279V18.3737V15.0325L28.9251 5.0627L33.1222 15.0325V18.3737V19.7447H34.4932H36.8343V21.8499V23.2209H38.2053C39.8387 23.2209 41.3885 23.8294 42.5178 24.8869C43.6441 25.9416 44.2585 27.3521 44.2585 28.8022V63.5638C44.2585 65.014 43.6441 66.4245 42.5178 67.4792C41.3885 68.5367 39.8387 69.1452 38.2053 69.1452H19.6449C18.0115 69.1452 16.4616 68.5367 15.3323 67.4792C14.206 66.4245 13.5917 65.014 13.5917 63.5638V28.8022C13.5917 27.3521 14.206 25.9416 15.3323 24.8869C16.4616 23.8293 18.0115 23.2209 19.6449 23.2209ZM18.2739 65.5604V66.9314H19.6449H38.2053H39.5763V65.5604V63.5638V62.1929H38.2053H19.6449H18.2739V63.5638V65.5604Z"
          stroke="#F6F6F6"
          strokeWidth="2.74195"
        />
        <path
          d="M21.016 24.221H22.016V23.221V20.7448H24.728H25.728V19.7448V16.3287L30.2962 5.47768L34.8643 16.3287V19.7448V20.7448H35.8643H38.5764V23.221V24.221H39.5764C41.3006 24.221 42.942 24.863 44.1425 25.9872C45.3408 27.1093 46.0005 28.6167 46.0005 30.1733V46.9349H14.811L14.5918 45.8957V30.1733C14.5918 28.6167 15.2516 27.1093 16.4498 25.9872C17.6503 24.863 19.2917 24.221 21.016 24.221ZM14.5918 48.9818L46.0005 48.9364V64.9349C46.0005 66.4916 45.3408 67.9989 44.1425 69.1211C42.942 70.2452 41.3006 70.8873 39.5764 70.8873H21.016C19.2917 70.8873 17.6503 70.2452 16.4498 69.1211C15.2516 67.9989 14.5918 66.4916 14.5918 64.9349V48.9818Z"
          stroke={color}
          strokeWidth="2"
        />
        <rect x="1" y="46" width="46" height="2" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_1494_7448">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconFiducialCorrection = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1399_2644)">
        <path
          d="M23.9989 39.4275C26.025 39.4275 28.0313 39.0284 29.9031 38.253C31.775 37.4777 33.4759 36.3412 34.9085 34.9085C36.3412 33.4759 37.4777 31.775 38.253 29.9031C39.0284 28.0313 39.4275 26.025 39.4275 23.9989C39.4275 21.9728 39.0284 19.9665 38.253 18.0946C37.4777 16.2227 36.3412 14.5219 34.9085 13.0892C33.4759 11.6566 31.775 10.5201 29.9031 9.74474C28.0313 8.96938 26.025 8.57031 23.9989 8.57031C19.907 8.57031 15.9827 10.1958 13.0892 13.0892C10.1958 15.9827 8.57031 19.907 8.57031 23.9989C8.57031 28.0908 10.1958 32.0151 13.0892 34.9085C15.9827 37.8019 19.907 39.4275 23.9989 39.4275Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.9986 8.57003V1.71289M23.9986 46.2843V39.4272M39.4272 23.9986H46.2843M1.71289 23.9986H8.57003M23.9986 25.7129C24.4533 25.7129 24.8893 25.5323 25.2108 25.2108C25.5323 24.8893 25.7129 24.4533 25.7129 23.9986C25.7129 23.5439 25.5323 23.1079 25.2108 22.7864C24.8893 22.4649 24.4533 22.2843 23.9986 22.2843C23.5439 22.2843 23.1079 22.4649 22.7864 22.7864C22.4649 23.1079 22.2843 23.5439 22.2843 23.9986C22.2843 24.4533 22.4649 24.8893 22.7864 25.2108C23.1079 25.5323 23.5439 25.7129 23.9986 25.7129Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1399_2644">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconBoardMaquette = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1450_2663)">
        <path
          d="M1 38.4753V8.32235C1.25854 7.94722 1.6134 7.81541 2.06965 7.85597C2.43465 7.88638 2.80472 7.86104 3.17479 7.86104C3.91999 7.86104 4.67027 7.86104 5.44589 7.86104C5.44589 7.44027 5.47124 7.0702 5.44082 6.70521C5.40533 6.25403 5.53207 5.89917 5.90721 5.64062H9.42539C9.80053 5.90424 9.93233 6.2591 9.89178 6.71534C9.86136 7.09048 9.88671 7.47069 9.88671 7.83569H11.367H11.545H15.0632L15.8179 7.84076L17.2881 7.84076C17.2881 7.45041 17.3134 7.08034 17.283 6.72041C17.2475 6.26923 17.3743 5.9093 17.7494 5.65076H21.2676C21.6427 5.91437 21.7745 6.26923 21.734 6.72548C21.7036 7.10062 21.7289 7.48083 21.7289 7.87117C21.9874 7.87117 22.1699 7.87117 22.3575 7.87117C26.7679 7.87117 31.1783 7.87117 35.5938 7.87117C36.2579 7.87117 36.4961 8.08916 36.5468 8.72791C36.6432 9.93443 37.5911 10.8317 38.7723 10.8317C39.9484 10.8317 40.8863 9.93443 40.9877 8.71777C41.0383 8.10437 41.2766 7.87624 41.9052 7.87624C43.2638 7.87624 44.6224 7.87624 45.976 7.87624C46.6654 7.87624 46.9138 8.13478 46.9138 8.83437C46.9138 18.5575 46.9138 28.2858 46.9138 38.0089C46.9138 38.6984 46.6553 38.9468 45.9557 38.9468C44.6427 38.9468 43.3348 38.9468 42.0218 38.9468C41.2411 38.9468 41.0637 38.7795 40.9826 37.9887C40.8609 36.8632 39.9231 36.0014 38.8027 35.9862C37.657 35.971 36.6888 36.8278 36.557 37.9684C36.4607 38.7947 36.2984 38.9468 35.4873 38.9468C24.3498 38.9468 13.2123 38.9468 2.07979 38.9569C1.62861 38.9569 1.26868 38.8606 1.00507 38.4855L1 38.4753ZM45.393 37.4462V9.35652H42.4122C41.7379 11.2423 40.5618 12.2664 38.9497 12.2866C36.9169 12.3171 35.685 11.2373 35.1021 9.36159H33.5762C33.5762 9.51874 33.5762 9.65561 33.5762 9.78742C33.5762 11.6226 33.566 13.4577 33.5863 15.2877C33.5863 15.5159 33.708 15.7947 33.8651 15.9569C35.3099 17.4321 36.7851 18.882 38.235 20.3521C38.4428 20.565 38.6101 20.6208 38.9092 20.5346C39.8825 20.2456 40.9167 20.6766 41.4135 21.5434C41.9204 22.4204 41.7734 23.5154 41.0586 24.2252C40.3388 24.9399 39.2488 25.0768 38.3718 24.5699C37.51 24.0629 37.0791 23.0389 37.3782 22.0656C37.4695 21.7614 37.3934 21.5941 37.1856 21.3913C35.6293 19.8502 34.0882 18.2939 32.5319 16.7579C32.2226 16.4537 32.0807 16.1394 32.0857 15.6984C32.106 13.7568 32.0959 11.8152 32.0959 9.8736V9.37172H29.1353H27.65H21.7644C21.7492 9.41735 21.739 9.43256 21.739 9.4427C21.739 9.85839 21.739 10.2741 21.7289 10.6898C21.7188 11.2677 21.4551 11.5465 20.8823 11.5516C19.9749 11.5617 19.0624 11.5617 18.1499 11.5516C17.5517 11.5516 17.2931 11.2728 17.283 10.6594C17.283 10.2335 17.283 9.80263 17.283 9.36159H15.8027C15.8027 8.93575 15.8027 9.81783 15.8027 9.36159C15.8027 9.36159 15.4905 9.35652 14.8822 9.36159C13.9899 9.36666 13.0926 9.36666 12.2004 9.36159C11.5972 9.36159 11.3619 9.36159 11.3619 9.36159C11.3568 8.92055 11.3619 9.79249 11.3619 9.36159H9.94247C9.91206 9.39707 9.89685 9.40721 9.89685 9.42242C9.89178 9.83811 9.88671 10.2538 9.88164 10.6695C9.8715 11.2778 9.61296 11.5516 9.01477 11.5566C8.12255 11.5617 7.22526 11.5617 6.33304 11.5566C5.7095 11.5566 5.45096 11.2829 5.44589 10.6442C5.44589 10.2183 5.44589 9.79249 5.44589 9.37679H2.50562V37.4361H35.1223C35.6901 35.3323 37.2667 34.5719 38.4479 34.5161C40.5415 34.4248 41.819 35.5097 42.4274 37.4462H45.393ZM8.38616 7.15638H6.94644V10.0561H8.38616V7.15638ZM20.2182 10.0612V7.15638H18.7937V10.0561H20.2182V10.0612ZM39.5378 21.9186C39.1424 21.8983 38.7926 22.2075 38.7672 22.608C38.7368 23.0237 39.0714 23.3836 39.4922 23.3938C39.8876 23.3988 40.2272 23.0795 40.2425 22.679C40.2577 22.2836 39.9383 21.9388 39.5429 21.9186H39.5378Z"
          fill={color}
        />
        <path
          d="M27.6547 28.5945H21.7285C21.7285 29.0558 21.7336 29.4968 21.7285 29.9379C21.7184 30.5158 21.4497 30.7845 20.8769 30.7946C20.446 30.8048 20.0151 30.7946 19.5335 30.7946L18.0431 30.8301H16.5527L15.0825 30.82H13.6124V33.7197H12.122V30.8301H10.6316V33.7298H9.16143V30.7946C8.70011 30.7946 8.28948 30.7946 7.87886 30.7946C7.17928 30.7946 6.92581 30.5411 6.92074 29.8568C6.92074 29.4461 6.92074 29.0305 6.92074 28.5894H3.99061V27.1193H6.88018V25.6339H3.98047V24.1638H6.88525V22.6785L6.89539 21.1931V19.723V18.2528L6.92074 16.8841C6.93088 16.2808 7.19449 16.0223 7.80282 16.0122C8.21851 16.0071 8.6342 16.002 9.0499 15.997C9.06004 15.997 9.07525 15.9817 9.12087 15.9463V13.0871H10.6113V15.9868H12.0814V13.082H13.5718V15.9767H15.042V15.9817H16.5324H18.0025L19.4929 16.0071C19.9644 16.0071 20.4054 16.0071 20.8465 16.0071C21.4548 16.0172 21.7184 16.2808 21.7285 16.879C21.7336 17.3099 21.7285 17.7358 21.7285 18.2174H24.6688V19.6875H21.759V21.1576H24.6637V22.643H21.7691V24.1131V25.6289V27.1091C21.9313 27.1091 22.0935 27.1091 22.2558 27.1091C24.2126 27.1091 26.1744 27.1091 28.1312 27.1091C28.8916 27.1091 29.135 27.3474 29.135 28.0926C29.135 29.1724 29.1451 30.2522 29.135 31.332C29.135 31.5804 29.2059 31.7071 29.429 31.8237C30.3719 32.3307 30.8028 33.3192 30.5443 34.3179C30.2857 35.3216 29.4087 35.9959 28.3746 35.9857C27.3657 35.9756 26.509 35.3013 26.2505 34.3128C25.9919 33.3141 26.433 32.3357 27.3607 31.8034C27.4823 31.7325 27.6395 31.5804 27.6446 31.4638C27.6699 30.5259 27.6598 29.5881 27.6598 28.6046L27.6547 28.5945ZM20.2178 29.2941V17.5127H8.43143V29.2941H20.2229H20.2178ZM28.3847 34.4902C28.7801 34.4902 29.1198 34.1709 29.1299 33.7754C29.1451 33.3597 28.7953 33.01 28.3796 33.015C27.9842 33.0201 27.6547 33.3597 27.6547 33.7552C27.6547 34.1556 27.9842 34.4852 28.3847 34.4902Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1450_2663">
          <rect
            width="46"
            height="33.3873"
            fill="white"
            transform="translate(1 5.64453)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconFlowMeter = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1472_2554)">
        <path
          d="M26.3811 37.9689H26.1811H25.2632H25.0589L25.0632 37.7647C25.0716 37.3661 25.0684 36.7025 25.0656 36.1182C25.0648 35.9359 25.0639 35.7612 25.0635 35.6048H23.8476V37.7689V37.9689H23.6476H22.7541H22.5541V37.7689V35.5497H22.5538H22.5511H22.5485H22.5458H22.5432H22.5405H22.5379H22.5352H22.5326H22.5299H22.5273H22.5246H22.522H22.5194H22.5167H22.5141H22.5115H22.5088H22.5062H22.5036H22.5009H22.4983H22.4957H22.493H22.4904H22.4878H22.4852H22.4826H22.4799H22.4773H22.4747H22.4721H22.4695H22.4669H22.4642H22.4616H22.459H22.4564H22.4538H22.4512H22.4486H22.446H22.4434H22.4408H22.4382H22.4356H22.433H22.4304H22.4278H22.4252H22.4226H22.42H22.4174H22.4148H22.4122H22.4096H22.4071H22.4045H22.4019H22.3993H22.3967H22.3941H22.3916H22.389H22.3864H22.3838H22.3813H22.3787H22.3761H22.3735H22.371H22.3684H22.3658H22.3633H22.3607H22.3581H22.3556H22.353H22.3504H22.3479H22.3453H22.3428H22.3402H22.3376H22.3351H22.3325H22.33H22.3274H22.3249H22.3223H22.3198H22.3172H22.3147H22.3121H22.3096H22.307H22.3045H22.302H22.2994H22.2969H22.2943H22.2918H22.2893H22.2867H22.2842H22.2817H22.2791H22.2766H22.2741H22.2715H22.269H22.2665H22.2639H22.2614H22.2589H22.2564H22.2538H22.2513H22.2488H22.2463H22.2438H22.2412H22.2387H22.2362H22.2337H22.2312H22.2287H22.2262H22.2236H22.2211H22.2186H22.2161H22.2136H22.2111H22.2086H22.2061H22.2036H22.2011H22.1986H22.1961H22.1936H22.1911H22.1886H22.1861H22.1836H22.1811H22.1786H22.1761H22.1736H22.1711H22.1686H22.1661H22.1636H22.1611H22.1587H22.1562H22.1537H22.1512H22.1487H22.1462H22.1437H22.1413H22.1388H22.1363H22.1338H22.1313H22.1289H22.1264H22.1239H22.1214H22.119H22.1165H22.114H22.1115H22.1091H22.1066H22.1041H22.1017H22.0992H22.0967H22.0943H22.0918H22.0893H22.0869H22.0844H22.0819H22.0795H22.077H22.0745H22.0721H22.0696H22.0672H22.0647H22.0622H22.0598H22.0573H22.0549H22.0524H22.05H22.0475H22.0451H22.0426H22.0402H22.0377H22.0353H22.0328H22.0304H22.0279H22.0255H22.023H22.0206H22.0181H22.0157H22.0133H22.0108H22.0084H22.0059H22.0035H22.001H21.9986H21.9962H21.9937H21.9913H21.9889H21.9864H21.984H21.9816H21.9791H21.9767H21.9743H21.9718H21.9694H21.967H21.9645H21.9621H21.9597H21.9572H21.9548H21.9524H21.95H21.9475H21.9451H21.9427H21.9403H21.9378H21.9354H21.933H21.9306H21.9282H21.9257H21.9233H21.9209H21.9185H21.9161H21.9136H21.9112H21.9088H21.9064H21.904H21.9016H21.8991H21.8967H21.8943H21.8919H21.8895H21.8871H21.8847H21.8823H21.8798H21.8774H21.875H21.8726H21.8702H21.8678H21.8654H21.863H21.8606H21.8582H21.8558H21.8534H21.851H21.8486H21.8461H21.8437H21.8413H21.8389H21.8365H21.8341H21.8317H21.8293H21.8269H21.8245H21.8221H21.8197H21.8173H21.8149H21.8125H21.8102H21.8078H21.8054H21.803H21.8006H21.7982H21.7958H21.7934H21.791H21.7886H21.7862H21.7838H21.7814H21.779H21.7766H21.7743H21.7719H21.7695H21.7671H21.7647H21.7623H21.7599H21.7575H21.7551H21.7528H21.7504H21.748H21.7456H21.7432H21.7408H21.7384H21.736H21.7337H21.7313H21.7289H21.7265H21.7241H21.7217H21.7194H21.717H21.7146H21.7122H21.7098H21.7075H21.7051H21.7027H21.7003H21.6979H21.6956H21.6932H21.6908H21.6884H21.686H21.6837H21.6813H21.6789H21.6765H21.6741H21.6718H21.6694H21.667H21.6646H21.6623H21.6599H21.6575H21.6551H21.6528H21.6504H21.648H21.6456H21.6433H21.6409H21.6385H21.6361H21.6338H21.6314H21.629H21.6266H21.6243H21.6219H21.6195H21.6172H21.6148H21.6124H21.61H21.6077H21.6053H21.6029H21.6006H21.5982H21.5958H21.5934H21.5911H21.5887H21.5863H21.584H21.5816H21.5792H21.5769H21.5745H21.5721H21.5697H21.5674H21.565H21.5626H21.5603H21.5579H21.5555H21.5532H21.5508H21.5484H21.5461H21.5437H21.5413H21.539H21.5366H21.5342H21.5319H21.5295H21.5271H21.5248H21.5224H21.52H21.5177H21.5153H21.5129H21.5106H21.5082H21.5058H21.5035H21.5011H21.4987H21.4964H21.494H21.4916H21.4893H21.4869H21.4845H21.4822H21.4798H21.4774H21.4751H21.4718L21.4718 35.5497C20.6806 35.5367 19.9936 35.2759 19.5124 34.8061C19.0293 34.3344 18.7698 33.6675 18.809 32.8777L18.8091 32.8773C18.8323 32.4273 18.7627 32.1285 18.6119 31.8977C18.4588 31.6633 18.2044 31.4717 17.8004 31.2726L17.8003 31.2725C12.0853 28.45 8.95953 21.736 10.3684 15.4686L10.3685 15.4685C12.3408 6.71042 21.3455 1.79408 29.6999 5.08624C38.0145 8.35885 41.3977 18.2156 36.8113 25.8737L36.8113 25.8738C35.2857 28.4184 33.1811 30.3325 30.4942 31.5746C30.3118 31.6603 30.2108 31.7399 30.1559 31.8241C30.1046 31.9026 30.0767 32.0113 30.1003 32.1946L30.1003 32.1947C30.1303 32.4285 30.1171 32.6718 30.1056 32.8858C30.1042 32.91 30.103 32.9338 30.1018 32.9571C30.1017 32.9578 30.1017 32.9585 30.1017 32.9591L29.9019 32.9489C29.8591 34.3392 28.8861 35.3129 27.4846 35.3497L26.3811 37.9689ZM26.3811 37.9689V37.7689V37.7653V37.7618V37.7583V37.7547V37.7511V37.7476V37.744V37.7404V37.7367V37.7331V37.7295V37.7258V37.7221V37.7185V37.7148V37.7111V37.7074V37.7037V37.6999V37.6962V37.6924V37.6887V37.6849V37.6811V37.6773V37.6735V37.6697V37.6658V37.662V37.6581V37.6543V37.6504V37.6465V37.6426V37.6387V37.6348V37.6309V37.6269V37.623V37.619V37.615V37.6111V37.6071V37.6031V37.5991V37.595V37.591V37.587V37.5829V37.5789V37.5748V37.5707V37.5666V37.5625V37.5584V37.5543V37.5502V37.546V37.5419V37.5377V37.5336V37.5294V37.5252V37.521V37.5168V37.5126V37.5084V37.5041V37.4999V37.4956V37.4914V37.4871V37.4828V37.4785V37.4742V37.4699V37.4656V37.4613V37.457V37.4526V37.4483V37.4439V37.4396V37.4352V37.4308V37.4264V37.422V37.4176V37.4132V37.4088V37.4044V37.3999V37.3955V37.391V37.3866V37.3821V37.3776V37.3731V37.3686V37.3641V37.3596V37.3551V37.3506V37.346V37.3415V37.3369V37.3324V37.3278V37.3233V37.3187V37.3141V37.3095V37.3049V37.3003V37.2957V37.2911V37.2864V37.2818V37.2772V37.2725V37.2679V37.2632V37.2585V37.2538V37.2492V37.2445V37.2398V37.2351V37.2304V37.2257V37.2209V37.2162V37.2115V37.2067V37.202V37.1972V37.1925V37.1877V37.1829V37.1782V37.1734V37.1686V37.1638V37.159V37.1542V37.1494V37.1445V37.1397V37.1349V37.1301V37.1252V37.1204V37.1155V37.1107V37.1058V37.1009V37.0961V37.0912V37.0863V37.0814V37.0765V37.0716V37.0667V37.0618V37.0569V37.052V37.047V37.0421V37.0372V37.0322V37.0273V37.0223V37.0174V37.0124V37.0075V37.0025V36.9975V36.9926V36.9876V36.9826V36.9776V36.9726V36.9676V36.9626V36.9576V36.9526V36.9476V36.9426V36.9376V36.9325V36.9275V36.9225V36.9174V36.9124V36.9073V36.9023V36.8973V36.8922V36.8871V36.8821V36.877V36.8719V36.8669V36.8618V36.8567V36.8516V36.8466V36.8415V36.8364V36.8313V36.8262V36.8211V36.816V36.8109V36.8058V36.8007V36.7956V36.7904V36.7853V36.7802V36.7751V36.77V36.7648V36.7597V36.7546V36.7494V36.7443V36.7391V36.734V36.7289V36.7237V36.7186V36.7134V36.7083V36.7031V36.698V36.6928V36.6876V36.6825V36.6773V36.6721V36.667V36.6618V36.6566V36.6515V36.6463V36.6411V36.6359V36.6308V36.6256V36.6204V36.6152V36.61V36.6049V36.5997V36.5945V36.5893V36.5841V36.5789V36.5737V36.5686V36.5634V36.5582V36.553V36.5478V36.5426V36.5374V36.5322V36.527V36.5218V36.5166V36.5114V36.5062V36.501V36.4958V36.4906V36.4855V36.4803V36.4751V36.4699V36.4647V36.4595V36.4543V36.4491V36.4439V36.4387V36.4335V36.4283V36.4231V36.4179V36.4127V36.4075V36.4023V36.3971V36.3919V36.3868V36.3816V36.3764V36.3712V36.366V36.3608V36.3556V36.3504V36.3453V36.3401V36.3349V36.3297V36.3245V36.3194V36.3142V36.309V36.3038V36.2987V36.2935V36.2883V36.2832V36.278V36.2728V36.2677V36.2625V36.2573V36.2522V36.247V36.2419V36.2367V36.2316V36.2264V36.2213V36.2161V36.211V36.2059V36.2007V36.1956V36.1905V36.1853V36.1802V36.1751V36.17V36.1648V36.1597V36.1546V36.1495V36.1444V36.1393V36.1342V36.1291V36.124V36.1189V36.1138V36.1087V36.1036V36.0985V36.0935V36.0884V36.0833V36.0783V36.0732V36.0681V36.0631V36.058V36.053V36.0479V36.0429V36.0378V36.0328V36.0278V36.0227V36.0177V36.0127V36.0077V36.0026V35.9976V35.9926V35.9876V35.9826V35.9776V35.9726V35.9677V35.9627V35.9577V35.9527V35.9478V35.9428V35.9378V35.9329V35.9279V35.923V35.918V35.9131V35.9082V35.9033V35.8983V35.8934V35.8885V35.8836V35.8787V35.8738V35.8689V35.864V35.8591V35.8543V35.8494V35.8445V35.8397V35.8348V35.83V35.8251V35.8203V35.8155V35.8106V35.8058V35.801V35.7962V35.7914V35.7866V35.7818V35.777V35.7722V35.7675V35.7627V35.7579V35.7532V35.7484V35.7437V35.7389V35.7342V35.7295V35.7248V35.7201V35.7153V35.7107V35.706V35.7013V35.6966V35.6919V35.6873V35.6826V35.678V35.6733V35.6687V35.664V35.6594V35.6548V35.6502V35.6456V35.641V35.6364V35.6318V35.6273V35.6227V35.6181V35.6136V35.609V35.6045V35.6V35.5955V35.5909V35.5864V35.5819V35.5774V35.573V35.5685V35.564V35.5596V35.5551V35.5507V35.5503C26.4753 35.5509 26.5674 35.5517 26.6575 35.5525C26.9496 35.5552 27.2226 35.5577 27.4899 35.5496L26.3811 37.9689ZM24.3628 31.6218L24.3628 31.6221C31.5675 31.815 37.6027 25.9299 37.6147 18.5499C37.6268 11.1477 31.6718 5.39189 24.5151 5.33757L24.3628 31.6218ZM24.3628 31.6218L24.3523 31.6221M24.3628 31.6218L24.3523 31.6221M24.3523 31.6221C17.3102 31.8028 11.2054 25.7075 11.2898 18.3565L11.2899 18.3565M24.3523 31.6221L11.2899 18.3565M11.2899 18.3565C11.3682 11.2979 17.2234 5.28331 24.515 5.33757L11.2899 18.3565ZM28.776 32.4174C28.8836 33.0973 28.8081 33.5291 28.5914 33.7969C28.3573 34.086 27.9049 34.2494 27.1113 34.2494H27.1009H27.0905H27.0801H27.0697H27.0593H27.0489H27.0385H27.0281H27.0177H27.0073H26.997H26.9866H26.9762H26.9658H26.9554H26.945H26.9346H26.9242H26.9138H26.9034H26.893H26.8826H26.8722H26.8618H26.8514H26.841H26.8306H26.8202H26.8098H26.7994H26.789H26.7786H26.7682H26.7578H26.7475H26.7371H26.7267H26.7163H26.7059H26.6955H26.6851H26.6747H26.6643H26.6539H26.6435H26.6331H26.6227H26.6123H26.6019H26.5916H26.5812H26.5708H26.5604H26.55H26.5396H26.5292H26.5188H26.5084H26.498H26.4876H26.4772H26.4669H26.4565H26.4461H26.4357H26.4253H26.4149H26.4045H26.3941H26.3837H26.3733H26.3629H26.3526H26.3422H26.3318H26.3214H26.311H26.3006H26.2902H26.2798H26.2694H26.2591H26.2487H26.2383H26.2279H26.2175H26.2071H26.1967H26.1863H26.1759H26.1656H26.1552H26.1448H26.1344H26.124H26.1136H26.1032H26.0928H26.0824H26.0721H26.0617H26.0513H26.0409H26.0305H26.0201H26.0097H25.9994H25.989H25.9786H25.9682H25.9578H25.9474H25.937H25.9266H25.9163H25.9059H25.8955H25.8851H25.8747H25.8643H25.8539H25.8436H25.8332H25.8228H25.8124H25.802H25.7916H25.7812H25.7709H25.7605H25.7501H25.7397H25.7293H25.7189H25.7085H25.6982H25.6878H25.6774H25.667H25.6566H25.6462H25.6359H25.6255H25.6151H25.6047H25.5943H25.5839H25.5735H25.5632H25.5528H25.5424H25.532H25.5216H25.5112H25.5009H25.4905H25.4801H25.4697H25.4593H25.4489H25.4386H25.4282H25.4178H25.4074H25.397H25.3866H25.3763H25.3659H25.3555H25.3451H25.3347H25.3243H25.314H25.3036H25.2932H25.2828H25.2724H25.2621H25.2517H25.2413H25.2309H25.2205H25.2101H25.1998H25.1894H25.179H25.1686H25.1582H25.1478H25.1375H25.1271H25.1167H25.1063H25.0959H25.0856H25.0752H25.0648H25.0544H25.044H25.0336H25.0233H25.0129H25.0025H24.9921H24.9817H24.9714H24.961H24.9506H24.9402H24.9298H24.9194H24.9091H24.8987H24.8883H24.8779H24.8675H24.8572H24.8468H24.8364H24.826H24.8156H24.8053H24.7949H24.7845H24.7741H24.7637H24.7534H24.743H24.7326H24.7222H24.7118H24.7014H24.6911H24.6807H24.6703H24.6599H24.6495H24.6392H24.6288H24.6184H24.608H24.5976H24.5873H24.5769H24.5665H24.5561H24.5457H24.5354H24.525H24.5146H24.5042H24.4938H24.4834H24.4731H24.4627H24.4523H24.4419H24.4315H24.4212H24.4108H24.4004H24.39H24.3796H24.3693H24.3589H24.3485H24.3381H24.3277H24.3174H24.307H24.2966H24.2862H24.2758H24.2654H24.2551H24.2447H24.2343H24.2239H24.2135H24.2032H24.1928H24.1824H24.172H24.1616H24.1513H24.1409H24.1305H24.1201H24.1097H24.0994H24.089H24.0786H24.0682H24.0578H24.0474H24.0371H24.0267H24.0163H24.0059H23.9955H23.9852H23.9748H23.9644H23.954H23.9436H23.9333H23.9229H23.9125H23.9021H23.8917H23.8813H23.871H23.8606H23.8502H23.8398H23.8294H23.8191H23.8087H23.7983H23.7879H23.7775H23.7671H23.7568H23.7464H23.736H23.7256H23.7152H23.7048H23.6945H23.6841H23.6737H23.6633H23.6529H23.6426H23.6322H23.6218H23.6114H23.601H23.5906H23.5803H23.5699H23.5595H23.5491H23.5387H23.5283H23.518H23.5076H23.4972H23.4868H23.4764H23.466H23.4557H23.4453H23.4349H23.4245H23.4141H23.4037H23.3934H23.383H23.3726H23.3622H23.3518H23.3414H23.3311H23.3207H23.3103H23.2999H23.2895H23.2791H23.2688H23.2584H23.248H23.2376H23.2272H23.2168H23.2064H23.1961H23.1857H23.1753H23.1649H23.1545H23.1441H23.1338H23.1234H23.113H23.1026H23.0922H23.0818H23.0714H23.0611H23.0507H23.0403H23.0299H23.0195H23.0091H22.9987H22.9883H22.978H22.9676H22.9572H22.9468H22.9364H22.926H22.9156H22.9053H22.8949H22.8845H22.8741H22.8637H22.8533H22.8429H22.8325H22.8222H22.8118H22.8014H22.791H22.7806H22.7702H22.7598H22.7494H22.7391H22.7287H22.7183H22.7079H22.6975H22.6871H22.6767H22.6663H22.6559H22.6456H22.6352H22.6248H22.6144H22.604H22.5936H22.5832H22.5728H22.5624H22.5521H22.5417H22.5313H22.5209H22.5105H22.5001H22.4897H22.4793H22.4689H22.4585H22.4481H22.4378H22.4274H22.417H22.4066H22.3962H22.3858H22.3754H22.365H22.3546H22.3442H22.3338H22.3234H22.3131H22.3027H22.2923H22.2819H22.2715H22.2611H22.2507H22.2403H22.2299H22.2195H22.2091H22.1987H22.1883H22.1779H22.1675H22.1572H22.1468H22.1364H22.126H22.1156H22.1052H22.0948H22.0844H22.074H22.0636H22.0532H22.0428H22.0324H22.022H22.0116H22.0012H21.9908H21.9804H21.97H21.9596H21.9492H21.9388H21.9285H21.9181H21.9077H21.8973H21.8869H21.8765H21.8661H21.8557H21.8453H21.8349H21.8245H21.8141H21.8037H21.7933C20.9943 34.2494 20.5282 34.0708 20.2906 33.7721C20.0724 33.4979 20.0021 33.0662 20.1317 32.4169C20.5089 32.466 20.889 32.5232 21.2708 32.5806C22.3182 32.7382 23.3788 32.8978 24.4309 32.8978C25.4714 32.8978 26.5181 32.7429 27.5672 32.5876C27.9698 32.528 28.3728 32.4683 28.776 32.4174Z"
          fill="black"
          stroke="black"
          strokeWidth="0.4"
        />
        <path
          d="M20.3876 40.0839C20.3754 39.5327 20.5896 39.2694 21.1526 39.2755M20.3876 40.0839L27.6579 44.0097C28.227 44.0159 28.5269 43.8076 28.5208 43.2013C28.5085 42.154 28.5085 41.1067 28.5208 40.0594C28.5269 39.5082 28.2637 39.2755 27.7191 39.2755C25.5282 39.2816 23.3435 39.2816 21.1526 39.2755M20.3876 40.0839C20.4121 41.1312 20.4182 42.1785 20.3876 43.2258M20.3876 40.0839L21.1526 39.2755M21.1526 39.2755L21.1548 39.0755C21.1545 39.0755 21.1542 39.0755 21.1539 39.0755C20.8459 39.0723 20.5838 39.142 20.4067 39.3358C20.2328 39.5262 20.1811 39.7933 20.1877 40.0884L20.1877 40.0886C20.2121 41.1336 20.2182 42.1771 20.1877 43.2197M20.3876 43.2258L20.1877 43.2195C20.1877 43.2196 20.1877 43.2196 20.1877 43.2197M20.3876 43.2258L20.1877 43.22C20.1877 43.2199 20.1877 43.2198 20.1877 43.2197M20.3876 43.2258C20.3693 43.8076 20.6263 44.0036 21.1648 44.0036C21.8788 43.9995 22.5928 44.0009 23.3068 44.0022C23.5695 44.0027 23.8323 44.0032 24.0951 44.0035L23.8955 44.2033C23.6987 44.203 23.502 44.2026 23.3053 44.2022C22.5918 44.2009 21.8792 44.1995 21.166 44.2036L21.1648 44.2036C20.8799 44.2036 20.6162 44.1535 20.4303 43.9785C20.2402 43.7995 20.1778 43.5348 20.1877 43.2197M21.524 40.4309H27.3416V42.8604H21.524V40.4309Z"
          fill="black"
          stroke="black"
          strokeWidth="0.4"
        />
        <path
          d="M36.1697 39.9961V39.7961H35.9697H29.7949H29.5949V39.9961V40.7739V40.9739H29.7949H35.9697H36.1697V40.7739V39.9961Z"
          fill="black"
          stroke="black"
          strokeWidth="0.4"
        />
        <path
          d="M19.0975 39.9961V39.7961H18.8975H12.7227H12.5227V39.9961V40.7739V40.9739H12.7227H18.8975H19.0975V40.7739V39.9961Z"
          fill="black"
          stroke="black"
          strokeWidth="0.4"
        />
        <path
          d="M36.1697 42.3828V42.1828H35.9697H29.7949H29.5949V42.3828V43.1606V43.3606H29.7949H35.9697H36.1697V43.1606V42.3828Z"
          fill="black"
          stroke="black"
          strokeWidth="0.4"
        />
        <path
          d="M19.0975 42.3828V42.1828H18.8975H12.7227H12.5227V42.3828V43.1606V43.3606H12.7227H18.8975H19.0975V43.1606V42.3828Z"
          fill="black"
          stroke="black"
          strokeWidth="0.4"
        />
        <path
          d="M14.7263 29.0177L14.6981 28.9933C12.3074 26.9183 10.8964 24.4231 10.2746 21.5196L10.2746 21.5196C9.18954 16.4322 10.4592 11.8437 14.1191 8.19137C19.1009 3.21429 26.5799 2.47372 32.5236 6.45634L32.468 6.53942L32.5236 6.45635C36.9963 9.4539 39.1684 13.7888 39.0984 19.128L39.0984 19.1281C39.0458 22.7156 37.5372 25.8018 35.231 28.5065L35.231 28.5065C34.93 28.859 34.6218 29.0802 34.2876 29.0987C33.9502 29.1175 33.623 28.9283 33.289 28.5514C32.9961 28.2229 32.6792 27.9137 32.3593 27.6015L32.3166 27.5598C31.9832 27.2344 31.6477 26.9048 31.3403 26.5507M14.7263 29.0177L31.4158 26.4851M14.7263 29.0177H14.7636H14.7897H14.8315L14.8609 28.988C15.1193 28.7265 15.3743 28.4704 15.6258 28.2179C16.3964 27.4442 17.1341 26.7036 17.8367 25.9388C17.894 25.8782 17.9217 25.8008 17.9351 25.7245C17.9485 25.6478 17.949 25.5637 17.945 25.4815C17.9421 25.4191 17.9363 25.3536 17.9307 25.2907C17.929 25.271 17.9273 25.2516 17.9257 25.2327C17.9187 25.1509 17.9138 25.0752 17.9158 25.0077L17.9192 24.8916L17.8038 24.9055C17.7369 24.9136 17.6637 24.9167 17.5854 24.9192C17.5718 24.9196 17.558 24.92 17.544 24.9204C17.4794 24.9223 17.412 24.9242 17.3468 24.9288C17.1926 24.9397 17.0225 24.9664 16.9005 25.0658L16.9004 25.0658C16.3649 25.5028 15.8648 26.0007 15.4175 26.5333L15.417 26.5339C15.1207 26.8921 14.8807 26.9929 14.6776 26.962C14.4647 26.9295 14.2466 26.7477 14.0096 26.4261C13.8713 26.2368 13.7332 26.0391 13.6038 25.8416L13.6034 25.841C12.1915 23.7197 11.4083 21.4069 11.3604 18.8841C11.6341 18.7878 11.9193 18.756 12.2147 18.7509C12.411 18.7476 12.6044 18.7558 12.8015 18.7642C12.93 18.7696 13.06 18.7752 13.1934 18.7776C13.8577 18.7896 14.5391 18.72 15.1549 18.1251L15.2359 18.0468L15.1485 17.9757C14.499 17.4466 13.8128 17.3882 13.1553 17.4003C13.0287 17.4026 12.9051 17.4074 12.7833 17.4121C12.5842 17.4199 12.3897 17.4274 12.1941 17.4237C11.9089 17.4182 11.6351 17.3882 11.3733 17.3007C11.5753 14.6332 12.5134 12.2531 14.1384 10.1499L14.1386 10.1497C14.1476 10.138 14.1772 10.1165 14.2396 10.0972C14.298 10.0791 14.3713 10.0671 14.4482 10.0631C14.525 10.0591 14.6015 10.0633 14.6661 10.0751C14.7335 10.0875 14.7759 10.1062 14.7955 10.1225L14.7964 10.1232C15.0697 10.3443 15.3204 10.5958 15.5751 10.8538C15.586 10.8648 15.5968 10.8758 15.6077 10.8868C15.8507 11.133 16.0985 11.3839 16.3689 11.6111L16.3689 11.6111L16.3705 11.6124C16.4874 11.7066 16.65 11.7336 16.7961 11.7466C16.8523 11.7517 16.9106 11.7548 16.9667 11.7579C16.9854 11.7589 17.0037 11.7599 17.0217 11.7609C17.0954 11.7652 17.164 11.7704 17.226 11.7804L17.3419 11.799V11.6817C17.3419 11.6114 17.3485 11.5346 17.3568 11.4527C17.3584 11.4362 17.3602 11.4194 17.3619 11.4025C17.3687 11.3372 17.3757 11.2693 17.3798 11.2041C17.3895 11.0464 17.3854 10.8653 17.2861 10.7373L17.2861 10.7373L17.2851 10.736C17.0623 10.4588 16.807 10.2111 16.5568 9.96831C16.5479 9.95966 16.5389 9.951 16.53 9.94236C16.2697 9.68969 16.016 9.44109 15.7992 9.16177L15.7992 9.16175L15.7978 9.16C15.7752 9.13231 15.7524 9.08032 15.7363 9.00557C15.7206 8.93306 15.7132 8.84835 15.7147 8.76389C15.7162 8.67926 15.7266 8.59858 15.7444 8.53375C15.7633 8.46512 15.7863 8.42958 15.8014 8.41703L15.7376 8.34007M14.7263 29.0177L15.7376 8.34007M31.3403 26.5507L31.4158 26.4851M31.3403 26.5507C31.3403 26.5508 31.3404 26.5508 31.3405 26.5509L31.4158 26.4851M31.3403 26.5507C31.2315 26.426 31.197 26.2531 31.1794 26.0935C31.1724 26.0298 31.1678 25.9637 31.1633 25.8998C31.162 25.8821 31.1608 25.8645 31.1595 25.8472C31.1536 25.7662 31.1468 25.6897 31.1346 25.6191L31.1121 25.4885L31.2439 25.5027C31.3187 25.5107 31.4007 25.5124 31.4879 25.5125C31.5105 25.5126 31.5335 25.5125 31.5568 25.5124C31.6219 25.5122 31.689 25.512 31.7537 25.5141C31.9255 25.5195 32.1137 25.5404 32.25 25.6436L32.2513 25.6445C32.5401 25.8701 32.7989 26.1347 33.0516 26.3949L33.0755 26.4194C33.3215 26.6728 33.5623 26.9209 33.8265 27.1346L33.8268 27.1348C33.8603 27.1621 33.9171 27.1899 33.9921 27.2129C34.0655 27.2354 34.1495 27.2513 34.2315 27.2588C34.3139 27.2664 34.3906 27.2653 34.45 27.256C34.4797 27.2513 34.5024 27.245 34.5184 27.2383C34.5337 27.2319 34.5382 27.2271 34.538 27.2274L34.5386 27.2267C36.402 24.9631 37.552 22.4181 37.652 19.3221M31.4158 26.4851C31.295 26.3468 31.2791 26.1207 31.2631 25.894C31.2586 25.83 31.2541 25.7661 31.2473 25.704C31.239 25.7032 31.2307 25.7024 31.2225 25.7015L31.2332 25.6021L31.3317 25.5851C31.3331 25.5933 31.3345 25.6014 31.3357 25.6096C31.408 25.6129 31.4833 25.6126 31.5586 25.6124C31.7995 25.6117 32.0412 25.611 32.1897 25.7233C32.4817 25.9514 32.7436 26.2212 33.0053 26.4907C33.2501 26.7428 33.4946 26.9948 33.7636 27.2123C33.9549 27.3681 34.5114 27.4201 34.6158 27.2902C36.4914 25.0117 37.652 22.4451 37.7521 19.3219C37.7186 19.3219 37.6853 19.322 37.652 19.3221M37.652 19.3221C37.4153 19.323 37.1827 19.3268 36.9535 19.3306C36.3108 19.3411 35.6944 19.3512 35.0849 19.2955L35.0833 19.2954C34.8926 19.2748 34.7213 19.1637 34.5707 19.0466C34.5131 19.0018 34.4556 18.9537 34.3999 18.9071C34.3819 18.892 34.3641 18.8772 34.3466 18.8626C34.2735 18.8019 34.2033 18.7457 34.1338 18.6989L34.0157 18.6193L34.1306 18.5352C34.2001 18.4844 34.2691 18.424 34.3404 18.3594C34.3589 18.3427 34.3775 18.3256 34.3964 18.3083C34.4492 18.26 34.5034 18.2103 34.5574 18.1643C34.7021 18.041 34.8679 17.9228 35.057 17.9019L35.0578 17.9018C35.6622 17.8404 36.274 17.8523 36.9136 17.8647C37.1506 17.8693 37.3914 17.874 37.6371 17.8751C37.6185 15.4695 36.9303 13.3489 35.6549 11.4696C35.5675 11.3415 35.486 11.2212 35.4097 11.1086C35.1193 10.6803 34.9037 10.3622 34.727 10.1389C34.6157 9.99823 34.5243 9.90112 34.444 9.83937C34.3647 9.77847 34.3024 9.75664 34.2471 9.75593C34.1908 9.7552 34.1258 9.7761 34.0411 9.83176C33.9558 9.88779 33.8584 9.97372 33.7387 10.0918C33.6444 10.1849 33.5393 10.2948 33.4179 10.4217C33.3857 10.4553 33.3524 10.4902 33.3178 10.5262C33.1536 10.6974 32.963 10.8938 32.7381 11.1123C32.7107 11.1397 32.6871 11.1681 32.6605 11.2002C32.6429 11.2214 32.6239 11.2443 32.6016 11.2696C32.5528 11.3248 32.4891 11.3891 32.4081 11.4201L32.4038 11.4217L32.4038 11.4216C32.1352 11.5108 31.8601 11.5773 31.5885 11.643C31.4863 11.6677 31.3846 11.6923 31.2839 11.718L31.112 11.7618L31.1636 11.592C31.198 11.4788 31.2229 11.3648 31.2488 11.2468C31.2651 11.1724 31.2818 11.0964 31.3014 11.0179C31.35 10.8233 31.4146 10.6257 31.5353 10.4622L31.5356 10.4619C31.7902 10.1196 32.1121 9.824 32.4243 9.53726C32.5461 9.42537 32.6665 9.31484 32.7808 9.20342L32.7813 9.20289C33.0212 8.9726 33.1023 8.80535 33.087 8.66353C33.0713 8.51806 32.9504 8.35441 32.6613 8.14389L32.661 8.14367C31.49 7.28444 30.6401 6.75186 29.541 6.34648C28.4587 5.94731 27.1308 5.66993 25.0117 5.33207L37.6375 17.9751C37.3875 17.974 37.1438 17.9693 36.905 17.9646C36.2683 17.9522 35.666 17.9405 35.0679 18.0013C34.8541 18.0249 34.6605 18.2021 34.4651 18.381C34.4013 18.4394 34.3373 18.4979 34.2724 18.5514C34.2635 18.5452 34.2545 18.539 34.2455 18.533L34.1897 18.6159L34.2488 18.6966C34.2575 18.6902 34.2662 18.6837 34.2749 18.6771C34.3383 18.7252 34.4016 18.7781 34.4651 18.8312C34.6677 19.0007 34.8726 19.1721 35.094 19.1959C35.6978 19.2511 36.3059 19.2412 36.9462 19.2306C37.1778 19.2268 37.4136 19.223 37.6549 19.2221C37.654 19.2555 37.6531 19.2888 37.652 19.3221ZM15.7376 8.34007C15.581 8.46993 15.5723 9.04129 15.7202 9.22308C15.9491 9.51799 16.2173 9.7783 16.4855 10.0385C16.737 10.2825 16.9883 10.5264 17.2071 10.7987L15.7376 8.34007ZM15.7376 8.34007L15.8009 8.41742C18.0203 6.59886 20.5495 5.54588 23.5588 5.38915M15.7376 8.34007L23.5588 5.38915M23.5588 5.38915C23.5573 5.57152 23.5521 5.75216 23.5469 5.93106C23.5324 6.43196 23.5184 6.91931 23.5864 7.39335L23.5865 7.39414C23.6227 7.63322 23.7189 7.95939 23.8312 8.22629C23.8874 8.35963 23.9494 8.48277 24.0128 8.5743C24.0443 8.61988 24.0787 8.66138 24.1158 8.69248C24.1514 8.72233 24.2 8.7514 24.2583 8.75172C24.2586 8.75172 24.259 8.75172 24.2593 8.75172L23.5588 5.38915ZM37.7371 17.8753C37.7186 15.4493 37.0242 13.3091 35.7375 11.4133C34.906 10.1931 34.5857 9.66437 34.2523 9.65601C33.9163 9.64758 33.5671 10.1676 32.668 11.0411C32.6378 11.0711 32.6084 11.1064 32.5789 11.1419C32.5148 11.2189 32.4497 11.2971 32.3723 11.3267C32.1079 11.4145 31.839 11.4795 31.5688 11.5449C31.5031 11.5608 31.4374 11.5767 31.3715 11.5929C31.3662 11.6122 31.3607 11.6313 31.3549 11.6501L37.7371 17.8753Z"
          fill="black"
          stroke="black"
          strokeWidth="0.2"
        />
        <path
          d="M23.7883 20.5268V20.3268C23.7883 20.123 23.785 19.916 23.7816 19.7069C23.773 19.1588 23.764 18.5968 23.8135 18.0429L23.8135 18.0427C23.831 17.8502 23.9353 17.6838 24.0296 17.5532C24.0651 17.504 24.1039 17.4539 24.1402 17.407C24.1531 17.3904 24.1656 17.3742 24.1776 17.3586C24.2254 17.2962 24.2674 17.2392 24.3016 17.1839L24.4819 16.8924L24.647 17.1927C24.6755 17.2446 24.7111 17.2985 24.7524 17.3583C24.7625 17.3728 24.773 17.3879 24.7839 17.4034C24.8155 17.4488 24.8496 17.4977 24.8806 17.5456C24.9619 17.6712 25.0527 17.834 25.0572 18.0191C25.0572 18.0191 25.0572 18.0191 25.0572 18.0191L24.8573 18.024C24.894 19.5123 24.8879 20.9944 24.8695 22.4826L23.7883 20.5268ZM23.7883 20.5268H23.8001C23.7994 20.7003 23.7979 20.875 23.7964 21.0502C23.7924 21.5399 23.7882 22.0345 23.8005 22.5235C23.8033 22.7038 23.7851 22.8252 23.738 22.9243C23.6921 23.0209 23.6084 23.1179 23.4391 23.2272L23.4388 23.2273C22.8016 23.6404 22.4486 24.2424 22.4192 24.8625C22.3896 25.4843 22.6872 26.0957 23.2925 26.5174L23.2932 26.5179C23.5007 26.6612 23.6292 26.7837 23.7079 26.9177C23.7843 27.0479 23.8243 27.2074 23.8189 27.4443C23.8189 27.4445 23.8189 27.4447 23.8189 27.4449L24.0188 27.4496L23.7883 20.5268ZM23.9883 20.3268C23.9883 20.1161 23.9849 19.9049 23.9815 19.6935C23.9729 19.1491 23.9642 18.6033 24.0127 18.0607L23.9883 20.3268ZM25.0094 24.3815C25.1021 24.4796 25.1671 24.6215 25.185 24.8145L25.1836 24.9548C25.181 25.2055 25.0999 25.3878 24.9765 25.5062C24.8529 25.6249 24.6662 25.6993 24.4147 25.694C24.1766 25.6889 23.9984 25.6057 23.8804 25.478C23.7617 25.3496 23.6873 25.1578 23.6925 24.906C23.6978 24.6531 23.778 24.4741 23.8988 24.3593C24.0199 24.2442 24.2047 24.1717 24.4615 24.177C24.7184 24.1823 24.8963 24.2618 25.0094 24.3815Z"
          fill="black"
          stroke="black"
          strokeWidth="0.4"
        />
      </g>
      <defs>
        <clipPath id="clip0_1472_2554">
          <rect
            width="31"
            height="42"
            fill="white"
            transform="translate(9 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconBarcodeReader = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.6872 44C7.12977 44 5.89331 43.4084 4.97782 42.2253C4.06077 41.0422 3.78876 39.7321 4.1618 38.295L8.58462 22.0398C7.33184 21.6216 6.2578 20.8232 5.36251 19.6447C4.46722 18.4661 4.01958 17.1089 4.01958 15.5729C4.01958 13.6918 4.70426 12.0805 6.07361 10.7393C7.44297 9.39796 9.08977 8.72808 11.014 8.7296H27.3344C28.7426 8.7296 29.8073 9.3128 30.5285 10.4792C31.2497 11.6456 31.2956 12.8432 30.6661 14.0719L27.437 20.3906C27.0935 21.0035 26.6326 21.4946 26.0544 21.8642C25.4762 22.2337 24.8273 22.4177 24.1076 22.4162H18.1297L17.2647 25.6189H17.4256C17.937 25.6478 18.3714 25.8348 18.7289 26.18C19.0864 26.5252 19.2651 26.9526 19.2651 27.462V30.6191C19.2651 31.1422 19.084 31.5802 18.7219 31.933C18.3613 32.2858 17.9144 32.4622 17.3813 32.4622H15.3995L13.2009 40.6924C12.9165 41.6687 12.3585 42.4641 11.5269 43.0784C10.6954 43.6928 9.7488 44 8.6872 44ZM8.68254 41.7189C9.22655 41.7189 9.69285 41.5668 10.0814 41.2627C10.47 40.9585 10.742 40.5593 10.8974 40.0651L15.7143 22.4162H10.8741L6.40701 38.8675C6.21272 39.5899 6.34873 40.2453 6.81502 40.8338C7.28132 41.4224 7.90538 41.7174 8.68254 41.7189ZM11.014 20.1351H24.1076C24.3765 20.1351 24.6299 20.0621 24.8677 19.9161C25.1055 19.7701 25.285 19.58 25.4062 19.3459L28.6353 13.0272C28.8747 12.5603 28.8514 12.1079 28.5654 11.6699C28.2841 11.2304 27.8737 11.0107 27.3344 11.0107H11.014C9.7317 11.0107 8.63435 11.4578 7.72197 12.352C6.80958 13.2462 6.35261 14.3198 6.35106 15.5729C6.3495 16.826 6.80647 17.9004 7.72197 18.7961C8.63746 19.6918 9.73481 20.1382 11.014 20.1351ZM36.6137 10.2214L35.6974 8.23688L42.9833 5L43.8879 6.99596L36.6137 10.2214ZM42.9833 26.1435L35.6974 22.9637L36.616 20.9677L43.8879 24.2069L42.9833 26.1435ZM36.9307 16.6701V14.4757H45V16.6701H36.9307Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.21508 42.0417C6.07109 43.148 7.21817 43.7 8.6872 43.7C9.68647 43.7 10.5702 43.4123 11.3487 42.8372C12.1275 42.2618 12.646 41.5223 12.912 40.6117L15.1692 32.1622H17.3813C17.8409 32.1622 18.211 32.0131 18.5121 31.7185C18.8141 31.4244 18.9651 31.0644 18.9651 30.6191V27.462C18.9651 27.0316 18.8178 26.6829 18.5205 26.3958C18.2183 26.104 17.8552 25.9453 17.4168 25.9189H16.8729L17.9 22.1162H24.1076C24.7727 22.1176 25.3655 21.9484 25.8928 21.6114C26.4269 21.2701 26.8528 20.8174 27.1725 20.2489L30.3989 13.9354C30.9809 12.7994 30.9388 11.7133 30.2733 10.637C29.6086 9.56185 28.642 9.0296 27.3344 9.0296H11.014C9.168 9.02814 7.59652 9.6675 6.28354 10.9536C4.97056 12.2396 4.31958 13.7741 4.31958 15.5729C4.31958 17.046 4.74734 18.3389 5.6014 19.4632C6.46476 20.5997 7.49085 21.3584 8.67961 21.7553L8.94852 21.845L4.45218 38.3703L4.45174 38.372C4.10293 39.7176 4.35478 40.9318 5.21508 42.0417ZM4.1618 38.295C3.78876 39.7321 4.06077 41.0422 4.97782 42.2253C5.89331 43.4084 7.12977 44 8.6872 44C9.7488 44 10.6954 43.6928 11.5269 43.0784C12.3585 42.4641 12.9165 41.6687 13.2009 40.6924L15.3995 32.4622H17.3813C17.9144 32.4622 18.3613 32.2858 18.7219 31.933C19.084 31.5802 19.2651 31.1422 19.2651 30.6191V27.462C19.2651 26.9526 19.0864 26.5252 18.7289 26.18C18.406 25.8683 18.0204 25.6855 17.572 25.6317C17.5239 25.626 17.4751 25.6217 17.4256 25.6189H17.2647L18.1297 22.4162H24.1076C24.8273 22.4177 25.4762 22.2337 26.0544 21.8642C26.6326 21.4946 27.0935 21.0035 27.437 20.3906L30.6661 14.0719C31.2956 12.8432 31.2497 11.6456 30.5285 10.4792C29.8073 9.3128 28.7426 8.7296 27.3344 8.7296H11.014C9.08977 8.72808 7.44297 9.39796 6.07361 10.7393C4.70426 12.0805 4.01958 13.6918 4.01958 15.5729C4.01958 17.1089 4.46722 18.4661 5.36251 19.6447C6.2578 20.8232 7.33184 21.6216 8.58462 22.0398L4.1618 38.295ZM8.68195 42.0189C7.81741 42.0172 7.10542 41.6834 6.57988 41.0201C6.05485 40.3575 5.89823 39.6041 6.11731 38.7896L10.6447 22.1162H16.1071L11.1838 40.1552C11.0112 40.7042 10.7051 41.1555 10.2663 41.4989C9.81951 41.8487 9.28571 42.0189 8.68195 42.0189ZM25.4062 19.3459C25.285 19.58 25.1055 19.7701 24.8677 19.9161C24.6299 20.0621 24.3765 20.1351 24.1076 20.1351H17.5608H11.014C9.73481 20.1382 8.63746 19.6918 7.72197 18.7961C6.80647 17.9004 6.3495 16.826 6.35106 15.5729C6.35261 14.3198 6.80958 13.2462 7.72197 12.352C8.63435 11.4578 9.7317 11.0107 11.014 11.0107H27.3344C27.8737 11.0107 28.2841 11.2304 28.5654 11.6699C28.8514 12.1079 28.9918 12.6669 28.7525 13.1337L25.4062 19.3459ZM10.8974 40.0651C10.742 40.5593 10.47 40.9585 10.0814 41.2627C9.69285 41.5668 9.22655 41.7189 8.68254 41.7189C7.90538 41.7174 7.28132 41.4224 6.81502 40.8338C6.34873 40.2453 6.21272 39.5899 6.40701 38.8675L10.8741 22.4162H15.7143L10.8974 40.0651ZM36.7622 9.82742L43.4898 6.84432L42.8329 5.39506L36.0974 8.38747L36.7622 9.82742ZM36.6137 10.2214L43.8879 6.99596L42.9833 5L35.6974 8.23688L36.6137 10.2214ZM42.8352 25.7516L43.4868 24.3566L36.7646 21.3623L36.0979 22.8111L42.8352 25.7516ZM42.9833 26.1435L43.8879 24.2069L36.616 20.9677L35.6974 22.9637L42.9833 26.1435ZM37.2307 14.7757H44.7V16.3701H37.2307V14.7757ZM36.9307 16.6701H45V14.4757H36.9307V16.6701Z"
        fill="#F6F6F6"
      />
    </svg>
  );
};

export const IconElectromagneticPump = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="path-1-outside-1_1450_2573"
        maskUnits="userSpaceOnUse"
        x="0"
        y="6.58594"
        width="47"
        height="34"
        fill={color}
      >
        <rect fill="white" y="6.58594" width="47" height="34" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.927 7.67226C13.3179 7.7975 12.7967 8.21472 12.5113 8.80567C12.3828 9.07142 12.3372 9.3668 12.3011 10.1642L12.2551 11.183L11.9785 11.2092C11.0643 11.2956 9.7793 11.953 8.95441 12.7564C7.68982 13.9878 7.08337 15.5187 7.08021 17.4872L7.07886 18.3575H6.28859H5.49832L5.49642 17.6995C5.49303 16.5176 5.26843 15.9805 4.61835 15.6001C4.28202 15.4034 4.17201 15.386 3.27489 15.3877C1.94763 15.3902 1.53116 15.6006 1.17538 16.4483C1.04341 16.7627 1.03155 17.2423 1.00911 23.1971C0.982319 30.2787 0.986033 30.3452 1.43696 30.9112C1.82601 31.3996 2.13145 31.498 3.30129 31.5122C4.4697 31.5263 4.70331 31.452 5.11504 30.9352C5.47082 30.4886 5.57735 30.0973 5.57735 29.2368V28.5462H6.3575H7.13766L7.1778 29.7136C7.24276 31.6036 7.67654 32.7518 8.77676 33.9457C9.74279 34.994 11.1538 35.7577 12.1366 35.764C12.2887 35.7649 12.4554 35.7945 12.5069 35.8298C12.5722 35.8743 12.6082 36.3773 12.6255 37.4891C12.6582 39.5915 12.435 39.4097 14.9864 39.4122C16.8038 39.414 16.9372 39.4035 17.0806 39.2492C17.1649 39.1586 17.6606 38.3576 18.1822 37.469L19.1305 35.8536L25.0686 35.8508L31.0067 35.848L32.0445 37.5803C32.6154 38.533 33.1378 39.3353 33.2055 39.3633C33.2733 39.3912 34.1882 39.4129 35.2387 39.4113C36.8164 39.4091 37.1762 39.3864 37.3067 39.2805C37.4535 39.1614 37.4665 39.036 37.4895 37.5231C37.5068 36.384 37.5425 35.8746 37.6081 35.8298C37.6597 35.7945 37.8619 35.7647 38.0575 35.7635C38.6727 35.7596 39.5701 35.4079 40.3752 34.855C41.7114 33.9373 42.5582 32.5371 42.9128 30.6593C42.9514 30.455 42.9937 30.4339 43.4498 30.3923C43.7221 30.3675 44.1154 30.2674 44.3236 30.1699C44.8766 29.911 45.5022 29.2364 45.7726 28.6075L45.9997 28.0792V23.282C45.9997 17.8848 46.0334 18.206 45.3872 17.4527C44.9164 16.904 44.1529 16.5347 43.3548 16.4696C43.1042 16.4491 43.075 16.418 43.0138 16.1075C42.6233 14.1253 41.537 12.5575 39.9853 11.7369C38.7355 11.0758 38.5265 11.0557 32.9093 11.0557H28.0377L28.0029 10.058C27.9648 8.96563 27.8899 8.72348 27.446 8.2559C27.1494 7.94362 26.8567 7.784 26.3615 7.66454C25.9078 7.55501 14.4624 7.56214 13.927 7.67226ZM26.5175 9.18562C26.6034 9.27782 26.6931 9.44016 26.717 9.54646C26.741 9.65268 26.7508 13.3884 26.7388 17.8481L26.7171 25.9565H20.1578H13.5986L13.5769 17.8481C13.5649 13.3884 13.5724 9.66244 13.5936 9.56811C13.6147 9.47379 13.7059 9.31145 13.7962 9.20727L13.9604 9.01793H20.1609C26.2295 9.01793 26.3648 9.0215 26.5175 9.18562ZM19.6654 11.3903C19.5868 11.4809 19.4214 11.949 19.2977 12.4304C19.1741 12.9118 18.9878 13.5806 18.8838 13.9166C18.7798 14.2528 18.6872 14.6252 18.6781 14.7445C18.6689 14.8637 18.6396 14.9613 18.6129 14.9613C18.5862 14.9613 18.5264 15.1236 18.4799 15.3222C18.4335 15.5207 18.316 15.9505 18.2188 16.2773C17.9375 17.2233 17.9313 17.513 18.1864 17.787C18.3046 17.914 18.4587 18.0185 18.5288 18.0193C18.599 18.0199 19.0737 17.8984 19.5839 17.7493C20.094 17.6001 20.5301 17.4981 20.5531 17.5227C20.576 17.5474 20.5019 17.793 20.3884 18.0687C20.2749 18.3443 20.1322 18.6939 20.0712 18.8457C20.0101 18.9975 19.9096 19.2458 19.8477 19.3976C19.7859 19.5494 19.6216 19.9601 19.4829 20.3103C19.344 20.6606 19.1677 21.1 19.091 21.2868C18.5602 22.5793 18.4588 22.8769 18.4588 23.1416C18.4588 23.6257 18.8382 23.8905 19.2758 23.7117C19.5008 23.6199 19.5589 23.5069 20.2395 21.8386C20.7306 20.6344 20.7964 20.472 21.1842 19.5037C21.5225 18.6594 21.6325 18.3891 21.9789 17.5509C22.4101 16.5073 22.4397 16.1692 22.1229 15.9015C21.8527 15.6731 21.7781 15.6772 20.6118 15.9855C20.0706 16.1286 19.6107 16.2272 19.5897 16.2047C19.5688 16.1822 19.6413 15.8454 19.7509 15.4564C20.3203 13.4352 20.7505 11.8258 20.7505 11.717C20.7505 11.2987 19.953 11.0586 19.6654 11.3903ZM39.4552 12.9704C40.0692 13.2912 40.8223 14.0146 41.1851 14.632C41.301 14.8291 41.4892 15.2608 41.6035 15.5915L41.8113 16.1924V23.4094V30.6263L41.6322 31.2235C41.1942 32.6839 40.1572 33.7678 38.7292 34.2574L38.176 34.4471H25.1366C14.5724 34.4471 12.0221 34.4258 11.7019 34.3347C11.327 34.2281 10.3244 33.7576 10.2399 33.6487C10.2182 33.6207 10.0582 33.467 9.88432 33.3073C9.43964 32.8988 8.95378 32.206 8.73867 31.6737C8.35294 30.7193 8.34906 30.6384 8.34606 23.4783C8.34298 16.0574 8.33769 16.1478 8.84172 15.0471C9.16083 14.3501 10.0302 13.3907 10.6547 13.0466C10.9045 12.9089 11.1089 12.7653 11.1091 12.7275C11.1092 12.6897 11.1418 12.6805 11.1816 12.7069C11.2215 12.7334 11.3548 12.7125 11.478 12.6606C11.6012 12.6087 11.8347 12.5582 11.997 12.5484L12.292 12.5305L12.3131 19.8136C12.333 26.6749 12.3423 27.1055 12.4753 27.2484C12.6088 27.3918 13.0242 27.3999 20.1676 27.3999H27.7189L27.8699 27.1995C28.0161 27.0056 28.021 26.7609 28.021 19.7497V12.5003L32.98 12.4785C38.4453 12.4544 38.4709 12.4563 39.4552 12.9704ZM31.1821 16.2951C30.9052 16.4045 30.787 16.6049 30.787 16.9649C30.787 17.6188 30.6171 17.5934 34.9982 17.5934C37.3181 17.5934 38.9148 17.5608 39.0002 17.5117C39.4247 17.2676 39.3645 16.4965 38.9075 16.3253C38.6573 16.2316 31.4145 16.2033 31.1821 16.2951ZM4.18987 16.9331C4.29861 17.0997 4.31291 17.8623 4.31291 23.4763C4.31291 27.6943 4.28541 29.8861 4.23112 29.9952C4.15842 30.1411 4.05924 30.1594 3.33812 30.1594C2.81251 30.1594 2.49347 30.1234 2.43207 30.0575C2.2948 29.91 2.2948 16.9937 2.43207 16.8462C2.49284 16.7809 2.80342 16.7443 3.29686 16.7443C4.00297 16.7443 4.0771 16.7599 4.18987 16.9331ZM43.8344 17.9447C44.237 18.0896 44.5993 18.4125 44.7755 18.7836C44.9264 19.1015 44.9328 19.2891 44.9328 23.4102C44.9328 27.1945 44.9177 27.7379 44.8053 27.9773C44.5101 28.606 44.0021 28.9707 43.4217 28.9707H43.1152V23.466C43.1152 20.4384 43.1389 17.9358 43.1679 17.9047C43.2473 17.8193 43.5337 17.8365 43.8344 17.9447ZM30.9178 19.6166C30.7257 19.8446 30.746 20.4139 30.9533 20.6156C31.1122 20.77 31.2956 20.7773 35.0301 20.7773H38.9404L39.1312 20.5391C39.3651 20.2469 39.3735 19.9792 39.1581 19.685L38.9943 19.4613H35.0214C31.2729 19.4613 31.0412 19.47 30.9178 19.6166ZM7.07886 23.4943V27.1877H6.28859H5.49832V23.4943V19.8009H6.28859H7.07886V23.4943ZM17.5104 35.9321C17.5104 35.9783 17.2441 36.457 16.9186 36.9956L16.3268 37.975L15.0812 37.9515L13.8357 37.9282L13.8135 36.8881L13.7913 35.848H15.6509C16.826 35.848 17.5104 35.879 17.5104 35.9321ZM36.3979 36.9115V37.9749L35.1206 37.9515L33.8432 37.9282L33.2635 36.9241C32.9445 36.3719 32.6836 35.9038 32.6836 35.884C32.6836 35.8642 33.5193 35.848 34.5408 35.848H36.3979V36.9115Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.927 7.67226C13.3179 7.7975 12.7967 8.21472 12.5113 8.80567C12.3828 9.07142 12.3372 9.3668 12.3011 10.1642L12.2551 11.183L11.9785 11.2092C11.0643 11.2956 9.7793 11.953 8.95441 12.7564C7.68982 13.9878 7.08337 15.5187 7.08021 17.4872L7.07886 18.3575H6.28859H5.49832L5.49642 17.6995C5.49303 16.5176 5.26843 15.9805 4.61835 15.6001C4.28202 15.4034 4.17201 15.386 3.27489 15.3877C1.94763 15.3902 1.53116 15.6006 1.17538 16.4483C1.04341 16.7627 1.03155 17.2423 1.00911 23.1971C0.982319 30.2787 0.986033 30.3452 1.43696 30.9112C1.82601 31.3996 2.13145 31.498 3.30129 31.5122C4.4697 31.5263 4.70331 31.452 5.11504 30.9352C5.47082 30.4886 5.57735 30.0973 5.57735 29.2368V28.5462H6.3575H7.13766L7.1778 29.7136C7.24276 31.6036 7.67654 32.7518 8.77676 33.9457C9.74279 34.994 11.1538 35.7577 12.1366 35.764C12.2887 35.7649 12.4554 35.7945 12.5069 35.8298C12.5722 35.8743 12.6082 36.3773 12.6255 37.4891C12.6582 39.5915 12.435 39.4097 14.9864 39.4122C16.8038 39.414 16.9372 39.4035 17.0806 39.2492C17.1649 39.1586 17.6606 38.3576 18.1822 37.469L19.1305 35.8536L25.0686 35.8508L31.0067 35.848L32.0445 37.5803C32.6154 38.533 33.1378 39.3353 33.2055 39.3633C33.2733 39.3912 34.1882 39.4129 35.2387 39.4113C36.8164 39.4091 37.1762 39.3864 37.3067 39.2805C37.4535 39.1614 37.4665 39.036 37.4895 37.5231C37.5068 36.384 37.5425 35.8746 37.6081 35.8298C37.6597 35.7945 37.8619 35.7647 38.0575 35.7635C38.6727 35.7596 39.5701 35.4079 40.3752 34.855C41.7114 33.9373 42.5582 32.5371 42.9128 30.6593C42.9514 30.455 42.9937 30.4339 43.4498 30.3923C43.7221 30.3675 44.1154 30.2674 44.3236 30.1699C44.8766 29.911 45.5022 29.2364 45.7726 28.6075L45.9997 28.0792V23.282C45.9997 17.8848 46.0334 18.206 45.3872 17.4527C44.9164 16.904 44.1529 16.5347 43.3548 16.4696C43.1042 16.4491 43.075 16.418 43.0138 16.1075C42.6233 14.1253 41.537 12.5575 39.9853 11.7369C38.7355 11.0758 38.5265 11.0557 32.9093 11.0557H28.0377L28.0029 10.058C27.9648 8.96563 27.8899 8.72348 27.446 8.2559C27.1494 7.94362 26.8567 7.784 26.3615 7.66454C25.9078 7.55501 14.4624 7.56214 13.927 7.67226ZM26.5175 9.18562C26.6034 9.27782 26.6931 9.44016 26.717 9.54646C26.741 9.65268 26.7508 13.3884 26.7388 17.8481L26.7171 25.9565H20.1578H13.5986L13.5769 17.8481C13.5649 13.3884 13.5724 9.66244 13.5936 9.56811C13.6147 9.47379 13.7059 9.31145 13.7962 9.20727L13.9604 9.01793H20.1609C26.2295 9.01793 26.3648 9.0215 26.5175 9.18562ZM19.6654 11.3903C19.5868 11.4809 19.4214 11.949 19.2977 12.4304C19.1741 12.9118 18.9878 13.5806 18.8838 13.9166C18.7798 14.2528 18.6872 14.6252 18.6781 14.7445C18.6689 14.8637 18.6396 14.9613 18.6129 14.9613C18.5862 14.9613 18.5264 15.1236 18.4799 15.3222C18.4335 15.5207 18.316 15.9505 18.2188 16.2773C17.9375 17.2233 17.9313 17.513 18.1864 17.787C18.3046 17.914 18.4587 18.0185 18.5288 18.0193C18.599 18.0199 19.0737 17.8984 19.5839 17.7493C20.094 17.6001 20.5301 17.4981 20.5531 17.5227C20.576 17.5474 20.5019 17.793 20.3884 18.0687C20.2749 18.3443 20.1322 18.6939 20.0712 18.8457C20.0101 18.9975 19.9096 19.2458 19.8477 19.3976C19.7859 19.5494 19.6216 19.9601 19.4829 20.3103C19.344 20.6606 19.1677 21.1 19.091 21.2868C18.5602 22.5793 18.4588 22.8769 18.4588 23.1416C18.4588 23.6257 18.8382 23.8905 19.2758 23.7117C19.5008 23.6199 19.5589 23.5069 20.2395 21.8386C20.7306 20.6344 20.7964 20.472 21.1842 19.5037C21.5225 18.6594 21.6325 18.3891 21.9789 17.5509C22.4101 16.5073 22.4397 16.1692 22.1229 15.9015C21.8527 15.6731 21.7781 15.6772 20.6118 15.9855C20.0706 16.1286 19.6107 16.2272 19.5897 16.2047C19.5688 16.1822 19.6413 15.8454 19.7509 15.4564C20.3203 13.4352 20.7505 11.8258 20.7505 11.717C20.7505 11.2987 19.953 11.0586 19.6654 11.3903ZM39.4552 12.9704C40.0692 13.2912 40.8223 14.0146 41.1851 14.632C41.301 14.8291 41.4892 15.2608 41.6035 15.5915L41.8113 16.1924V23.4094V30.6263L41.6322 31.2235C41.1942 32.6839 40.1572 33.7678 38.7292 34.2574L38.176 34.4471H25.1366C14.5724 34.4471 12.0221 34.4258 11.7019 34.3347C11.327 34.2281 10.3244 33.7576 10.2399 33.6487C10.2182 33.6207 10.0582 33.467 9.88432 33.3073C9.43964 32.8988 8.95378 32.206 8.73867 31.6737C8.35294 30.7193 8.34906 30.6384 8.34606 23.4783C8.34298 16.0574 8.33769 16.1478 8.84172 15.0471C9.16083 14.3501 10.0302 13.3907 10.6547 13.0466C10.9045 12.9089 11.1089 12.7653 11.1091 12.7275C11.1092 12.6897 11.1418 12.6805 11.1816 12.7069C11.2215 12.7334 11.3548 12.7125 11.478 12.6606C11.6012 12.6087 11.8347 12.5582 11.997 12.5484L12.292 12.5305L12.3131 19.8136C12.333 26.6749 12.3423 27.1055 12.4753 27.2484C12.6088 27.3918 13.0242 27.3999 20.1676 27.3999H27.7189L27.8699 27.1995C28.0161 27.0056 28.021 26.7609 28.021 19.7497V12.5003L32.98 12.4785C38.4453 12.4544 38.4709 12.4563 39.4552 12.9704ZM31.1821 16.2951C30.9052 16.4045 30.787 16.6049 30.787 16.9649C30.787 17.6188 30.6171 17.5934 34.9982 17.5934C37.3181 17.5934 38.9148 17.5608 39.0002 17.5117C39.4247 17.2676 39.3645 16.4965 38.9075 16.3253C38.6573 16.2316 31.4145 16.2033 31.1821 16.2951ZM4.18987 16.9331C4.29861 17.0997 4.31291 17.8623 4.31291 23.4763C4.31291 27.6943 4.28541 29.8861 4.23112 29.9952C4.15842 30.1411 4.05924 30.1594 3.33812 30.1594C2.81251 30.1594 2.49347 30.1234 2.43207 30.0575C2.2948 29.91 2.2948 16.9937 2.43207 16.8462C2.49284 16.7809 2.80342 16.7443 3.29686 16.7443C4.00297 16.7443 4.0771 16.7599 4.18987 16.9331ZM43.8344 17.9447C44.237 18.0896 44.5993 18.4125 44.7755 18.7836C44.9264 19.1015 44.9328 19.2891 44.9328 23.4102C44.9328 27.1945 44.9177 27.7379 44.8053 27.9773C44.5101 28.606 44.0021 28.9707 43.4217 28.9707H43.1152V23.466C43.1152 20.4384 43.1389 17.9358 43.1679 17.9047C43.2473 17.8193 43.5337 17.8365 43.8344 17.9447ZM30.9178 19.6166C30.7257 19.8446 30.746 20.4139 30.9533 20.6156C31.1122 20.77 31.2956 20.7773 35.0301 20.7773H38.9404L39.1312 20.5391C39.3651 20.2469 39.3735 19.9792 39.1581 19.685L38.9943 19.4613H35.0214C31.2729 19.4613 31.0412 19.47 30.9178 19.6166ZM7.07886 23.4943V27.1877H6.28859H5.49832V23.4943V19.8009H6.28859H7.07886V23.4943ZM17.5104 35.9321C17.5104 35.9783 17.2441 36.457 16.9186 36.9956L16.3268 37.975L15.0812 37.9515L13.8357 37.9282L13.8135 36.8881L13.7913 35.848H15.6509C16.826 35.848 17.5104 35.879 17.5104 35.9321ZM36.3979 36.9115V37.9749L35.1206 37.9515L33.8432 37.9282L33.2635 36.9241C32.9445 36.3719 32.6836 35.9038 32.6836 35.884C32.6836 35.8642 33.5193 35.848 34.5408 35.848H36.3979V36.9115Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.927 7.67226C13.3179 7.7975 12.7967 8.21472 12.5113 8.80567C12.3828 9.07142 12.3372 9.3668 12.3011 10.1642L12.2551 11.183L11.9785 11.2092C11.0643 11.2956 9.7793 11.953 8.95441 12.7564C7.68982 13.9878 7.08337 15.5187 7.08021 17.4872L7.07886 18.3575H6.28859H5.49832L5.49642 17.6995C5.49303 16.5176 5.26843 15.9805 4.61835 15.6001C4.28202 15.4034 4.17201 15.386 3.27489 15.3877C1.94763 15.3902 1.53116 15.6006 1.17538 16.4483C1.04341 16.7627 1.03155 17.2423 1.00911 23.1971C0.982319 30.2787 0.986033 30.3452 1.43696 30.9112C1.82601 31.3996 2.13145 31.498 3.30129 31.5122C4.4697 31.5263 4.70331 31.452 5.11504 30.9352C5.47082 30.4886 5.57735 30.0973 5.57735 29.2368V28.5462H6.3575H7.13766L7.1778 29.7136C7.24276 31.6036 7.67654 32.7518 8.77676 33.9457C9.74279 34.994 11.1538 35.7577 12.1366 35.764C12.2887 35.7649 12.4554 35.7945 12.5069 35.8298C12.5722 35.8743 12.6082 36.3773 12.6255 37.4891C12.6582 39.5915 12.435 39.4097 14.9864 39.4122C16.8038 39.414 16.9372 39.4035 17.0806 39.2492C17.1649 39.1586 17.6606 38.3576 18.1822 37.469L19.1305 35.8536L25.0686 35.8508L31.0067 35.848L32.0445 37.5803C32.6154 38.533 33.1378 39.3353 33.2055 39.3633C33.2733 39.3912 34.1882 39.4129 35.2387 39.4113C36.8164 39.4091 37.1762 39.3864 37.3067 39.2805C37.4535 39.1614 37.4665 39.036 37.4895 37.5231C37.5068 36.384 37.5425 35.8746 37.6081 35.8298C37.6597 35.7945 37.8619 35.7647 38.0575 35.7635C38.6727 35.7596 39.5701 35.4079 40.3752 34.855C41.7114 33.9373 42.5582 32.5371 42.9128 30.6593C42.9514 30.455 42.9937 30.4339 43.4498 30.3923C43.7221 30.3675 44.1154 30.2674 44.3236 30.1699C44.8766 29.911 45.5022 29.2364 45.7726 28.6075L45.9997 28.0792V23.282C45.9997 17.8848 46.0334 18.206 45.3872 17.4527C44.9164 16.904 44.1529 16.5347 43.3548 16.4696C43.1042 16.4491 43.075 16.418 43.0138 16.1075C42.6233 14.1253 41.537 12.5575 39.9853 11.7369C38.7355 11.0758 38.5265 11.0557 32.9093 11.0557H28.0377L28.0029 10.058C27.9648 8.96563 27.8899 8.72348 27.446 8.2559C27.1494 7.94362 26.8567 7.784 26.3615 7.66454C25.9078 7.55501 14.4624 7.56214 13.927 7.67226ZM26.5175 9.18562C26.6034 9.27782 26.6931 9.44016 26.717 9.54646C26.741 9.65268 26.7508 13.3884 26.7388 17.8481L26.7171 25.9565H20.1578H13.5986L13.5769 17.8481C13.5649 13.3884 13.5724 9.66244 13.5936 9.56811C13.6147 9.47379 13.7059 9.31145 13.7962 9.20727L13.9604 9.01793H20.1609C26.2295 9.01793 26.3648 9.0215 26.5175 9.18562ZM19.6654 11.3903C19.5868 11.4809 19.4214 11.949 19.2977 12.4304C19.1741 12.9118 18.9878 13.5806 18.8838 13.9166C18.7798 14.2528 18.6872 14.6252 18.6781 14.7445C18.6689 14.8637 18.6396 14.9613 18.6129 14.9613C18.5862 14.9613 18.5264 15.1236 18.4799 15.3222C18.4335 15.5207 18.316 15.9505 18.2188 16.2773C17.9375 17.2233 17.9313 17.513 18.1864 17.787C18.3046 17.914 18.4587 18.0185 18.5288 18.0193C18.599 18.0199 19.0737 17.8984 19.5839 17.7493C20.094 17.6001 20.5301 17.4981 20.5531 17.5227C20.576 17.5474 20.5019 17.793 20.3884 18.0687C20.2749 18.3443 20.1322 18.6939 20.0712 18.8457C20.0101 18.9975 19.9096 19.2458 19.8477 19.3976C19.7859 19.5494 19.6216 19.9601 19.4829 20.3103C19.344 20.6606 19.1677 21.1 19.091 21.2868C18.5602 22.5793 18.4588 22.8769 18.4588 23.1416C18.4588 23.6257 18.8382 23.8905 19.2758 23.7117C19.5008 23.6199 19.5589 23.5069 20.2395 21.8386C20.7306 20.6344 20.7964 20.472 21.1842 19.5037C21.5225 18.6594 21.6325 18.3891 21.9789 17.5509C22.4101 16.5073 22.4397 16.1692 22.1229 15.9015C21.8527 15.6731 21.7781 15.6772 20.6118 15.9855C20.0706 16.1286 19.6107 16.2272 19.5897 16.2047C19.5688 16.1822 19.6413 15.8454 19.7509 15.4564C20.3203 13.4352 20.7505 11.8258 20.7505 11.717C20.7505 11.2987 19.953 11.0586 19.6654 11.3903ZM39.4552 12.9704C40.0692 13.2912 40.8223 14.0146 41.1851 14.632C41.301 14.8291 41.4892 15.2608 41.6035 15.5915L41.8113 16.1924V23.4094V30.6263L41.6322 31.2235C41.1942 32.6839 40.1572 33.7678 38.7292 34.2574L38.176 34.4471H25.1366C14.5724 34.4471 12.0221 34.4258 11.7019 34.3347C11.327 34.2281 10.3244 33.7576 10.2399 33.6487C10.2182 33.6207 10.0582 33.467 9.88432 33.3073C9.43964 32.8988 8.95378 32.206 8.73867 31.6737C8.35294 30.7193 8.34906 30.6384 8.34606 23.4783C8.34298 16.0574 8.33769 16.1478 8.84172 15.0471C9.16083 14.3501 10.0302 13.3907 10.6547 13.0466C10.9045 12.9089 11.1089 12.7653 11.1091 12.7275C11.1092 12.6897 11.1418 12.6805 11.1816 12.7069C11.2215 12.7334 11.3548 12.7125 11.478 12.6606C11.6012 12.6087 11.8347 12.5582 11.997 12.5484L12.292 12.5305L12.3131 19.8136C12.333 26.6749 12.3423 27.1055 12.4753 27.2484C12.6088 27.3918 13.0242 27.3999 20.1676 27.3999H27.7189L27.8699 27.1995C28.0161 27.0056 28.021 26.7609 28.021 19.7497V12.5003L32.98 12.4785C38.4453 12.4544 38.4709 12.4563 39.4552 12.9704ZM31.1821 16.2951C30.9052 16.4045 30.787 16.6049 30.787 16.9649C30.787 17.6188 30.6171 17.5934 34.9982 17.5934C37.3181 17.5934 38.9148 17.5608 39.0002 17.5117C39.4247 17.2676 39.3645 16.4965 38.9075 16.3253C38.6573 16.2316 31.4145 16.2033 31.1821 16.2951ZM4.18987 16.9331C4.29861 17.0997 4.31291 17.8623 4.31291 23.4763C4.31291 27.6943 4.28541 29.8861 4.23112 29.9952C4.15842 30.1411 4.05924 30.1594 3.33812 30.1594C2.81251 30.1594 2.49347 30.1234 2.43207 30.0575C2.2948 29.91 2.2948 16.9937 2.43207 16.8462C2.49284 16.7809 2.80342 16.7443 3.29686 16.7443C4.00297 16.7443 4.0771 16.7599 4.18987 16.9331ZM43.8344 17.9447C44.237 18.0896 44.5993 18.4125 44.7755 18.7836C44.9264 19.1015 44.9328 19.2891 44.9328 23.4102C44.9328 27.1945 44.9177 27.7379 44.8053 27.9773C44.5101 28.606 44.0021 28.9707 43.4217 28.9707H43.1152V23.466C43.1152 20.4384 43.1389 17.9358 43.1679 17.9047C43.2473 17.8193 43.5337 17.8365 43.8344 17.9447ZM30.9178 19.6166C30.7257 19.8446 30.746 20.4139 30.9533 20.6156C31.1122 20.77 31.2956 20.7773 35.0301 20.7773H38.9404L39.1312 20.5391C39.3651 20.2469 39.3735 19.9792 39.1581 19.685L38.9943 19.4613H35.0214C31.2729 19.4613 31.0412 19.47 30.9178 19.6166ZM7.07886 23.4943V27.1877H6.28859H5.49832V23.4943V19.8009H6.28859H7.07886V23.4943ZM17.5104 35.9321C17.5104 35.9783 17.2441 36.457 16.9186 36.9956L16.3268 37.975L15.0812 37.9515L13.8357 37.9282L13.8135 36.8881L13.7913 35.848H15.6509C16.826 35.848 17.5104 35.879 17.5104 35.9321ZM36.3979 36.9115V37.9749L35.1206 37.9515L33.8432 37.9282L33.2635 36.9241C32.9445 36.3719 32.6836 35.9038 32.6836 35.884C32.6836 35.8642 33.5193 35.848 34.5408 35.848H36.3979V36.9115Z"
        stroke={color}
        strokeWidth="0.4"
        mask="url(#path-1-outside-1_1450_2573)"
      />
    </svg>
  );
};

export const IconStreamLineTarget = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9311 23.0802C23.6811 22.4067 24.8182 22.4067 25.5681 23.0802L36.2144 32.6416C37.5607 33.8507 36.7054 36.0831 34.8959 36.0831H13.6034C11.7938 36.0831 10.9386 33.8507 12.2848 32.6416L22.9311 23.0802Z"
        stroke={color}
        strokeWidth="1.33331"
      />
      <path
        d="M25.3444 4.99922C25.3444 4.46384 24.9104 4.02983 24.375 4.02983C23.8396 4.02983 23.4056 4.46384 23.4056 4.99922L25.3444 4.99922ZM25.3444 21.4999C25.3444 20.9646 24.9104 20.5305 24.375 20.5305C23.8396 20.5305 23.4056 20.9646 23.4056 21.4999L25.3444 21.4999ZM23.4056 18.4998C23.4056 19.0352 23.8396 19.4692 24.375 19.4692C24.9104 19.4692 25.3444 19.0352 25.3444 18.4998L23.4056 18.4998ZM25.3444 15.4997C25.3444 14.9643 24.9104 14.5303 24.375 14.5303C23.8396 14.5303 23.4056 14.9643 23.4056 15.4997L25.3444 15.4997ZM23.4056 12.4995C23.4056 13.0349 23.8396 13.4689 24.375 13.4689C24.9104 13.4689 25.3444 13.0349 25.3444 12.4995L23.4056 12.4995ZM25.3444 9.49941C25.3444 8.96403 24.9104 8.53002 24.375 8.53002C23.8396 8.53002 23.4056 8.96403 23.4056 9.49941L25.3444 9.49941ZM23.4056 6.49928C23.4056 7.03467 23.8396 7.46868 24.375 7.46868C24.9104 7.46868 25.3444 7.03467 25.3444 6.49928L23.4056 6.49928ZM25.3444 23L25.3444 21.4999L23.4056 21.4999L23.4056 23L25.3444 23ZM25.3444 18.4998L25.3444 15.4997L23.4056 15.4997L23.4056 18.4998L25.3444 18.4998ZM25.3444 12.4995L25.3444 9.49941L23.4056 9.49941L23.4056 12.4995L25.3444 12.4995ZM25.3444 6.49928L25.3444 4.99922L23.4056 4.99922L23.4056 6.49928L25.3444 6.49928Z"
        fill={color}
      />
      <path
        d="M18.2379 14.4121L14.1014 18.5487M18.2379 14.4121L14.1014 10.2755M18.2379 14.4121H8.58594"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0003 14.4121L35.1369 18.5487M31.0003 14.4121L35.1369 10.2755M31.0003 14.4121H40.6523"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconStreamLineLocation = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2107_7548)">
        <path
          d="M21.9518 5.19579C23.1304 3.5156 25.6196 3.5156 26.7982 5.19579L45.4887 31.8401C46.8647 33.8017 45.4615 36.5 43.0655 36.5H5.6845C3.28845 36.5 1.88527 33.8017 3.26126 31.8401L21.9518 5.19579Z"
          stroke={color}
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_2107_7548">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconCenterPoint = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1399_2644)">
        <path
          d="M23.9989 39.4275C26.025 39.4275 28.0313 39.0284 29.9031 38.253C31.775 37.4777 33.4759 36.3412 34.9085 34.9085C36.3412 33.4759 37.4777 31.775 38.253 29.9031C39.0284 28.0313 39.4275 26.025 39.4275 23.9989C39.4275 21.9728 39.0284 19.9665 38.253 18.0946C37.4777 16.2227 36.3412 14.5219 34.9085 13.0892C33.4759 11.6566 31.775 10.5201 29.9031 9.74474C28.0313 8.96938 26.025 8.57031 23.9989 8.57031C19.907 8.57031 15.9827 10.1958 13.0892 13.0892C10.1958 15.9827 8.57031 19.907 8.57031 23.9989C8.57031 28.0908 10.1958 32.0151 13.0892 34.9085C15.9827 37.8019 19.907 39.4275 23.9989 39.4275Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.9986 8.57003V1.71289M23.9986 46.2843V39.4272M39.4272 23.9986H46.2843M1.71289 23.9986H8.57003M23.9986 25.7129C24.4533 25.7129 24.8893 25.5323 25.2108 25.2108C25.5323 24.8893 25.7129 24.4533 25.7129 23.9986C25.7129 23.5439 25.5323 23.1079 25.2108 22.7864C24.8893 22.4649 24.4533 22.2843 23.9986 22.2843C23.5439 22.2843 23.1079 22.4649 22.7864 22.7864C22.4649 23.1079 22.2843 23.5439 22.2843 23.9986C22.2843 24.4533 22.4649 24.8893 22.7864 25.2108C23.1079 25.5323 23.5439 25.7129 23.9986 25.7129Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1399_2644">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconThermalNozzle = ({
  className,
  width = "48",
  height = "48",
  color = "black",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2107_7579)">
        <path
          d="M23.9989 39.4275C26.025 39.4275 28.0313 39.0284 29.9031 38.253C31.775 37.4777 33.4759 36.3412 34.9085 34.9085C36.3412 33.4759 37.4777 31.775 38.253 29.9031C39.0284 28.0313 39.4275 26.025 39.4275 23.9989C39.4275 21.9728 39.0284 19.9665 38.253 18.0946C37.4777 16.2227 36.3412 14.5219 34.9085 13.0892C33.4759 11.6566 31.775 10.5201 29.9031 9.74474C28.0313 8.96938 26.025 8.57031 23.9989 8.57031C19.907 8.57031 15.9827 10.1958 13.0892 13.0892C10.1958 15.9827 8.57031 19.907 8.57031 23.9989C8.57031 28.0908 10.1958 32.0151 13.0892 34.9085C15.9827 37.8019 19.907 39.4275 23.9989 39.4275Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.9986 8.57003V1.71289M23.9986 46.2843V39.4272M39.4272 23.9986H46.2843M1.71289 23.9986H8.57003"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.0013 32.3333C22.8485 32.3333 21.866 31.9269 21.0538 31.1142C20.2416 30.3014 19.8352 29.3189 19.8346 28.1667C19.8341 27.0144 20.2405 26.0319 21.0538 25.2192C21.8671 24.4064 22.8496 24 24.0013 24C25.153 24 26.1357 24.4064 26.9496 25.2192C27.7635 26.0319 28.1696 27.0144 28.168 28.1667C28.1663 29.3189 27.7599 30.3017 26.9488 31.115C26.1377 31.9283 25.1552 32.3344 24.0013 32.3333ZM24.0013 30.6667C24.6957 30.6667 25.286 30.4236 25.7721 29.9375C26.2582 29.4514 26.5013 28.8611 26.5013 28.1667C26.5013 27.4722 26.2582 26.8819 25.7721 26.3958C25.286 25.9097 24.6957 25.6667 24.0013 25.6667C23.3069 25.6667 22.7166 25.9097 22.2305 26.3958C21.7444 26.8819 21.5013 27.4722 21.5013 28.1667C21.5013 28.8611 21.7444 29.4514 22.2305 29.9375C22.7166 30.4236 23.3069 30.6667 24.0013 30.6667ZM19.8346 24.125L15.668 19.9583C16.7791 18.8472 18.0535 17.9931 19.4913 17.3958C20.9291 16.7986 22.4324 16.5 24.0013 16.5C25.5702 16.5 27.0738 16.7986 28.5121 17.3958C29.9505 17.9931 31.2246 18.8472 32.3346 19.9583L28.168 24.125C27.5985 23.5556 26.9596 23.1144 26.2513 22.8017C25.543 22.4889 24.793 22.3328 24.0013 22.3333C23.2096 22.3339 22.4596 22.4903 21.7513 22.8025C21.043 23.1147 20.4041 23.5556 19.8346 24.125ZM19.9596 21.9167C20.543 21.5 21.1785 21.1875 21.8663 20.9792C22.5541 20.7708 23.2657 20.6667 24.0013 20.6667C24.7369 20.6667 25.4419 20.7675 26.1163 20.9692C26.7907 21.1708 27.433 21.4728 28.043 21.875L29.8763 20.0417C29.0152 19.4306 28.088 18.9653 27.0946 18.6458C26.1013 18.3264 25.0702 18.1667 24.0013 18.1667C22.9324 18.1667 21.901 18.3264 20.9071 18.6458C19.9132 18.9653 18.9863 19.4306 18.1263 20.0417L19.9596 21.9167Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2107_7579">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// End

export const IconHistory = ({
  className,
  width = "24",
  height = "25",
  color = "#008ECC",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12.5C3 14.28 3.52784 16.0201 4.51677 17.5001C5.50571 18.9802 6.91131 20.1337 8.55585 20.8149C10.2004 21.4961 12.01 21.6743 13.7558 21.3271C15.5016 20.9798 17.1053 20.1226 18.364 18.864C19.6226 17.6053 20.4798 16.0016 20.8271 14.2558C21.1743 12.51 20.9961 10.7004 20.3149 9.05585C19.6337 7.41131 18.4802 6.00571 17.0001 5.01677C15.5201 4.02784 13.78 3.5 12 3.5C9.48395 3.50947 7.06897 4.49122 5.26 6.24L3 8.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 3.5V8.5H8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7.5V12.5L16 14.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconRefresh = ({
  className,
  width = "24",
  height = "24",
  color = "#008ECC",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.48395 3.00947 7.06897 3.99122 5.26 5.74L3 8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 3V8H8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21C14.516 20.9905 16.931 20.0088 18.74 18.26L21 16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 16H21V21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconInfoSelect = ({ className, width, height, color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#008ECC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16V12"
        stroke="#008ECC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8H12.01"
        stroke="#008ECC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconArrowDown = ({
  className,
  width = "24",
  height = "24",
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9L12 15L18 9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconArrowLeft = ({
  className,
  width = "24",
  height = "24",
  color = "#C5C5C5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 6L9 12L15 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconAutoPurge = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 3V10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 5H20.51M27.5 5H27.51M21.5 9H21.51M26.5 9H26.51"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 16V13H25V16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 16H31V20H17V16Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 16V20M24 16V20M27 16V20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 20H37C38.1046 20 39 20.8954 39 22V23C39 24.1046 38.1046 25 37 25H11C9.89543 25 9 24.1046 9 23V22C9 20.8954 9.89543 20 11 20Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 25V36C12 37.6569 17.3726 39 24 39C30.6274 39 36 37.6569 36 36V25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 28H27V34L24 36L21 34V28Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 42H42C43.1046 42 44 42.8954 44 44V45H4V44C4 42.8954 4.89543 42 6 42Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 39V42M30 39V42"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconDropJetFluxer = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 3V5.5M24 9.5V12M24 16V18.5M24 22.5V23.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 32C42 35.3137 33.9411 38 24 38C14.0589 38 6 35.3137 6 32C6 28.6863 14.0589 26 24 26C33.9411 26 42 28.6863 42 32Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 32V38C6 41.3137 14.0589 44 24 44C33.9411 44 42 41.3137 42 38V32"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 29.5H15.01M33 29.5H33.01M14 34.5H14.01M34 34.5H34.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 32H25.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconAdditionalFluxHead = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4H14C14.5523 4 15 4.44772 15 5V10C15 10.5523 14.5523 11 14 11H8C7.44772 11 7 10.5523 7 10V5C7 4.44772 7.44772 4 8 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 4H40C40.5523 4 41 4.44772 41 5V10C41 10.5523 40.5523 11 40 11H34C33.4477 11 33 10.5523 33 10V5C33 4.44772 33.4477 4 34 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 8H13M35 8H39"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11V16M37 11V16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 16H14C15.1046 16 16 16.8954 16 18V26C16 27.1046 15.1046 28 14 28H8C6.89543 28 6 27.1046 6 26V18C6 16.8954 6.89543 16 8 16Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 16H40C41.1046 16 42 16.8954 42 18V26C42 27.1046 41.1046 28 40 28H34C32.8954 28 32 27.1046 32 26V18C32 16.8954 32.8954 16 34 16Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 28V31H12.5V28M35.5 28V31H38.5V28"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 22H28M22.5 19.5L20 22L22.5 24.5M25.5 19.5L28 22L25.5 24.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 35H11.01M11 39H11.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 34V36M37 38V40"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 43H44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconOpticalFluxPresenceSensor = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4H36C37.1046 4 38 4.89543 38 6V9C38 10.1046 37.1046 11 36 11H12C10.8954 11 10 10.1046 10 9V6C10 4.89543 10.8954 4 12 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7.5H15.01M20 7.5H20.01M25 7.5H25.01M30 7.5H30.01M34 7.5H34.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 18H6C4.89543 18 4 18.8954 4 20V24C4 25.1046 4.89543 26 6 26H9C11.2091 26 13 24.2091 13 22C13 19.7909 11.2091 18 9 18Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 17H42C43.1046 17 44 17.8954 44 19V25C44 26.1046 43.1046 27 42 27H38C36.8954 27 36 26.1046 36 25V19C36 17.8954 36.8954 17 38 17Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.5 22C41.5 22.8284 40.8284 23.5 40 23.5C39.1716 23.5 38.5 22.8284 38.5 22C38.5 21.1716 39.1716 20.5 40 20.5C40.8284 20.5 41.5 21.1716 41.5 22Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 22H20M28 22H32M29.5 19.5L32 22L29.5 24.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 29H24.01M24 25.5H24.01M24 22H24.01M22 18.5H22.01M26 18.5H26.01M20.5 14.5H20.51M24 14.5H24.01M27.5 14.5H27.51"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 36H28C29.1046 36 30 36.8954 30 38V42C30 43.1046 29.1046 44 28 44H20C18.8954 44 18 43.1046 18 42V38C18 36.8954 18.8954 36 20 36Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 36V32H25.5V36"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconBarcode = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 13V8C4 5.79086 5.79086 4 8 4H13M35 4H40C42.2091 4 44 5.79086 44 8V13M44 35V40C44 42.2091 42.2091 44 40 44H35M13 44H8C5.79086 44 4 42.2091 4 40V35"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14V34M16 14V34M26 14V34M36 14V34"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 14H22V34H20V14Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 14H32V34H30V14Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconFiducialDynamicCorrection = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24C8 15.1634 15.1634 8 24 8C32.8366 8 40 15.1634 40 24Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 4V18M24 30V44M4 24H18M30 24H44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 24H24.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconPcbWarpageCorrection = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 4H25C26.1046 4 27 4.89543 27 6V10C27 11.1046 26.1046 12 25 12H15C13.8954 12 13 11.1046 13 10V6C13 4.89543 13.8954 4 15 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 12V14H22V12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 17V19M20 22V24M20 27V28"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 6V22M33.5 8.5L36 6L38.5 8.5M33.5 19.5L36 22L38.5 19.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 36C14 29 34 29 44 36V40C34 33 14 33 4 40V36Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconElectromagneticPumpFlow = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 29V17C10 9.26801 16.268 3 24 3C31.732 3 38 9.26801 38 17V29H30V17C30 13.6863 27.3137 11 24 11C20.6863 11 18 13.6863 18 17V29H10Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 23H18M30 23H38"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 34H44M4 44H44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 39H35M31 36L35 39L31 42"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconDualSolderBaths = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 24H20C21.1046 24 22 24.8954 22 26V40C22 41.1046 21.1046 42 20 42H6C4.89543 42 4 41.1046 4 40V26C4 24.8954 4.89543 24 6 24Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 24H42C43.1046 24 44 24.8954 44 26V40C44 41.1046 43.1046 42 42 42H28C26.8954 42 26 41.1046 26 40V26C26 24.8954 26.8954 24 28 24Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 30H18M30 30H40"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 24V19M35 24V19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 19C9 15 11 12 13 12C15 12 17 15 17 19H9Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 19C31 15 33 12 35 12C37 12 39 15 39 19H31Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconMes = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 44V30L13 35V30L22 35V30L31 35V22H44V44H4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 40H14M19 40H23M28 40H32M37 40H39"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 7C27 8.65685 25.6569 10 24 10C22.3431 10 21 8.65685 21 7C21 5.34315 22.3431 4 24 4C25.6569 4 27 5.34315 27 7Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43 12C43 13.6569 41.6569 15 40 15C38.3431 15 37 13.6569 37 12C37 10.3431 38.3431 9 40 9C41.6569 9 43 10.3431 43 12Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.8 11L21.2 8M26.8 8L37.2 11M40 15V22M24 10V31"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconAutomaticRework = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 15C23 19.4183 19.4183 23 15 23C10.5817 23 7 19.4183 7 15C7 10.5817 10.5817 7 15 7C19.4183 7 23 10.5817 23 15Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 21L26 26"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12.5L17.5 17.5M17.5 12.5L12.5 17.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 14C42 9.02944 37.9706 5 33 5C30.4 5 28.1 6.1 26.5 7.9M42 14L44.5 11.5M42 14L39.5 11.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 36H44V42H4V36Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 36C10 33.7909 11.7909 32 14 32C16.2091 32 18 33.7909 18 36M30 36C30 33.7909 31.7909 32 34 32C36.2091 32 38 33.7909 38 36"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconMachineTemperature = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4H40C42.2091 4 44 5.79086 44 8V40C44 42.2091 42.2091 44 40 44H8C5.79086 44 4 42.2091 4 40V8C4 5.79086 5.79086 4 8 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 29.5V14C20 12.3431 21.3431 11 23 11C24.6569 11 26 12.3431 26 14V29.5C27.8 30.6 29 32.6 29 35C29 38.3137 26.3137 41 23 41C19.6863 41 17 38.3137 17 35C17 32.6 18.2 30.6 20 29.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 35V20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 15H35M31 21H35M31 27H35"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconThermistorFluxSensing = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 4C24 4 17 11.5 17 16C17 19.866 20.134 23 24 23C27.866 23 31 19.866 31 16C31 11.5 24 4 24 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 30H33C33.5523 30 34 30.4477 34 31V37C34 37.5523 33.5523 38 33 38H15C14.4477 38 14 37.5523 14 37V31C14 30.4477 14.4477 30 15 30Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 34H14M34 34H44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 44H12L36 26"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconUltrasonicFluxer = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 34H29C30.1046 34 31 34.8954 31 36V42C31 43.1046 30.1046 44 29 44H19C17.8954 44 17 43.1046 17 42V36C17 34.8954 17.8954 34 19 34Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 34V30H25.5V34"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 35C10.5 37 10.5 41 12 43M36 35C37.5 37 37.5 41 36 43M7 32C4.5 35.5 4.5 42.5 7 46M41 32C43.5 35.5 43.5 42.5 41 46"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 25H22.01M26 25H26.01M19 19H19.01M24 19.5H24.01M29 19H29.01M16 13H16.01M21 13.5H21.01M27 13.5H27.01M32 13H32.01M13 7H13.01M19 7.5H19.01M24 7H24.01M29 7.5H29.01M35 7H35.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconApNozzle = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 40H35C36.1046 40 37 40.8954 37 42V44H11V42C11 40.8954 11.8954 40 13 40Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 40V22M28 40V22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 22H30"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 22C19 17 21.2386 14 24 14C26.7614 14 29 17 29 22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconJetTip = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 40H35C36.1046 40 37 40.8954 37 42V44H11V42C11 40.8954 11.8954 40 13 40Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 40V28L14 20H34L28 28V40"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 20C14 9 34 9 34 20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 20C19 15.5 29 15.5 29 20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconJetWave = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 40H35C36.1046 40 37 40.8954 37 42V44H11V42C11 40.8954 11.8954 40 13 40Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 40V22L30 18V40"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 18C34 9 40 7 44 12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 22C16 16 20 12 26 12C29 12 31 14 30 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconMicroNozzle = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 40H35C36.1046 40 37 40.8954 37 42V44H11V42C11 40.8954 11.8954 40 13 40Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 40V16M25.5 40V16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 16C22.5 14.3431 23.1716 13 24 13C24.8284 13 25.5 14.3431 25.5 16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 30C35 28 31 26 33 24C35 22 31 20 33 18M15 30C13 28 17 26 15 24C13 22 17 20 15 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconWideWave = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 40H40C41.1046 40 42 40.8954 42 42V44H6V42C6 40.8954 6.89543 40 8 40Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 40V24M38 40V24"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 24C10 19 38 19 38 24"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 24C8.5 24.5 7 26 7 28M38 24C39.5 24.5 41 26 41 28"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconCustomNozzle = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 40H42C43.1046 40 44 40.8954 44 42V44H4V42C4 40.8954 4.89543 40 6 40Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 40V26M13 40V26M19 40V26M23 40V26M29 40V26M33 40V26M39 40V26M43 40V26"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 26C9 23 13 23 13 26M19 26C19 23 23 23 23 26M29 26C29 23 33 23 33 26M39 26C39 23 43 23 43 26"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconThermalCalibration = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 40H35C36.1046 40 37 40.8954 37 42V44H11V42C11 40.8954 11.8954 40 13 40Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 40V22M28 40V22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 22H30"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 22C19 17 21.2386 14 24 14C26.7614 14 29 17 29 22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 6H34M14 3V9M34 3V9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 3.5L14 6L17 8.5M31 3.5L34 6L31 8.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconNozzleVerification = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 40H27C28.1046 40 29 40.8954 29 42V44H3V42C3 40.8954 3.89543 40 5 40Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 40V22M20 40V22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 22H22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 22C11 17 13.2386 14 16 14C18.7614 14 21 17 21 22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44 14C44 18.9706 39.9706 23 35 23C30.0294 23 26 18.9706 26 14C26 9.02944 30.0294 5 35 5C39.9706 5 44 9.02944 44 14Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 14L34 17L39 11"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconAutoNozzleTinning = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 40H35C36.1046 40 37 40.8954 37 42V44H11V42C11 40.8954 11.8954 40 13 40Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 40V22M28 40V22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 22H30"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 22C19 17 21.2386 14 24 14C26.7614 14 29 17 29 22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 3C24 3 21.5 6 21.5 7.75C21.5 9.12 22.62 10 24 10C25.38 10 26.5 9.12 26.5 7.75C26.5 6 24 3 24 3Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9L11.2 12.8L15 14L11.2 15.2L10 19L8.8 15.2L5 14L8.8 12.8L10 9ZM38 5L38.9 7.6L41.5 8.5L38.9 9.4L38 12L37.1 9.4L34.5 8.5L37.1 7.6L38 5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconAutoLevelDetect = ({
  className,
  width = "48",
  height = "48",
  color = "#E5E5E5",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 20V40C8 42.2091 9.79086 44 12 44H36C38.2091 44 40 42.2091 40 40V20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 30C12 28 16 32 20 30C24 28 28 32 32 30C34 29 36 29 40 30"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 4V26M29 26H35"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 4V16M13 13L16 16L19 13"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
